var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanderaDeEspana2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.666667,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 750,
    height: 500,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rect2",
    transform: "matrix(1.5,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 750,
    height: 500,
    style: {
      fill: "rgb(198,11,30)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect4",
    transform: "matrix(1.5,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 125,
    width: 750,
    height: 250,
    style: {
      fill: "rgb(255,196,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1527",
    transform: "matrix(0.315031,0,0,0.210021,232.088,154.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2604-5",
    transform: "matrix(1,0,0,1,4.99985,4.99999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path840-4",
    d: "M449.228,329.024C396.575,328.957 348.985,322.879 312.758,313.519C348.985,304.145 396.575,298.416 449.228,298.315C501.871,298.416 549.715,304.145 585.942,313.519C549.715,322.879 501.871,328.957 449.228,329.024",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831-9",
    d: "M330.649,214.274C330.649,208.866 335.271,204.493 340.962,204.493C346.629,204.493 351.27,208.866 351.27,214.274C351.27,219.663 346.648,224.036 340.962,224.036C335.271,224.036 330.649,219.663 330.649,214.274Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833-6",
    d: "M446.967,129.945C478.577,129.945 506.704,134.625 525.026,141.887C535.512,146.619 549.59,150.116 565,152.176C576.736,153.747 587.887,154.068 597.587,153.325C610.559,153.071 629.321,156.87 648.089,165.133C663.623,172.026 676.59,180.403 685.203,188.513L677.749,195.152L675.594,214.001L655.145,237.415L644.927,246.085L620.723,265.46L608.36,266.471L604.6,277.167L448.002,258.821L290.925,277.167L287.16,266.471L274.777,265.46L250.578,246.085L240.355,237.415L219.916,214.001L217.789,195.152L210.298,188.513C218.948,180.403 231.92,172.026 247.416,165.133C266.184,156.87 284.951,153.071 297.913,153.325C307.613,154.068 318.769,153.747 330.505,152.176C345.92,150.116 360.012,146.619 370.479,141.887C388.82,134.625 415.376,129.945 446.967,129.945Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2639-2-4-7",
    transform: "matrix(5.36858,0,0,5.59248,-566.098,-952.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2640-9-5-4",
    d: "M193.384,229.571L193.384,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2641-4-9-8",
    d: "M191.612,229.571L191.612,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2642-9-3-2",
    d: "M189.94,229.571L189.94,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2643-5-6-3",
    d: "M188.282,229.571L188.282,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2644-3-9-1",
    d: "M186.805,229.571L186.805,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2645-9-0-8",
    d: "M183.987,229.22L183.948,223.283M185.323,229.298L185.323,223.088",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2646-4-6-6",
    d: "M181.386,228.953L181.386,223.483M182.704,229.109L182.665,223.288",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2647-6-4-4",
    d: "M177.897,228.64L177.897,223.835M179.042,228.718L179.042,223.679M180.221,228.875L180.221,223.639",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2648-7-3-9",
    d: "M176.673,228.601L176.673,223.952",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2649-1-84-9",
    d: "M175.533,228.697L175.533,223.61",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2650-4-4-2",
    d: "M174.31,228.549L174.31,223.805",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2651-8-9-1",
    d: "M171.806,228.138L171.767,224.124M173.089,228.384L173.089,223.95",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2652-4-7-3",
    d: "M170.522,228.045L170.522,224.421",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2653-0-1-7",
    d: "M169.347,228.086L169.347,224.604",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2654-7-73-4",
    d: "M168.064,227.414L168.064,224.799",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2655-2-7-8",
    d: "M166.745,227.438L166.745,225.051",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2656-9-1-0",
    d: "M165.349,227.126L165.349,225.352",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2657-0-9-9",
    d: "M200.432,229.22L200.432,223.244M197.431,229.415L197.47,223.088M195.244,229.493L195.244,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path838-7",
    d: "M449.371,288.734C391.028,288.821 338.763,295.729 301.467,306.947C298.827,307.742 297.421,310.022 297.469,312.537C297.311,315.124 298.736,317.624 301.467,318.453C338.763,329.686 391.028,336.593 449.371,336.68C507.705,336.593 559.932,329.686 597.232,318.453C599.944,317.624 601.352,315.124 601.209,312.537C601.257,310.022 599.872,307.742 597.232,306.947C559.932,295.729 507.705,288.821 449.371,288.734ZM449.229,298.314C501.872,298.415 549.714,304.145 585.941,313.52C549.714,322.879 501.872,328.956 449.229,329.023C396.576,328.956 348.985,322.879 312.758,313.52C348.985,304.145 396.576,298.415 449.229,298.314Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path834-6",
    d: "M448.964,288.687C389.922,288.802 336.929,296.203 299.628,307.689C302.727,306.219 302.45,302.401 298.594,292.471C293.938,280.458 286.681,280.985 286.681,280.985C327.919,268.804 385.323,261.183 449.213,261.101C513.128,261.183 570.992,268.804 612.235,280.985C612.235,280.985 604.973,280.458 600.317,292.471C596.466,302.401 596.179,306.219 599.283,307.689C561.987,296.203 508.002,288.802 448.964,288.687",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path836-6",
    d: "M449.213,261.116C385.323,261.216 327.919,268.818 286.681,281.018C283.931,281.842 281.023,280.765 280.132,278.164C279.242,275.558 280.722,272.569 283.471,271.726C324.886,259.023 383.771,251.047 449.228,250.913C514.699,251.033 573.809,259.023 615.229,271.726C617.978,272.569 619.459,275.558 618.568,278.164C617.672,280.765 614.764,281.842 612.019,281.018C570.777,268.818 513.128,261.216 449.213,261.116",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path860-4",
    d: "M403.64,275.63C403.64,272.909 405.973,270.696 408.847,270.696C411.741,270.696 414.078,272.909 414.078,275.63C414.078,278.346 411.741,280.578 408.847,280.578C405.973,280.578 403.64,278.346 403.64,275.63",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path862-7",
    d: "M449.343,279.514L433.708,279.514C430.824,279.514 428.434,277.316 428.434,274.581C428.434,271.86 430.772,269.633 433.646,269.633L465.246,269.633C468.12,269.633 470.462,271.86 470.462,274.581C470.462,277.316 468.072,279.514 465.174,279.514L449.343,279.514",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path864-0",
    d: "M370.804,283.821L359.557,285.124C356.688,285.459 354.029,283.533 353.67,280.846C353.32,278.13 355.356,275.663 358.225,275.342L369.535,274.025L381.041,272.703C383.891,272.368 386.497,274.26 386.856,276.98C387.191,279.682 385.108,282.163 382.253,282.484L370.804,283.821",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path866-8",
    d: "M325.102,284.803C325.102,282.082 327.44,279.869 330.309,279.869C333.202,279.869 335.535,282.082 335.535,284.803C335.535,287.538 333.202,289.751 330.309,289.751C327.44,289.751 325.102,287.538 325.102,284.803",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path868-8",
    d: "M291.38,292.291L296.136,286.201L312.154,288.227L299.346,297.573L292.251,294.843L290.22,293.92L291.38,292.291Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path870-3",
    d: "M527.896,283.821L539.133,285.124C541.983,285.459 544.666,283.533 545.02,280.846C545.341,278.13 543.325,275.663 540.47,275.342L529.165,274.025L517.659,272.703C514.785,272.368 512.184,274.26 511.844,276.98C511.485,279.682 513.592,282.163 516.443,282.484L527.896,283.821",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path872-4",
    d: "M484.622,275.63C484.622,272.909 486.96,270.696 489.834,270.696C492.722,270.696 495.06,272.909 495.06,275.63C495.06,278.346 492.722,280.578 489.834,280.578C486.96,280.578 484.622,278.346 484.622,275.63",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path874-4",
    d: "M563.16,284.803C563.16,282.082 565.498,279.869 568.372,279.869C571.26,279.869 573.598,282.082 573.598,284.803C573.598,287.538 571.26,289.751 568.372,289.751C565.498,289.751 563.16,287.538 563.16,284.803",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path876-3",
    d: "M608.36,293.789L602.564,286.201L586.546,288.227L599.354,297.573L607.977,294.799L608.88,294.505L608.36,293.789Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path879-8",
    d: "M331.31,171.317L337.911,176.605L347.807,160.438C337.068,153.867 329.705,142.447 329.705,129.437C329.705,127.967 329.791,126.534 329.973,125.112C331.008,104.486 356.137,87.443 388.049,87.443C404.603,87.443 419.553,91.969 430.077,99.236C430.36,96.041 430.647,93.306 431.093,90.398C419.5,83.64 404.46,79.573 388.049,79.573C351.361,79.573 322.659,100.414 321.265,125.097C321.121,126.534 321.05,127.986 321.05,129.437C321.05,142.6 327.066,154.456 336.569,162.699L331.31,171.317",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path880-5",
    d: "M331.31,171.317L337.911,176.605L347.807,160.438C337.068,153.867 329.705,142.447 329.705,129.437C329.705,127.967 329.791,126.534 329.973,125.112C331.008,104.486 356.137,87.443 388.049,87.443C404.603,87.443 419.553,91.969 430.077,99.236C430.36,96.041 430.647,93.306 431.093,90.398C419.5,83.64 404.46,79.573 388.049,79.573C351.361,79.573 322.659,100.414 321.265,125.097C321.121,126.534 321.05,127.986 321.05,129.437C321.05,142.6 327.066,154.456 336.569,162.699L331.31,171.317",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path881-1",
    d: "M331.736,171.499C319.215,162.158 311.441,149.455 311.441,135.468C311.441,119.354 321.979,104.979 337.997,95.452C328.115,103.389 322.123,113.644 321.265,125.097C321.121,126.534 321.05,127.986 321.05,129.437C321.05,142.6 327.066,154.456 336.569,162.699L331.736,171.499",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path882-2",
    d: "M331.736,171.499C319.215,162.158 311.441,149.455 311.441,135.468C311.441,119.354 321.979,104.979 337.997,95.452C328.115,103.389 322.123,113.644 321.265,125.097C321.121,126.534 321.05,127.986 321.05,129.437C321.05,142.6 327.066,154.456 336.569,162.699L331.736,171.499",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path883-0",
    d: "M221.272,187.818C214.259,179.963 209.962,169.813 209.962,158.714C209.962,152.022 211.509,145.623 214.312,139.913C224.443,119.067 256.23,103.897 294.009,103.897C304.303,103.897 314.152,105.013 323.248,107.087C321.232,109.286 319.646,111.7 318.104,114.133C310.545,112.663 302.45,111.867 294.009,111.867C259.425,111.867 230.493,125.318 222.11,143.491C219.878,148.123 218.628,153.292 218.628,158.714C218.628,169.76 223.801,179.661 231.901,186.42L219.38,206.873L212.673,201.537L221.272,187.838",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path884-5",
    d: "M221.272,187.818C214.259,179.963 209.962,169.813 209.962,158.714C209.962,152.022 211.509,145.623 214.312,139.913C224.443,119.067 256.23,103.897 294.009,103.897C304.303,103.897 314.152,105.013 323.248,107.087C321.232,109.286 319.646,111.7 318.104,114.133C310.545,112.663 302.45,111.867 294.009,111.867C259.425,111.867 230.493,125.318 222.11,143.491C219.878,148.123 218.628,153.292 218.628,158.714C218.628,169.76 223.801,179.661 231.901,186.42L219.38,206.873L212.673,201.537L221.272,187.838L221.272,187.818Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path885-4",
    d: "M234.095,119.287C224.998,125.011 218.11,132.057 214.312,139.913C211.509,145.623 209.962,152.022 209.962,158.714C209.962,169.813 214.259,179.963 221.272,187.818L213.67,200.153C206.394,190.807 202.164,179.896 202.164,168.289C202.164,148.305 214.882,130.841 234.095,119.287",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886-1",
    d: "M234.095,119.287C224.998,125.011 218.11,132.057 214.312,139.913C211.509,145.623 209.962,152.022 209.962,158.714C209.962,169.813 214.259,179.963 221.272,187.818L213.67,200.153C206.394,190.807 202.164,179.896 202.164,168.289C202.164,148.305 214.882,130.841 234.095,119.287Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path887-0",
    d: "M448.821,75.449C457.203,75.449 464.412,80.991 466.127,88.425C467.248,94.997 467.948,102.479 468.106,110.449C468.121,111.278 468.048,112.088 468.048,112.902C468.073,113.846 468.249,114.861 468.264,115.824C468.551,132.546 470.941,147.309 474.347,156.348L448.806,180.777L422.992,156.348C426.417,147.309 428.788,132.546 429.109,115.824C429.128,114.861 429.311,113.846 429.311,112.902C429.311,112.088 429.253,111.278 429.272,110.449C429.397,102.479 430.11,94.997 431.236,88.425C432.932,80.991 440.438,75.449 448.806,75.449",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path888-7",
    d: "M448.821,75.449C457.203,75.449 464.412,80.991 466.127,88.425C467.248,94.997 467.948,102.479 468.106,110.449C468.121,111.278 468.048,112.088 468.048,112.902C468.073,113.846 468.249,114.861 468.264,115.824C468.551,132.546 470.941,147.309 474.347,156.348L448.806,180.777L422.992,156.348C426.417,147.309 428.788,132.546 429.109,115.824C429.128,114.861 429.311,113.846 429.311,112.902C429.311,112.088 429.253,111.278 429.272,110.449C429.397,102.479 430.11,94.997 431.236,88.425C432.932,80.991 440.438,75.449 448.806,75.449L448.821,75.449Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889-2",
    d: "M448.821,83.405C453.175,83.405 456.844,86.178 457.74,90.025C458.794,96.242 459.469,103.341 459.613,110.837C459.613,111.618 459.573,112.394 459.573,113.151C459.573,114.08 459.736,115.01 459.755,115.958C460.023,131.751 462.289,145.671 465.532,154.235L448.694,170.181L431.838,154.235C435.052,145.69 437.318,131.751 437.601,115.958C437.62,115.01 437.783,114.08 437.797,113.151C437.797,112.394 437.744,111.618 437.744,110.837C437.888,103.341 438.563,96.242 439.632,90.025C440.508,86.178 444.484,83.405 448.819,83.405",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path890-2",
    d: "M448.821,83.405C453.175,83.405 456.844,86.178 457.74,90.025C458.794,96.242 459.469,103.341 459.613,110.837C459.613,111.618 459.573,112.394 459.573,113.151C459.573,114.08 459.736,115.01 459.755,115.958C460.023,131.751 462.289,145.671 465.532,154.235L448.694,170.181L431.838,154.235C435.052,145.69 437.318,131.751 437.601,115.958C437.62,115.01 437.783,114.08 437.797,113.151C437.797,112.394 437.744,111.618 437.744,110.837C437.888,103.341 438.563,96.242 439.632,90.025C440.508,86.178 444.484,83.405 448.819,83.405L448.821,83.405Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path891-4",
    d: "M566.14,171.317L559.539,176.605L549.643,160.438C560.377,153.867 567.745,142.447 567.745,129.437C567.745,127.967 567.659,126.534 567.481,125.112C566.461,104.486 541.294,87.443 509.415,87.443C492.827,87.443 477.892,91.969 467.358,99.236C467.071,96.041 466.822,93.306 466.338,90.398C477.935,83.64 492.971,79.573 509.415,79.573C546.093,79.573 574.791,100.414 576.199,125.097C576.324,126.534 576.396,127.986 576.396,129.437C576.396,142.6 570.389,154.456 560.88,162.699L566.14,171.317",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path892-5",
    d: "M566.14,171.317L559.539,176.605L549.643,160.438C560.377,153.867 567.745,142.447 567.745,129.437C567.745,127.967 567.659,126.534 567.481,125.112C566.461,104.486 541.294,87.443 509.415,87.443C492.827,87.443 477.892,91.969 467.358,99.236C467.071,96.041 466.822,93.306 466.338,90.398C477.935,83.64 492.971,79.573 509.415,79.573C546.093,79.573 574.791,100.414 576.199,125.097C576.324,126.534 576.396,127.986 576.396,129.437C576.396,142.6 570.389,154.456 560.88,162.699L566.14,171.317",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path893-8",
    d: "M565.714,171.499C578.235,162.158 586.014,149.455 586.014,135.468C586.014,119.354 575.466,104.979 559.472,95.452C569.335,103.389 575.322,113.644 576.199,125.097C576.324,126.534 576.396,127.986 576.396,129.437C576.396,142.6 570.389,154.456 560.88,162.699L565.714,171.499",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path894-4",
    d: "M565.714,171.499C578.235,162.158 586.014,149.455 586.014,135.468C586.014,119.354 575.466,104.979 559.472,95.452C569.335,103.389 575.322,113.644 576.199,125.097C576.324,126.534 576.396,127.986 576.396,129.437C576.396,142.6 570.389,154.456 560.88,162.699L565.714,171.499",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path895-5",
    d: "M676.197,187.818C683.191,179.963 687.483,169.813 687.483,158.714C687.483,152.022 685.936,145.623 683.157,139.913C673.007,119.067 641.22,103.897 603.436,103.897C593.142,103.897 583.298,105.013 574.202,107.087C576.237,109.286 577.809,111.7 579.361,114.133C586.886,112.663 595.019,111.867 603.416,111.867C638.011,111.867 666.957,125.318 675.321,143.491C677.567,148.123 678.803,153.292 678.803,158.714C678.803,169.76 673.63,179.661 665.53,186.42L678.051,206.873L684.776,201.537L676.183,187.838",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path896-9",
    d: "M676.197,187.818C683.191,179.963 687.483,169.813 687.483,158.714C687.483,152.022 685.936,145.623 683.157,139.913C673.007,119.067 641.22,103.897 603.436,103.897C593.142,103.897 583.298,105.013 574.202,107.087C576.237,109.286 577.809,111.7 579.361,114.133C586.886,112.663 595.019,111.867 603.416,111.867C638.011,111.867 666.957,125.318 675.321,143.491C677.567,148.123 678.803,153.292 678.803,158.714C678.803,169.76 673.63,179.661 665.53,186.42L678.051,206.873L684.776,201.537L676.183,187.838L676.198,187.819L676.197,187.818Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path897-6",
    d: "M663.355,119.287C672.451,125.011 679.34,132.057 683.157,139.913C685.921,145.623 687.483,152.022 687.483,158.714C687.483,169.813 683.191,179.963 676.197,187.818L683.78,200.153C691.056,190.807 695.267,179.896 695.267,168.289C695.267,148.305 682.568,130.841 663.355,119.287",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path898-1",
    d: "M663.355,119.287C672.451,125.011 679.34,132.057 683.157,139.913C685.921,145.623 687.483,152.022 687.483,158.714C687.483,169.813 683.191,179.963 676.197,187.818L683.78,200.153C691.056,190.807 695.267,179.896 695.267,168.289C695.267,148.305 682.568,130.841 663.355,119.287Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path900-8",
    d: "M439.743,159.49C439.743,154.762 443.81,150.945 448.806,150.945C453.802,150.945 457.869,154.762 457.869,159.49C457.869,164.237 453.802,168.074 448.806,168.074C443.81,168.074 439.743,164.237 439.743,159.49",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path901-2",
    d: "M439.743,159.49C439.743,154.762 443.81,150.945 448.806,150.945C453.802,150.945 457.869,154.762 457.869,159.49C457.869,164.237 453.802,168.074 448.806,168.074C443.81,168.074 439.743,164.237 439.743,159.49Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path902-7",
    d: "M439.743,142.682C439.743,137.954 443.81,134.098 448.806,134.098C453.802,134.098 457.869,137.954 457.869,142.682C457.869,147.414 453.802,151.246 448.806,151.246C443.81,151.246 439.743,147.414 439.743,142.682",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path904-3",
    d: "M441.564,124.604C441.564,120.82 444.811,117.764 448.806,117.764C452.782,117.764 456.03,120.82 456.03,124.604C456.03,128.388 452.782,131.449 448.806,131.449C444.811,131.449 441.564,128.388 441.564,124.604",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path906-4",
    d: "M443.595,108.304C443.595,105.588 445.932,103.375 448.806,103.375C451.695,103.375 454.013,105.588 454.013,108.304C454.013,111.043 451.695,113.256 448.806,113.256C445.932,113.256 443.595,111.043 443.595,108.304",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path908-4",
    d: "M444.629,94.048C444.629,91.85 446.498,90.097 448.806,90.097C451.106,90.097 452.978,91.85 452.978,94.048C452.978,96.228 451.106,98 448.806,98C446.498,98 444.629,96.228 444.629,94.048",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path910-6",
    d: "M449.573,211.079L455.46,212.161C454.511,214.542 454.315,217.143 454.315,219.883C454.315,232.093 464.805,242.027 477.719,242.027C488.085,242.027 496.913,235.609 499.945,226.742C500.285,226.977 502.178,218.733 503.155,218.834C503.974,218.92 503.888,227.399 504.19,227.245C505.689,238.411 515.892,245.965 527.378,245.965C540.273,245.965 550.73,236.083 550.73,223.849C550.73,222.939 550.678,222.029 550.553,221.148L557.882,213.886L561.819,223.14C560.253,226.048 559.63,229.31 559.63,232.807C559.63,244.48 569.618,253.921 581.947,253.921C589.703,253.921 596.514,250.19 600.514,244.528L605.203,238.564L605.168,245.879C605.168,253.227 608.272,259.818 615.443,260.982C615.443,260.982 623.677,261.489 634.584,252.925C645.501,244.36 651.513,237.266 651.513,237.266L652.452,245.845C652.452,245.845 643.393,259.851 633.531,265.561C628.142,268.703 619.955,271.994 613.446,270.931C606.558,269.815 601.652,264.292 599.123,257.926C594.213,260.814 588.417,262.5 582.209,262.5C568.869,262.5 556.879,255.186 552.137,244.173C546.001,250.793 537.456,254.865 527.435,254.865C516.781,254.865 507.024,250.07 500.907,242.703C494.896,248.178 486.724,251.555 477.718,251.555C465.925,251.555 455.406,245.778 449.442,237.06C443.488,245.778 432.979,251.555 421.205,251.555C412.204,251.555 404.013,248.178 397.997,242.703C391.904,250.07 382.127,254.865 371.479,254.865C361.453,254.865 352.907,250.793 346.766,244.173C342.029,255.186 330.044,262.5 316.699,262.5C310.486,262.5 304.714,260.814 299.809,257.926C297.256,264.292 292.351,269.815 285.482,270.931C278.972,271.994 270.786,268.703 265.383,265.561C255.515,259.851 246.466,245.845 246.466,245.845L247.415,237.266C247.415,237.266 253.431,244.36 264.329,252.925C275.245,261.504 283.47,260.982 283.47,260.982C290.641,259.818 293.74,253.227 293.74,245.879L293.706,238.564L298.396,244.528C302.391,250.19 309.226,253.921 316.967,253.921C329.292,253.921 339.279,244.48 339.279,232.807C339.279,229.31 338.652,226.048 337.086,223.14L341.023,213.886L348.362,221.148C348.251,222.029 348.184,222.939 348.184,223.849C348.184,236.083 358.627,245.965 371.531,245.965C383.037,245.965 393.221,238.411 394.72,227.245C395.041,227.399 394.955,218.92 395.769,218.834C396.737,218.733 398.643,226.977 398.964,226.742C402.015,235.609 410.829,242.027 421.229,242.027C434.138,242.027 444.595,232.093 444.595,219.883C444.595,217.143 444.432,214.542 443.469,212.161L449.572,211.079",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path912-0",
    d: "M610.18,240.269C611.531,236.303 610.324,232.38 607.469,231.523C604.619,230.627 601.189,233.128 599.838,237.079C598.478,241.031 599.695,244.935 602.549,245.831C605.4,246.688 608.824,244.207 610.18,240.269",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path914-4",
    d: "M508.491,220.573C509.023,216.434 507.044,212.822 504.065,212.482C501.086,212.128 498.231,215.184 497.699,219.308C497.162,223.428 499.141,227.063 502.12,227.418C505.1,227.753 507.955,224.697 508.491,220.573",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path916-8",
    d: "M390.42,220.573C389.888,216.434 391.886,212.822 394.846,212.482C397.825,212.128 400.68,215.184 401.217,219.308C401.729,223.428 399.77,227.063 396.791,227.418C393.811,227.753 390.956,224.697 390.42,220.573",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path918-4",
    d: "M288.75,240.269C287.394,236.303 288.606,232.38 291.461,231.523C294.316,230.627 297.722,233.128 299.077,237.079C300.414,241.031 299.202,244.935 296.366,245.831C293.511,246.688 290.105,244.207 288.75,240.269",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path920-9",
    d: "M332.915,172.414C337.963,175.604 342.37,180.911 343.898,186.841C343.898,186.841 344.492,185.625 347.271,184.02C350.073,182.449 352.444,182.497 352.444,182.497C352.444,182.497 351.644,187.109 351.251,188.767C350.844,190.386 350.806,195.339 349.737,199.798C348.664,204.258 346.72,207.822 346.72,207.822C344.741,206.198 342.03,205.388 339.228,205.843C336.445,206.318 334.198,207.956 332.915,210.116C332.915,210.116 329.791,207.4 327.186,203.563C324.565,199.726 322.784,195.099 321.782,193.696C320.8,192.278 318.391,188.192 318.391,188.192C318.391,188.192 320.609,187.363 323.799,187.953C326.989,188.547 327.99,189.509 327.99,189.509C327.315,183.412 329.332,177.041 332.915,172.414",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path922-2",
    d: "M335.056,220.98C333.451,219.711 332.239,217.938 331.846,215.845C331.449,213.766 331.899,211.706 332.953,210.016C332.953,210.016 328.738,207.889 324.225,206.706C320.8,205.81 314.774,205.776 312.954,205.743C311.134,205.69 307.498,205.609 307.498,205.609C307.498,205.609 307.8,206.437 308.835,208.243C310.08,210.423 311.187,211.788 311.187,211.788C305.156,213.177 300.021,217.143 296.773,221.742C301.487,224.999 307.747,226.977 313.898,226.35C313.898,226.35 313.361,227.993 312.973,230.474C312.652,232.519 312.672,233.362 312.672,233.362C312.672,233.362 316.058,232.112 317.754,231.489C319.45,230.862 325.102,228.903 328.01,226.944C331.808,224.343 335.056,220.994 335.056,220.994",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path924-7",
    d: "M348.578,218.714C349.627,217.028 350.13,214.964 349.737,212.87C349.345,210.777 348.2,209.005 346.595,207.735C346.595,207.735 349.771,204.373 353.57,201.791C356.463,199.832 362.129,197.854 363.825,197.245C365.521,196.623 368.912,195.353 368.912,195.353C368.912,195.353 368.927,196.215 368.606,198.261C368.218,200.728 367.676,202.366 367.676,202.366C373.836,201.724 380.107,203.784 384.82,207.06C381.577,211.639 376.404,215.538 370.392,216.928C370.392,216.928 371.48,218.293 372.744,220.472C373.779,222.297 374.086,223.107 374.086,223.107C374.086,223.107 370.445,223.025 368.625,222.992C366.805,222.958 360.779,222.939 357.354,222.029C352.841,220.827 348.578,218.733 348.578,218.733",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path926-6",
    d: "M330.649,214.274C330.649,208.866 335.271,204.493 340.962,204.493C346.629,204.493 351.27,208.866 351.27,214.274C351.27,219.663 346.648,224.036 340.962,224.036C335.271,224.036 330.649,219.663 330.649,214.274",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path928-1",
    d: "M449.18,156.788C454.138,161.282 457.955,168.002 458.439,174.914C458.439,174.914 459.33,173.664 462.774,172.414C466.214,171.163 468.853,171.652 468.853,171.652C468.853,171.652 467.018,176.672 466.214,178.425C465.414,180.183 464.379,185.692 462.233,190.439C460.149,195.219 457.242,198.816 457.242,198.816C455.35,196.656 452.499,195.253 449.285,195.253C446.09,195.253 443.24,196.656 441.348,198.816C441.348,198.816 438.441,195.219 436.338,190.439C434.211,185.692 433.162,180.183 432.376,178.425C431.576,176.672 429.718,171.652 429.718,171.652C429.718,171.652 432.376,171.163 435.801,172.414C439.24,173.664 440.155,174.914 440.155,174.914C440.634,168.002 444.241,161.282 449.18,156.788",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path930-2",
    d: "M441.492,211.333C439.959,209.628 438.977,207.415 438.977,205.015C438.977,202.634 439.887,200.407 441.42,198.73C441.42,198.73 437.176,195.554 432.395,193.394C428.774,191.737 422.049,190.592 420.032,190.218C418.001,189.83 413.968,189.069 413.968,189.069C413.968,189.069 414.131,190.031 414.912,192.244C415.86,194.932 416.804,196.656 416.804,196.656C409.815,197.078 403.229,200.555 398.664,205.067C403.229,209.541 409.796,212.937 416.804,213.397C416.804,213.397 415.86,215.103 414.912,217.804C414.131,219.984 413.968,220.961 413.968,220.961C413.968,220.961 418.001,220.218 420.032,219.85C422.049,219.442 428.774,218.312 432.395,216.64C437.176,214.475 441.492,211.352 441.492,211.352",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path932-7",
    d: "M457.031,211.333C458.564,209.628 459.541,207.415 459.541,205.015C459.541,202.634 458.636,200.407 457.098,198.73C457.098,198.73 461.347,195.554 466.127,193.394C469.763,191.737 476.488,190.592 478.505,190.218C480.502,189.83 484.531,189.069 484.531,189.069C484.531,189.069 484.392,190.031 483.587,192.244C482.639,194.932 481.714,196.656 481.714,196.656C488.708,197.078 495.285,200.555 499.835,205.067C495.285,209.541 488.722,212.937 481.714,213.397C481.714,213.397 482.639,215.103 483.587,217.804C484.373,219.984 484.531,220.961 484.531,220.961C484.531,220.961 480.522,220.218 478.505,219.85C476.488,219.442 469.763,218.312 466.127,216.64C461.347,214.475 457.031,211.352 457.031,211.352",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path934-8",
    d: "M565.996,172.414C560.967,175.604 556.564,180.911 555.027,186.841C555.027,186.841 554.414,185.625 551.64,184.02C548.857,182.449 546.462,182.497 546.462,182.497C546.462,182.497 547.267,187.109 547.679,188.767C548.091,190.386 548.105,195.339 549.173,199.798C550.246,204.258 552.186,207.822 552.186,207.822C554.189,206.198 556.9,205.388 559.683,205.843C562.461,206.318 564.712,207.956 566.015,210.116C566.015,210.116 569.119,207.4 571.744,203.563C574.345,199.726 576.146,195.099 577.109,193.696C578.091,192.278 580.52,188.192 580.52,188.192C580.52,188.192 578.288,187.363 575.097,187.953C571.902,188.547 570.901,189.509 570.901,189.509C571.615,183.412 569.579,177.041 565.996,172.414",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path936-6",
    d: "M563.874,220.98C565.464,219.711 566.696,217.938 567.064,215.845C567.462,213.766 567.029,211.706 565.982,210.016C565.982,210.016 570.173,207.889 574.681,206.706C578.11,205.81 584.155,205.776 585.952,205.743C587.777,205.69 591.412,205.609 591.412,205.609C591.412,205.609 591.125,206.437 590.081,208.243C588.826,210.423 587.724,211.788 587.724,211.788C593.75,213.177 598.885,217.143 602.138,221.742C597.443,224.999 591.183,226.977 585.013,226.35C585.013,226.35 585.564,227.993 585.942,230.474C586.239,232.519 586.225,233.362 586.225,233.362C586.225,233.362 582.833,232.112 581.161,231.489C579.466,230.862 573.809,228.903 570.901,226.944C567.122,224.343 563.874,220.994 563.874,220.994",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path938-8",
    d: "M550.337,218.714C549.284,217.028 548.804,214.964 549.173,212.87C549.571,210.777 550.73,209.005 552.33,207.735C552.33,207.735 549.14,204.373 545.341,201.791C542.453,199.832 536.777,197.854 535.086,197.245C533.39,196.623 530.018,195.353 530.018,195.353C530.018,195.353 530.003,196.215 530.319,198.261C530.698,200.728 531.234,202.366 531.234,202.366C525.079,201.724 518.799,203.784 514.105,207.06C517.357,211.639 522.511,215.538 528.523,216.928C528.523,216.928 527.436,218.293 526.181,220.472C525.132,222.297 524.849,223.107 524.849,223.107C524.849,223.107 528.465,223.025 530.286,222.992C532.087,222.958 538.156,222.939 541.557,222.029C546.055,220.827 550.318,218.733 550.318,218.733",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path940-0",
    d: "M547.645,214.274C547.645,208.866 552.258,204.493 557.954,204.493C563.663,204.493 568.281,208.866 568.281,214.274C568.281,219.663 563.663,224.036 557.954,224.036C552.258,224.036 547.645,219.663 547.645,214.274",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path942-5",
    d: "M662.962,235.963C660.534,233.396 655.504,233.937 651.744,237.146C647.979,240.337 646.887,245.036 649.315,247.584C651.744,250.151 656.773,249.596 660.534,246.406C664.299,243.177 665.391,238.497 662.962,235.963",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path944-2",
    d: "M648.319,242.181C648.836,240.423 650.015,238.631 651.744,237.146C655.504,233.937 660.534,233.396 662.962,235.963C663.264,236.303 663.604,236.758 663.8,237.161C663.8,237.161 669.026,227.245 675.215,223.955C681.409,220.625 691.88,221.469 691.88,221.469C691.88,213.867 685.653,207.721 677.625,207.721C672.916,207.721 668.456,209.68 665.831,212.99L664.749,207.889C664.749,207.889 658.292,209.172 655.327,216.554C652.386,223.955 655.595,234.646 655.595,234.646C655.595,234.646 653.991,230.052 651.567,226.991C649.157,223.955 642.969,220.625 639.74,219.107C636.512,217.603 633.211,215.337 633.211,215.337C633.211,215.337 633.068,216.166 632.943,218.211C632.818,220.659 633.015,222.163 633.015,222.163C627.094,221.387 620.187,222.35 614.803,224.443C617.102,228.97 621.49,233.228 627.233,235.408C627.233,235.408 625.164,237.113 623.272,238.986C621.705,240.576 621.207,241.319 621.207,241.319C621.207,241.319 625.255,241.893 627.29,242.181C629.302,242.449 636.028,243.512 640.042,243.244C643.002,243.057 646.321,242.569 648.319,242.181",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path948-5",
    d: "M250.597,242.181C250.079,240.423 248.911,238.631 247.172,237.146C243.407,233.937 238.392,233.396 235.949,235.963C235.628,236.303 235.307,236.758 235.11,237.161C235.11,237.161 229.865,227.245 223.676,223.955C217.507,220.625 207.036,221.469 207.036,221.469C207.036,213.867 213.263,207.721 221.286,207.721C226.014,207.721 230.44,209.68 233.094,212.99L234.167,207.889C234.167,207.889 240.624,209.172 243.584,216.554C246.539,223.955 243.316,234.646 243.316,234.646C243.316,234.646 244.92,230.052 247.349,226.991C249.773,223.955 255.962,220.625 259.185,219.107C262.404,217.603 265.719,215.337 265.719,215.337C265.719,215.337 265.844,216.166 265.973,218.211C266.098,220.659 265.901,222.163 265.901,222.163C271.803,221.387 278.724,222.35 284.113,224.443C281.809,228.97 277.436,233.228 271.678,235.408C271.678,235.408 273.747,237.113 275.635,238.986C277.211,240.576 277.723,241.319 277.723,241.319C277.723,241.319 273.656,241.893 271.644,242.181C269.604,242.449 262.903,243.512 258.888,243.244C255.928,243.057 252.609,242.569 250.597,242.181",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path946-0",
    d: "M235.949,235.963C238.392,233.396 243.407,233.937 247.172,237.146C250.951,240.337 252.019,245.036 249.596,247.584C247.172,250.151 242.137,249.596 238.377,246.406C234.612,243.177 233.525,238.497 235.949,235.963",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path950-9",
    d: "M438.977,205.015C438.977,199.612 443.595,195.253 449.285,195.253C454.976,195.253 459.613,199.612 459.613,205.015C459.613,210.423 454.995,214.796 449.285,214.796C443.595,214.796 438.977,210.423 438.977,205.015",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path952-4",
    d: "M427.826,56.581C427.826,45.53 437.267,36.611 448.893,36.611C460.523,36.611 469.959,45.53 469.959,56.581C469.959,67.593 460.523,76.512 448.893,76.512C437.267,76.512 427.826,67.593 427.826,56.581",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path953-1",
    d: "M443.375,0.616L443.375,11.393L431.849,11.393L431.849,22.32L443.375,22.32L443.375,53.755L428.855,53.755C428.684,54.78 427.807,55.528 427.807,56.599C427.807,59.352 428.387,61.998 429.454,64.383C429.483,64.447 429.574,64.469 429.604,64.533L468.224,64.533C468.254,64.469 468.345,64.447 468.373,64.383C469.44,61.998 470.02,59.352 470.02,56.599C470.02,55.532 469.141,54.778 468.972,53.755L454.901,53.755L454.901,22.32L466.427,22.32L466.427,11.393L454.901,11.393L454.901,0.616L443.375,0.616L443.375,0.616Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1040-6",
    d: "M686.525,205.829C686.525,203.089 688.862,200.91 691.736,200.91C694.625,200.91 696.943,203.089 696.943,205.829C696.943,208.564 694.625,210.758 691.736,210.758C688.862,210.758 686.525,208.564 686.525,205.829",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1041-1",
    d: "M686.525,205.829C686.525,203.089 688.862,200.91 691.736,200.91C694.625,200.91 696.943,203.089 696.943,205.829C696.943,208.564 694.625,210.758 691.736,210.758C688.862,210.758 686.525,208.564 686.525,205.829Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1042-8",
    d: "M693.657,193.193C693.657,190.472 695.98,188.273 698.869,188.273C701.738,188.273 704.076,190.472 704.076,193.193C704.076,195.947 701.738,198.141 698.869,198.141C695.98,198.141 693.657,195.947 693.657,193.193",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043-3",
    d: "M693.657,193.193C693.657,190.472 695.98,188.273 698.869,188.273C701.738,188.273 704.076,190.472 704.076,193.193C704.076,195.947 701.738,198.141 698.869,198.141C695.98,198.141 693.657,195.947 693.657,193.193Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1044-5",
    d: "M698.399,178.564C698.399,175.843 700.742,173.63 703.635,173.63C706.504,173.63 708.842,175.843 708.842,178.564C708.842,181.299 706.504,183.512 703.635,183.512C700.742,183.512 698.399,181.299 698.399,178.564",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1045-6",
    d: "M698.399,178.564C698.399,175.843 700.742,173.63 703.635,173.63C706.504,173.63 708.842,175.843 708.842,178.564C708.842,181.299 706.504,183.512 703.635,183.512C700.742,183.512 698.399,181.299 698.399,178.564Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1046-6",
    d: "M699.012,162.867C699.012,160.132 701.345,157.938 704.215,157.938C707.089,157.938 709.426,160.132 709.426,162.867C709.426,165.607 707.089,167.801 704.215,167.801C701.345,167.801 699.012,165.607 699.012,162.867",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1047-4",
    d: "M699.012,162.867C699.012,160.132 701.345,157.938 704.215,157.938C707.089,157.938 709.426,160.132 709.426,162.867C709.426,165.607 707.089,167.801 704.215,167.801C701.345,167.801 699.012,165.607 699.012,162.867Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1048-2",
    d: "M695.142,147.414C695.142,144.694 697.48,142.495 700.344,142.495C703.237,142.495 705.575,144.694 705.575,147.414C705.575,150.164 703.237,152.362 700.344,152.362C697.48,152.362 695.142,150.164 695.142,147.414",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1049-2",
    d: "M695.142,147.414C695.142,144.694 697.48,142.495 700.344,142.495C703.237,142.495 705.575,144.694 705.575,147.414C705.575,150.164 703.237,152.362 700.344,152.362C697.48,152.362 695.142,150.164 695.142,147.414Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1050-8",
    d: "M687.114,133.389C687.114,130.654 689.451,128.46 692.326,128.46C695.214,128.46 697.542,130.654 697.542,133.389C697.542,136.129 695.214,138.342 692.326,138.342C689.451,138.342 687.114,136.129 687.114,133.389",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1051-8",
    d: "M687.114,133.389C687.114,130.654 689.451,128.46 692.326,128.46C695.214,128.46 697.542,130.654 697.542,133.389C697.542,136.129 695.214,138.342 692.326,138.342C689.451,138.342 687.114,136.129 687.114,133.389Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1052-5",
    d: "M676.413,121.869C676.413,119.134 678.746,116.921 681.62,116.921C684.513,116.921 686.846,119.134 686.846,121.869C686.846,124.59 684.513,126.803 681.62,126.803C678.746,126.803 676.413,124.59 676.413,121.869",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1053-2",
    d: "M676.413,121.869C676.413,119.134 678.746,116.921 681.62,116.921C684.513,116.921 686.846,119.134 686.846,121.869C686.846,124.59 684.513,126.803 681.62,126.803C678.746,126.803 676.413,124.59 676.413,121.869Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1054-0",
    d: "M663.978,112.294C663.978,109.554 666.315,107.341 669.208,107.341C672.078,107.341 674.415,109.554 674.415,112.294C674.415,115.01 672.078,117.223 669.208,117.223C666.315,117.223 663.978,115.01 663.978,112.294",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1055-2",
    d: "M663.978,112.294C663.978,109.554 666.315,107.341 669.208,107.341C672.078,107.341 674.415,109.554 674.415,112.294C674.415,115.01 672.078,117.223 669.208,117.223C666.315,117.223 663.978,115.01 663.978,112.294Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1056-0",
    d: "M649.124,104.452C649.124,101.717 651.456,99.538 654.33,99.538C657.219,99.538 659.556,101.717 659.556,104.452C659.556,107.192 657.219,109.405 654.33,109.405C651.456,109.405 649.124,107.192 649.124,104.452",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1057-3",
    d: "M649.124,104.452C649.124,101.717 651.456,99.538 654.33,99.538C657.219,99.538 659.556,101.717 659.556,104.452C659.556,107.192 657.219,109.405 654.33,109.405C651.456,109.405 649.124,107.192 649.124,104.452Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1058-4",
    d: "M633.709,98.862C633.709,96.142 636.047,93.929 638.935,93.929C641.804,93.929 644.147,96.142 644.147,98.862C644.147,101.597 641.804,103.81 638.935,103.81C636.047,103.81 633.709,101.597 633.709,98.862",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059-2",
    d: "M633.709,98.862C633.709,96.142 636.047,93.929 638.935,93.929C641.804,93.929 644.147,96.142 644.147,98.862C644.147,101.597 641.804,103.81 638.935,103.81C636.047,103.81 633.709,101.597 633.709,98.862Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1060-5",
    d: "M616.479,95.787C616.479,93.066 618.812,90.839 621.686,90.839C624.579,90.839 626.907,93.066 626.907,95.787C626.907,98.508 624.579,100.721 621.686,100.721C618.812,100.721 616.479,98.508 616.479,95.787",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1061-9",
    d: "M616.479,95.787C616.479,93.066 618.812,90.839 621.686,90.839C624.579,90.839 626.907,93.066 626.907,95.787C626.907,98.508 624.579,100.721 621.686,100.721C618.812,100.721 616.479,98.508 616.479,95.787Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1062-5",
    d: "M600.121,94.925C600.121,92.204 602.458,90.01 605.347,90.01C608.221,90.01 610.559,92.204 610.559,94.925C610.559,97.665 608.221,99.878 605.347,99.878C602.458,99.878 600.121,97.665 600.121,94.925",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1063-6",
    d: "M600.121,94.925C600.121,92.204 602.458,90.01 605.347,90.01C608.221,90.01 610.559,92.204 610.559,94.925C610.559,97.665 608.221,99.878 605.347,99.878C602.458,99.878 600.121,97.665 600.121,94.925Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1064-6",
    d: "M584.064,95.485C584.064,92.765 586.407,90.552 589.29,90.552C592.184,90.552 594.502,92.765 594.502,95.485C594.502,98.221 592.184,100.434 589.29,100.434C586.407,100.434 584.064,98.221 584.064,95.485",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1065-0",
    d: "M584.064,95.485C584.064,92.765 586.407,90.552 589.29,90.552C592.184,90.552 594.502,92.765 594.502,95.485C594.502,98.221 592.184,100.434 589.29,100.434C586.407,100.434 584.064,98.221 584.064,95.485Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1066-5",
    d: "M568.032,95.485C568.032,92.765 570.365,90.552 573.239,90.552C576.108,90.552 578.446,92.765 578.446,95.485C578.446,98.221 576.108,100.434 573.239,100.434C570.365,100.434 568.032,98.221 568.032,95.485",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1067-7",
    d: "M568.032,95.485C568.032,92.765 570.365,90.552 573.239,90.552C576.108,90.552 578.446,92.765 578.446,95.485C578.446,98.221 576.108,100.434 573.239,100.434C570.365,100.434 568.032,98.221 568.032,95.485Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1068-8",
    d: "M576.06,109.252C576.06,106.517 578.398,104.304 581.267,104.304C584.155,104.304 586.474,106.517 586.474,109.252C586.474,111.973 584.155,114.2 581.267,114.2C578.398,114.2 576.06,111.973 576.06,109.252",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1070-4",
    d: "M579.322,124.456C579.322,121.72 581.66,119.503 584.534,119.503C587.422,119.503 589.76,121.72 589.76,124.456C589.76,127.157 587.422,129.37 584.534,129.37C581.66,129.37 579.322,127.157 579.322,124.456",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1072-5",
    d: "M579.911,139.607C579.911,136.852 582.249,134.658 585.137,134.658C588.012,134.658 590.339,136.852 590.339,139.607C590.339,142.327 588.012,144.54 585.137,144.54C582.249,144.54 579.911,142.327 579.911,139.607",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1074-8",
    d: "M575.164,153.392C575.164,150.672 577.502,148.444 580.371,148.444C583.264,148.444 585.583,150.672 585.583,153.392C585.583,156.127 583.264,158.326 580.371,158.326C577.502,158.326 575.164,156.127 575.164,153.392",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1076-0",
    d: "M566.298,166.062C566.298,163.341 568.64,161.114 571.51,161.114C574.393,161.114 576.716,163.341 576.716,166.062C576.716,168.783 574.393,170.996 571.51,170.996C568.64,170.996 566.298,168.783 566.298,166.062",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1078-3",
    d: "M555.884,85.924C555.884,83.204 558.222,81.005 561.11,81.005C563.984,81.005 566.317,83.204 566.317,85.924C566.317,88.66 563.984,90.873 561.11,90.873C558.222,90.873 555.884,88.66 555.884,85.924",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1079-1",
    d: "M555.884,85.924C555.884,83.204 558.222,81.005 561.11,81.005C563.984,81.005 566.317,83.204 566.317,85.924C566.317,88.66 563.984,90.873 561.11,90.873C558.222,90.873 555.884,88.66 555.884,85.924Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1080-4",
    d: "M541.629,78.05C541.629,75.329 543.952,73.101 546.841,73.101C549.715,73.101 552.043,75.329 552.043,78.05C552.043,80.77 549.715,82.983 546.841,82.983C543.952,82.983 541.629,80.77 541.629,78.05",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1081-0",
    d: "M541.629,78.05C541.629,75.329 543.952,73.101 546.841,73.101C549.715,73.101 552.043,75.329 552.043,78.05C552.043,80.77 549.715,82.983 546.841,82.983C543.952,82.983 541.629,80.77 541.629,78.05Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1082-0",
    d: "M525.917,73.303C525.917,70.582 528.255,68.388 531.139,68.388C534.013,68.388 536.35,70.582 536.35,73.303C536.35,76.038 534.013,78.256 531.139,78.256C528.255,78.256 525.917,76.038 525.917,73.303",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1083-1",
    d: "M525.917,73.303C525.917,70.582 528.255,68.388 531.139,68.388C534.013,68.388 536.35,70.582 536.35,73.303C536.35,76.038 534.013,78.256 531.139,78.256C528.255,78.256 525.917,76.038 525.917,73.303Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1084-3",
    d: "M509.578,70.5C509.578,67.78 511.916,65.567 514.785,65.567C517.674,65.567 519.997,67.78 519.997,70.5C519.997,73.216 517.674,75.434 514.785,75.434C511.916,75.434 509.578,73.216 509.578,70.5",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1085-2",
    d: "M509.578,70.5C509.578,67.78 511.916,65.567 514.785,65.567C517.674,65.567 519.997,67.78 519.997,70.5C519.997,73.216 517.674,75.434 514.785,75.434C511.916,75.434 509.578,73.216 509.578,70.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1086-6",
    d: "M493.579,70.769C493.579,68.048 495.912,65.821 498.786,65.821C501.675,65.821 504.012,68.048 504.012,70.769C504.012,73.509 501.675,75.702 498.786,75.702C495.912,75.702 493.579,73.509 493.579,70.769",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1087-8",
    d: "M493.579,70.769C493.579,68.048 495.912,65.821 498.786,65.821C501.675,65.821 504.012,68.048 504.012,70.769C504.012,73.509 501.675,75.702 498.786,75.702C495.912,75.702 493.579,73.509 493.579,70.769Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1088-1",
    d: "M476.934,73.576C476.934,70.855 479.271,68.656 482.145,68.656C485.034,68.656 487.371,70.855 487.371,73.576C487.371,76.325 485.034,78.524 482.145,78.524C479.271,78.524 476.934,76.325 476.934,73.576",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1089-0",
    d: "M476.934,73.576C476.934,70.855 479.271,68.656 482.145,68.656C485.034,68.656 487.371,70.855 487.371,73.576C487.371,76.325 485.034,78.524 482.145,78.524C479.271,78.524 476.934,76.325 476.934,73.576Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1090-1",
    d: "M461.524,78.897C461.524,76.158 463.862,73.945 466.731,73.945C469.619,73.945 471.957,76.158 471.957,78.897C471.957,81.613 469.619,83.846 466.731,83.846C463.862,83.846 461.524,81.613 461.524,78.897",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1091-3",
    d: "M461.524,78.897C461.524,76.158 463.862,73.945 466.731,73.945C469.619,73.945 471.957,76.158 471.957,78.897C471.957,81.613 469.619,83.846 466.731,83.846C463.862,83.846 461.524,81.613 461.524,78.897Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1092-6",
    d: "M200.507,205.829C200.507,203.089 202.844,200.91 205.713,200.91C208.607,200.91 210.925,203.089 210.925,205.829C210.925,208.564 208.607,210.758 205.713,210.758C202.844,210.758 200.507,208.564 200.507,205.829",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1093-4",
    d: "M200.507,205.829C200.507,203.089 202.844,200.91 205.713,200.91C208.607,200.91 210.925,203.089 210.925,205.829C210.925,208.564 208.607,210.758 205.713,210.758C202.844,210.758 200.507,208.564 200.507,205.829Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1094-2",
    d: "M193.369,193.193C193.369,190.472 195.707,188.273 198.581,188.273C201.469,188.273 203.807,190.472 203.807,193.193C203.807,195.947 201.469,198.141 198.581,198.141C195.707,198.141 193.369,195.947 193.369,193.193",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1095-6",
    d: "M193.369,193.193C193.369,190.472 195.707,188.273 198.581,188.273C201.469,188.273 203.807,190.472 203.807,193.193C203.807,195.947 201.469,198.141 198.581,198.141C195.707,198.141 193.369,195.947 193.369,193.193Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1096-3",
    d: "M188.608,178.564C188.608,175.843 190.946,173.63 193.834,173.63C196.708,173.63 199.046,175.843 199.046,178.564C199.046,181.299 196.708,183.512 193.834,183.512C190.946,183.512 188.608,181.299 188.608,178.564",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1097-7",
    d: "M188.608,178.564C188.608,175.843 190.946,173.63 193.834,173.63C196.708,173.63 199.046,175.843 199.046,178.564C199.046,181.299 196.708,183.512 193.834,183.512C190.946,183.512 188.608,181.299 188.608,178.564Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1098-2",
    d: "M188.019,162.867C188.019,160.132 190.356,157.938 193.23,157.938C196.119,157.938 198.456,160.132 198.456,162.867C198.456,165.607 196.119,167.801 193.23,167.801C190.356,167.801 188.019,165.607 188.019,162.867",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1099-2",
    d: "M188.019,162.867C188.019,160.132 190.356,157.938 193.23,157.938C196.119,157.938 198.456,160.132 198.456,162.867C198.456,165.607 196.119,167.801 193.23,167.801C190.356,167.801 188.019,165.607 188.019,162.867Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1100-6",
    d: "M191.889,147.414C191.889,144.694 194.227,142.495 197.096,142.495C199.97,142.495 202.308,144.694 202.308,147.414C202.308,150.164 199.97,152.362 197.096,152.362C194.227,152.362 191.889,150.164 191.889,147.414",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1101-7",
    d: "M191.889,147.414C191.889,144.694 194.227,142.495 197.096,142.495C199.97,142.495 202.308,144.694 202.308,147.414C202.308,150.164 199.97,152.362 197.096,152.362C194.227,152.362 191.889,150.164 191.889,147.414Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1102-1",
    d: "M199.898,133.389C199.898,130.654 202.236,128.46 205.129,128.46C207.998,128.46 210.336,130.654 210.336,133.389C210.336,136.129 207.998,138.342 205.129,138.342C202.236,138.342 199.898,136.129 199.898,133.389",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1103-0",
    d: "M199.898,133.389C199.898,130.654 202.236,128.46 205.129,128.46C207.998,128.46 210.336,130.654 210.336,133.389C210.336,136.129 207.998,138.342 205.129,138.342C202.236,138.342 199.898,136.129 199.898,133.389Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1104-2",
    d: "M210.604,121.869C210.604,119.134 212.942,116.921 215.83,116.921C218.699,116.921 221.037,119.134 221.037,121.869C221.037,124.59 218.699,126.803 215.83,126.803C212.942,126.803 210.604,124.59 210.604,121.869",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1105-3",
    d: "M210.604,121.869C210.604,119.134 212.942,116.921 215.83,116.921C218.699,116.921 221.037,119.134 221.037,121.869C221.037,124.59 218.699,126.803 215.83,126.803C212.942,126.803 210.604,124.59 210.604,121.869Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1106-5",
    d: "M223.034,112.294C223.034,109.554 225.372,107.341 228.26,107.341C231.135,107.341 233.472,109.554 233.472,112.294C233.472,115.01 231.135,117.223 228.26,117.223C225.372,117.223 223.034,115.01 223.034,112.294",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1107-2",
    d: "M223.034,112.294C223.034,109.554 225.372,107.341 228.26,107.341C231.135,107.341 233.472,109.554 233.472,112.294C233.472,115.01 231.135,117.223 228.26,117.223C225.372,117.223 223.034,115.01 223.034,112.294Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1108-6",
    d: "M237.893,104.452C237.893,101.717 240.231,99.538 243.119,99.538C245.993,99.538 248.331,101.717 248.331,104.452C248.331,107.192 245.993,109.405 243.119,109.405C240.231,109.405 237.893,107.192 237.893,104.452",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1109-2",
    d: "M237.893,104.452C237.893,101.717 240.231,99.538 243.119,99.538C245.993,99.538 248.331,101.717 248.331,104.452C248.331,107.192 245.993,109.405 243.119,109.405C240.231,109.405 237.893,107.192 237.893,104.452Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1110-6",
    d: "M253.308,98.862C253.308,96.142 255.641,93.929 258.515,93.929C261.403,93.929 263.741,96.142 263.741,98.862C263.741,101.597 261.403,103.81 258.515,103.81C255.641,103.81 253.308,101.597 253.308,98.862",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1111-1",
    d: "M253.308,98.862C253.308,96.142 255.641,93.929 258.515,93.929C261.403,93.929 263.741,96.142 263.741,98.862C263.741,101.597 261.403,103.81 258.515,103.81C255.641,103.81 253.308,101.597 253.308,98.862Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1112-5",
    d: "M270.557,95.787C270.557,93.066 272.89,90.839 275.764,90.839C278.633,90.839 280.971,93.066 280.971,95.787C280.971,98.508 278.633,100.721 275.764,100.721C272.89,100.721 270.557,98.508 270.557,95.787",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1113-0",
    d: "M270.557,95.787C270.557,93.066 272.89,90.839 275.764,90.839C278.633,90.839 280.971,93.066 280.971,95.787C280.971,98.508 278.633,100.721 275.764,100.721C272.89,100.721 270.557,98.508 270.557,95.787Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1114-4",
    d: "M286.896,94.925C286.896,92.204 289.229,90.01 292.122,90.01C294.991,90.01 297.329,92.204 297.329,94.925C297.329,97.665 294.991,99.878 292.122,99.878C289.229,99.878 286.896,97.665 286.896,94.925",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1115-2",
    d: "M286.896,94.925C286.896,92.204 289.229,90.01 292.122,90.01C294.991,90.01 297.329,92.204 297.329,94.925C297.329,97.665 294.991,99.878 292.122,99.878C289.229,99.878 286.896,97.665 286.896,94.925Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1116-9",
    d: "M302.943,95.485C302.943,92.765 305.285,90.552 308.155,90.552C311.048,90.552 313.381,92.765 313.381,95.485C313.381,98.221 311.048,100.434 308.155,100.434C305.285,100.434 302.943,98.221 302.943,95.485",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1117-8",
    d: "M302.943,95.485C302.943,92.765 305.285,90.552 308.155,90.552C311.048,90.552 313.381,92.765 313.381,95.485C313.381,98.221 311.048,100.434 308.155,100.434C305.285,100.434 302.943,98.221 302.943,95.485Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1118-2",
    d: "M318.999,95.485C318.999,92.765 321.337,90.552 324.211,90.552C327.099,90.552 329.437,92.765 329.437,95.485C329.437,98.221 327.099,100.434 324.211,100.434C321.337,100.434 318.999,98.221 318.999,95.485",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1119-6",
    d: "M318.999,95.485C318.999,92.765 321.337,90.552 324.211,90.552C327.099,90.552 329.437,92.765 329.437,95.485C329.437,98.221 327.099,100.434 324.211,100.434C321.337,100.434 318.999,98.221 318.999,95.485Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1120-9",
    d: "M310.976,109.252C310.976,106.517 313.309,104.304 316.183,104.304C319.071,104.304 321.409,106.517 321.409,109.252C321.409,111.973 319.071,114.2 316.183,114.2C313.309,114.2 310.976,111.973 310.976,109.252",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1122-5",
    d: "M307.709,124.456C307.709,121.72 310.027,119.503 312.921,119.503C315.79,119.503 318.128,121.72 318.128,124.456C318.128,127.157 315.79,129.37 312.921,129.37C310.027,129.37 307.709,127.157 307.709,124.456",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1124-7",
    d: "M307.106,139.607C307.106,136.852 309.443,134.658 312.332,134.658C315.201,134.658 317.538,136.852 317.538,139.607C317.538,142.327 315.201,144.54 312.332,144.54C309.443,144.54 307.106,142.327 307.106,139.607",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1126-2",
    d: "M311.867,153.392C311.867,150.672 314.204,148.444 317.074,148.444C319.967,148.444 322.3,150.672 322.3,153.392C322.3,156.127 319.967,158.326 317.074,158.326C314.204,158.326 311.867,156.127 311.867,153.392",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1128-2",
    d: "M320.729,166.062C320.729,163.341 323.071,161.114 325.935,161.114C328.829,161.114 331.166,163.341 331.166,166.062C331.166,168.783 328.829,170.996 325.935,170.996C323.071,170.996 320.729,168.783 320.729,166.062",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1130-7",
    d: "M331.133,85.924C331.133,83.204 333.47,81.005 336.34,81.005C339.228,81.005 341.566,83.204 341.566,85.924C341.566,88.66 339.228,90.873 336.34,90.873C333.47,90.873 331.133,88.66 331.133,85.924",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1131-7",
    d: "M331.133,85.924C331.133,83.204 333.47,81.005 336.34,81.005C339.228,81.005 341.566,83.204 341.566,85.924C341.566,88.66 339.228,90.873 336.34,90.873C333.47,90.873 331.133,88.66 331.133,85.924Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1132-5",
    d: "M345.402,78.05C345.402,75.329 347.74,73.101 350.609,73.101C353.498,73.101 355.835,75.329 355.835,78.05C355.835,80.77 353.498,82.983 350.609,82.983C347.74,82.983 345.402,80.77 345.402,78.05",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1133-1",
    d: "M345.402,78.05C345.402,75.329 347.74,73.101 350.609,73.101C353.498,73.101 355.835,75.329 355.835,78.05C355.835,80.77 353.498,82.983 350.609,82.983C347.74,82.983 345.402,80.77 345.402,78.05Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1134-1",
    d: "M361.095,73.303C361.095,70.582 363.437,68.388 366.321,68.388C369.195,68.388 371.532,70.582 371.532,73.303C371.532,76.038 369.195,78.256 366.321,78.256C363.437,78.256 361.095,76.038 361.095,73.303",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1135-7",
    d: "M361.095,73.303C361.095,70.582 363.437,68.388 366.321,68.388C369.195,68.388 371.532,70.582 371.532,73.303C371.532,76.038 369.195,78.256 366.321,78.256C363.437,78.256 361.095,76.038 361.095,73.303Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1136-0",
    d: "M377.448,70.5C377.448,67.78 379.791,65.567 382.66,65.567C385.553,65.567 387.891,67.78 387.891,70.5C387.891,73.216 385.553,75.434 382.66,75.434C379.791,75.434 377.448,73.216 377.448,70.5",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1137-0",
    d: "M377.448,70.5C377.448,67.78 379.791,65.567 382.66,65.567C385.553,65.567 387.891,67.78 387.891,70.5C387.891,73.216 385.553,75.434 382.66,75.434C379.791,75.434 377.448,73.216 377.448,70.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1138-5",
    d: "M393.457,70.769C393.457,68.048 395.77,65.821 398.664,65.821C401.533,65.821 403.87,68.048 403.87,70.769C403.87,73.509 401.533,75.702 398.664,75.702C395.77,75.702 393.457,73.509 393.457,70.769",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1139-1",
    d: "M393.457,70.769C393.457,68.048 395.77,65.821 398.664,65.821C401.533,65.821 403.87,68.048 403.87,70.769C403.87,73.509 401.533,75.702 398.664,75.702C395.77,75.702 393.457,73.509 393.457,70.769Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1140-6",
    d: "M410.098,73.576C410.098,70.855 412.435,68.656 415.304,68.656C418.198,68.656 420.516,70.855 420.516,73.576C420.516,76.325 418.198,78.524 415.304,78.524C412.435,78.524 410.098,76.325 410.098,73.576",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1141-0",
    d: "M410.098,73.576C410.098,70.855 412.435,68.656 415.304,68.656C418.198,68.656 420.516,70.855 420.516,73.576C420.516,76.325 418.198,78.524 415.304,78.524C412.435,78.524 410.098,76.325 410.098,73.576Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1142-3",
    d: "M425.493,78.897C425.493,76.158 427.826,73.945 430.714,73.945C433.588,73.945 435.926,76.158 435.926,78.897C435.926,81.613 433.588,83.846 430.714,83.846C427.826,83.846 425.493,81.613 425.493,78.897",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1143-9",
    d: "M425.493,78.897C425.493,76.158 427.826,73.945 430.714,73.945C433.588,73.945 435.926,76.158 435.926,78.897C435.926,81.613 433.588,83.846 430.714,83.846C427.826,83.846 425.493,81.613 425.493,78.897Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3541-6",
    transform: "matrix(1,0,0,1,4.99985,4.99999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2944-1",
    transform: "matrix(1,0,0,1,-9.15211,-10.0823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path688-1-5",
    d: "M814.273,319.179C814.273,319.179 810.776,322.862 808.223,323.384C805.674,323.892 802.446,321.09 802.446,321.09C802.446,321.09 800.147,323.485 797.325,324.127C794.509,324.769 790.595,320.951 790.595,320.951C790.595,320.951 787.908,324.769 785.494,325.664C783.075,326.56 780.129,324.52 780.129,324.52C780.129,324.52 779.061,326.412 777.044,327.456C776.186,327.863 774.764,327.188 774.764,327.188L771.919,325.41L768.69,321.966L765.734,320.817C765.734,320.817 764.398,316.491 764.254,315.735C764.149,314.973 763.861,313.047 763.861,313.047C763.258,309.958 768.019,306.375 774.811,304.837C778.72,303.927 782.121,303.994 784.626,304.77C787.338,302.457 793.081,300.852 799.84,300.852C805.957,300.852 811.326,302.15 814.291,304.162C817.213,302.15 822.583,300.852 828.719,300.852C835.445,300.852 841.183,302.457 843.899,304.77C846.414,303.994 849.8,303.942 853.728,304.837C860.502,306.375 865.287,309.958 864.674,313.047C864.674,313.047 864.391,314.973 864.271,315.735C864.128,316.491 862.791,320.817 862.791,320.817L859.826,321.966L856.598,325.41L853.8,327.188C853.8,327.188 852.373,327.863 851.515,327.456C849.499,326.426 848.411,324.52 848.411,324.52C848.411,324.52 845.451,326.56 843.042,325.664C840.618,324.769 837.926,320.951 837.926,320.951C837.926,320.951 834.036,324.769 831.196,324.127C828.379,323.485 826.089,321.09 826.089,321.09C826.089,321.09 822.861,323.892 820.317,323.384C817.75,322.862 814.291,319.179 814.291,319.179",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path689-0-2",
    d: "M814.273,319.179C814.273,319.179 810.776,322.862 808.223,323.384C805.674,323.892 802.446,321.09 802.446,321.09C802.446,321.09 800.147,323.485 797.325,324.127C794.509,324.769 790.595,320.951 790.595,320.951C790.595,320.951 787.908,324.769 785.494,325.664C783.075,326.56 780.129,324.52 780.129,324.52C780.129,324.52 779.061,326.412 777.044,327.456C776.186,327.863 774.764,327.188 774.764,327.188L771.919,325.41L768.69,321.966L765.734,320.817C765.734,320.817 764.398,316.491 764.254,315.735C764.149,314.973 763.861,313.047 763.861,313.047C763.258,309.958 768.019,306.375 774.811,304.837C778.72,303.927 782.121,303.994 784.626,304.77C787.338,302.457 793.081,300.852 799.84,300.852C805.957,300.852 811.326,302.15 814.291,304.162C817.213,302.15 822.583,300.852 828.719,300.852C835.445,300.852 841.183,302.457 843.899,304.77C846.414,303.994 849.8,303.942 853.728,304.837C860.502,306.375 865.287,309.958 864.674,313.047C864.674,313.047 864.391,314.973 864.271,315.735C864.128,316.491 862.791,320.817 862.791,320.817L859.826,321.966L856.598,325.41L853.8,327.188C853.8,327.188 852.373,327.863 851.515,327.456C849.499,326.426 848.411,324.52 848.411,324.52C848.411,324.52 845.451,326.56 843.042,325.664C840.618,324.769 837.926,320.951 837.926,320.951C837.926,320.951 834.036,324.769 831.196,324.127C828.379,323.485 826.089,321.09 826.089,321.09C826.089,321.09 822.861,323.892 820.317,323.384C817.75,322.862 814.291,319.179 814.291,319.179L814.271,319.179L814.273,319.179Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path691-9-4",
    d: "M807.619,299.075C807.619,293.925 810.546,289.753 814.162,289.753C817.784,289.753 820.73,293.925 820.73,299.075C820.73,304.248 817.784,308.435 814.162,308.435C810.546,308.435 807.619,304.248 807.619,299.075Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path693-2-7",
    d: "M811.274,299.075C811.274,294.347 812.63,290.496 814.292,290.496C815.963,290.496 817.305,294.347 817.305,299.075C817.305,303.822 815.963,307.678 814.292,307.678C812.63,307.678 811.274,303.822 811.274,299.075Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694-3-7",
    d: "M780.502,337.39C779.54,334.67 777.734,332.236 777.734,332.236C786.998,329.516 799.893,327.81 814.234,327.777C828.576,327.81 841.562,329.516 850.821,332.236C850.821,332.236 849.786,334.061 848.34,336.595C847.54,337.999 846.486,340.446 846.558,340.446C838.19,337.879 827.417,336.562 814.182,336.547C800.927,336.562 788.19,338.186 781.551,340.614C781.647,340.614 781.091,339.081 780.431,337.39L780.503,337.39",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path695-9-5",
    d: "M780.502,337.39C779.54,334.67 777.734,332.236 777.734,332.236C786.998,329.516 799.893,327.81 814.234,327.777C828.576,327.81 841.562,329.516 850.821,332.236C850.821,332.236 849.786,334.061 848.34,336.595C847.744,337.555 847.608,338.011 846.558,340.446C838.19,337.879 827.417,336.562 814.182,336.547C800.927,336.562 788.19,338.186 781.551,340.614C781.647,340.614 781.091,339.081 780.431,337.39L780.503,337.39",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696-1-8",
    d: "M814.234,349.164C825.807,349.145 838.549,347.392 843.257,346.175C846.395,345.26 848.234,343.843 847.894,342.204C847.736,341.428 847.056,340.753 846.141,340.365C839.239,338.152 826.794,336.581 814.234,336.562C801.699,336.581 789.192,338.152 782.265,340.365C781.379,340.753 780.68,341.428 780.536,342.204C780.181,343.843 782.021,345.26 785.177,346.175C789.872,347.392 802.671,349.145 814.234,349.164",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path697-2-6",
    d: "M814.234,349.164C825.807,349.145 838.549,347.392 843.257,346.175C846.395,345.26 848.234,343.843 847.894,342.204C847.736,341.428 847.056,340.753 846.141,340.365C839.239,338.152 826.794,336.581 814.234,336.562C801.699,336.581 789.192,338.152 782.265,340.365C781.379,340.753 780.68,341.428 780.536,342.204C780.181,343.843 782.021,345.26 785.177,346.175C789.872,347.392 802.671,349.145 814.234,349.164Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path698-0-9",
    d: "M842.295,303.252C842.295,302.116 843.257,301.206 844.431,301.206C845.629,301.206 846.591,302.116 846.591,303.252C846.591,304.382 845.629,305.278 844.431,305.278C843.257,305.278 842.295,304.382 842.295,303.252",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path700-1-3",
    d: "M841.083,296.119C841.083,294.989 842.041,294.079 843.224,294.079C844.412,294.079 845.379,294.989 845.379,296.119C845.379,297.235 844.412,298.15 843.224,298.15C842.041,298.15 841.083,297.235 841.083,296.119ZM835.694,291.66C835.694,290.529 836.652,289.619 837.854,289.619C839.023,289.619 839.995,290.529 839.995,291.66C839.995,292.795 839.023,293.705 837.854,293.705C836.652,293.705 835.694,292.795 835.694,291.66ZM828.964,289.514C828.964,288.369 829.931,287.454 831.124,287.454C832.322,287.454 833.27,288.369 833.27,289.514C833.27,290.616 832.322,291.545 831.124,291.545C829.931,291.545 828.964,290.616 828.964,289.514ZM822.119,289.753C822.119,288.618 823.077,287.708 824.26,287.708C825.457,287.708 826.42,288.618 826.42,289.753C826.42,290.884 825.457,291.78 824.26,291.78C823.077,291.78 822.119,290.884 822.119,289.753Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path701-8-0",
    d: "M863.558,317.1C864.2,315.529 864.602,313.79 864.602,311.984C864.602,304.416 858.6,298.265 851.161,298.265C848.785,298.265 846.558,298.907 844.613,300.023",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path702-0-2",
    d: "M839.617,307.472C840.312,306.241 840.815,304.737 840.815,303.319C840.815,297.863 835.177,293.437 828.24,293.437C825.275,293.437 822.564,294.246 820.428,295.578",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path703-8-2",
    d: "M865.412,310.887C865.412,309.771 866.394,308.842 867.572,308.842C868.765,308.842 869.728,309.771 869.728,310.887C869.728,312.017 868.765,312.913 867.572,312.913C866.394,312.913 865.412,312.017 865.412,310.887ZM864.602,303.386C864.602,302.251 865.575,301.36 866.763,301.36C867.946,301.36 868.908,302.251 868.908,303.386C868.908,304.502 867.946,305.412 866.763,305.412C865.575,305.412 864.602,304.502 864.602,303.386ZM859.774,297.643C859.774,296.526 860.737,295.616 861.915,295.616C863.112,295.616 864.07,296.526 864.07,297.643C864.07,298.773 863.112,299.683 861.915,299.683C860.737,299.683 859.774,298.773 859.774,297.643ZM853.317,294.582C853.317,293.47 854.279,292.556 855.472,292.556C856.655,292.556 857.618,293.47 857.618,294.582C857.618,295.717 856.655,296.646 855.472,296.646C854.279,296.646 853.317,295.717 853.317,294.582ZM846.452,294.855C846.452,293.724 847.415,292.809 848.608,292.809C849.801,292.809 850.768,293.724 850.768,294.855C850.768,295.971 849.801,296.881 848.608,296.881C847.415,296.881 846.452,295.971 846.452,294.855Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path704-7-8",
    d: "M851.386,327.068L848.574,324.52C848.574,324.52 845.878,326.172 842.51,325.664C839.157,325.161 838.084,321.09 838.084,321.09C838.084,321.09 834.305,324.246 831.234,324.012C828.149,323.739 826.133,321.09 826.133,321.09C826.133,321.09 822.761,323.485 819.8,323.25C816.84,322.982 814.019,319.298 814.019,319.298C814.019,319.298 811.063,323.116 808.098,323.384C805.138,323.624 802.728,320.817 802.728,320.817C802.728,320.817 801.373,323.624 797.608,324.246C793.848,324.888 790.619,321.325 790.619,321.325C790.619,321.325 788.497,324.769 785.925,325.664C783.376,326.56 780.023,324.381 780.023,324.381C780.023,324.381 779.487,325.664 779.08,326.426C778.668,327.188 777.595,327.322 777.595,327.322L778.438,329.602C787.649,326.934 800.147,325.276 814.273,325.262C828.418,325.276 841.255,326.934 850.462,329.621L851.41,327.068",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path705-1-2",
    d: "M851.386,327.068L848.574,324.52C848.574,324.52 845.878,326.172 842.51,325.664C839.157,325.161 838.084,321.09 838.084,321.09C838.084,321.09 834.305,324.246 831.234,324.012C828.149,323.739 826.133,321.09 826.133,321.09C826.133,321.09 822.761,323.485 819.8,323.25C816.84,322.982 814.019,319.298 814.019,319.298C814.019,319.298 811.063,323.116 808.098,323.384C805.138,323.624 802.728,320.817 802.728,320.817C802.728,320.817 801.373,323.624 797.608,324.246C793.848,324.888 790.619,321.325 790.619,321.325C790.619,321.325 788.497,324.769 785.925,325.664C783.376,326.56 780.023,324.381 780.023,324.381C780.023,324.381 779.487,325.664 779.08,326.426C778.668,327.188 777.595,327.322 777.595,327.322L778.438,329.602C787.649,326.934 800.147,325.276 814.273,325.262C828.418,325.276 841.255,326.934 850.462,329.621L851.41,327.068L851.385,327.068L851.386,327.068Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path707-5-2",
    d: "M781.595,303.252C781.595,302.116 782.553,301.206 783.75,301.206C784.924,301.206 785.891,302.116 785.891,303.252C785.891,304.382 784.924,305.278 783.75,305.278C782.553,305.278 781.595,304.382 781.595,303.252Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path708-5-2",
    d: "M782.806,296.119C782.806,294.989 783.769,294.079 784.962,294.079C786.14,294.079 787.103,294.989 787.103,296.119C787.103,297.235 786.14,298.15 784.962,298.15C783.769,298.15 782.806,297.235 782.806,296.119ZM788.176,291.66C788.176,290.529 789.139,289.619 790.332,289.619C791.529,289.619 792.492,290.529 792.492,291.66C792.492,292.795 791.529,293.705 790.332,293.705C789.139,293.705 788.176,292.795 788.176,291.66ZM794.901,289.514C794.901,288.369 795.864,287.454 797.057,287.454C798.254,287.454 799.217,288.369 799.217,289.514C799.217,290.616 798.254,291.545 797.057,291.545C795.864,291.545 794.901,290.616 794.901,289.514ZM801.766,289.753C801.766,288.618 802.728,287.708 803.907,287.708C805.104,287.708 806.067,288.618 806.067,289.753C806.067,290.884 805.104,291.78 803.907,291.78C802.728,291.78 801.766,290.884 801.766,289.753Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path709-4-3",
    d: "M764.614,317.1C763.986,315.529 763.579,313.79 763.579,311.984C763.579,304.416 769.586,298.265 777.02,298.265C779.396,298.265 781.623,298.907 783.573,300.023",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path710-9-0",
    d: "M788.727,307.304C788.032,306.087 787.367,304.737 787.367,303.319C787.367,297.863 793.009,293.437 799.945,293.437C802.886,293.437 805.617,294.246 807.758,295.578",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path711-8-1",
    d: "M758.458,310.887C758.458,309.771 759.416,308.842 760.619,308.842C761.787,308.842 762.755,309.771 762.755,310.887C762.755,312.017 761.787,312.913 760.619,312.913C759.416,312.913 758.458,312.017 758.458,310.887ZM759.258,303.386C759.258,302.251 760.24,301.36 761.419,301.36C762.616,301.36 763.579,302.251 763.579,303.386C763.579,304.502 762.616,305.412 761.419,305.412C760.24,305.412 759.258,304.502 759.258,303.386ZM764.111,297.643C764.111,296.526 765.073,295.616 766.271,295.616C767.449,295.616 768.412,296.526 768.412,297.643C768.412,298.773 767.449,299.683 766.271,299.683C765.073,299.683 764.111,298.773 764.111,297.643ZM770.568,294.582C770.568,293.47 771.531,292.556 772.704,292.556C773.906,292.556 774.864,293.47 774.864,294.582C774.864,295.717 773.906,296.646 772.704,296.646C771.531,296.646 770.568,295.717 770.568,294.582ZM777.418,294.855C777.418,293.724 778.38,292.809 779.578,292.809C780.771,292.809 781.719,293.724 781.719,294.855C781.719,295.971 780.771,296.881 779.578,296.881C778.38,296.881 777.418,295.971 777.418,294.855Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path713-9-8",
    d: "M814.306,314.753L815.643,314.992C815.432,315.548 815.389,316.137 815.389,316.764C815.389,319.533 817.769,321.78 820.691,321.78C823.048,321.78 825.045,320.328 825.726,318.316C825.807,318.369 826.238,316.491 826.449,316.525C826.65,316.525 826.616,318.47 826.664,318.436C827.019,320.951 829.318,322.675 831.929,322.675C834.851,322.675 837.222,320.429 837.222,317.66C837.222,317.454 837.207,317.253 837.172,317.052L838.848,315.394L839.734,317.507C839.38,318.149 839.236,318.891 839.236,319.686C839.236,322.34 841.507,324.486 844.29,324.486C846.057,324.486 847.609,323.624 848.5,322.34L849.569,320.989L849.549,322.661C849.549,324.314 850.267,325.803 851.881,326.071C851.881,326.071 853.754,326.206 856.221,324.246C858.703,322.307 860.058,320.683 860.058,320.683L860.202,322.675C860.202,322.675 857.768,326.661 855.579,327.93C854.367,328.639 852.523,329.381 851.067,329.128C849.51,328.893 848.428,327.643 847.853,326.225C846.751,326.881 845.448,327.255 844.054,327.255C841.06,327.255 838.368,325.597 837.314,323.15C835.935,324.634 834.014,325.53 831.763,325.53C829.377,325.53 827.183,324.467 825.804,322.795C824.453,324.045 822.618,324.807 820.597,324.807C817.962,324.807 815.587,323.485 814.25,321.545C812.909,323.485 810.571,324.807 807.913,324.807C805.896,324.807 804.066,324.045 802.711,322.795C801.336,324.467 799.161,325.53 796.752,325.53C794.505,325.53 792.594,324.634 791.224,323.15C790.166,325.583 787.459,327.255 784.48,327.255C783.091,327.255 781.802,326.881 780.696,326.225C780.125,327.643 779.024,328.893 777.486,329.128C776.025,329.381 774.186,328.639 772.974,327.93C770.761,326.661 768.141,322.675 768.141,322.675L768.481,320.683C768.481,320.683 769.832,322.307 772.298,324.246C774.775,326.206 776.648,326.071 776.648,326.071C778.272,325.803 778.961,324.314 778.961,322.661L778.961,320.989L780.02,322.34C780.93,323.624 782.477,324.486 784.226,324.486C787.033,324.486 789.294,322.34 789.294,319.686C789.294,318.891 789.15,318.149 788.796,317.507L789.687,315.394L791.344,317.052C791.309,317.253 791.309,317.454 791.309,317.66C791.309,320.429 793.666,322.675 796.564,322.675C799.193,322.675 801.493,320.951 801.833,318.436C801.905,318.47 801.883,316.525 802.063,316.525C802.298,316.491 802.724,318.369 802.796,318.316C803.49,320.328 805.488,321.78 807.84,321.78C810.771,321.78 813.142,319.533 813.142,316.764C813.142,316.137 813.107,315.548 812.893,314.992L814.268,314.753L814.306,314.753Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path714-6-8",
    d: "M814.234,327.796C799.893,327.81 787.012,329.516 777.758,332.255C777.135,332.457 776.378,331.982 776.172,331.427C775.971,330.838 776.421,330.11 777.02,329.908C786.337,327.068 799.538,325.276 814.234,325.262C828.916,325.276 842.184,327.068 851.482,329.908C852.1,330.11 852.55,330.838 852.354,331.427C852.157,331.982 851.372,332.457 850.768,332.255C841.509,329.516 828.576,327.81 814.234,327.796",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path715-7-5",
    d: "M814.234,327.796C799.893,327.81 787.012,329.516 777.758,332.255C777.135,332.457 776.378,331.982 776.172,331.427C775.971,330.838 776.421,330.11 777.02,329.908C786.337,327.068 799.538,325.276 814.234,325.262C828.916,325.276 842.184,327.068 851.482,329.908C852.1,330.11 852.55,330.838 852.354,331.427C852.157,331.982 851.372,332.457 850.768,332.255C841.509,329.516 828.576,327.81 814.234,327.796Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path716-6-7",
    d: "M800.357,332.878C800.357,331.8 801.287,330.919 802.446,330.919C803.586,330.919 804.515,331.8 804.515,332.878C804.515,333.975 803.586,334.837 802.446,334.837C801.287,334.837 800.357,333.975 800.357,332.878",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path717-9-9",
    d: "M800.357,332.878C800.357,331.8 801.287,330.919 802.446,330.919C803.586,330.919 804.515,331.8 804.515,332.878C804.515,333.975 803.586,334.837 802.446,334.837C801.287,334.837 800.357,333.975 800.357,332.878Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path718-6-0",
    d: "M814.411,333.726L809.794,333.726C808.936,333.726 808.223,333.051 808.223,332.236C808.223,331.441 808.917,330.785 809.775,330.785L819.106,330.785C819.963,330.785 820.634,331.441 820.634,332.236C820.634,333.051 819.944,333.726 819.087,333.726L814.411,333.726",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path719-42-7",
    d: "M814.411,333.726L809.794,333.726C808.936,333.726 808.223,333.051 808.223,332.236C808.223,331.441 808.917,330.785 809.775,330.785L819.106,330.785C819.963,330.785 820.634,331.441 820.634,332.236C820.634,333.051 819.944,333.726 819.087,333.726L814.411,333.726",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path720-9-5",
    d: "M791.299,335.312L787.999,335.8C787.151,335.92 786.356,335.379 786.212,334.569C786.088,333.774 786.653,333.031 787.496,332.912L790.811,332.423L794.197,331.901C795.045,331.8 795.826,332.323 795.97,333.118C796.094,333.908 795.505,334.67 794.667,334.789L791.299,335.312",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path721-9-8",
    d: "M791.299,335.312L787.999,335.8C787.151,335.92 786.356,335.379 786.212,334.569C786.088,333.774 786.653,333.031 787.496,332.912L790.811,332.423L794.197,331.901C795.045,331.8 795.826,332.323 795.97,333.118C796.094,333.908 795.505,334.67 794.667,334.789L791.299,335.312",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path722-1-6",
    d: "M777.968,337.625L779.434,335.264L782.576,335.853L780.751,338.506L777.968,337.625",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path723-6-5",
    d: "M777.968,337.625L779.434,335.264L782.576,335.853L780.751,338.506C779.824,338.213 778.896,337.919 777.968,337.625Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path724-9-7",
    d: "M823.977,332.878C823.977,331.8 824.921,330.919 826.061,330.919C827.206,330.919 828.149,331.8 828.149,332.878C828.149,333.975 827.206,334.837 826.061,334.837C824.921,334.837 823.977,333.975 823.977,332.878",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path725-0-9",
    d: "M823.977,332.878C823.977,331.8 824.921,330.919 826.061,330.919C827.206,330.919 828.149,331.8 828.149,332.878C828.149,333.975 827.206,334.837 826.061,334.837C824.921,334.837 823.977,333.975 823.977,332.878Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path726-5-2",
    d: "M837.193,335.312L840.513,335.8C841.351,335.92 842.132,335.379 842.275,334.569C842.395,333.774 841.849,333.031 841.011,332.912L837.691,332.423L834.305,331.901C833.447,331.8 832.662,332.323 832.537,333.118C832.394,333.908 833.002,334.67 833.84,334.789L837.193,335.312",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path727-8-4",
    d: "M837.193,335.312L840.513,335.8C841.351,335.92 842.132,335.379 842.275,334.569C842.395,333.774 841.849,333.031 841.011,332.912L837.691,332.423L834.305,331.901C833.447,331.8 832.662,332.323 832.537,333.118C832.394,333.908 833.002,334.67 833.84,334.789L837.193,335.312",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path728-3-6",
    d: "M850.251,337.759L849.073,335.244L845.854,335.513L847.396,338.334L850.251,337.759",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729-1-1",
    d: "M850.141,337.605L849.073,335.244L845.854,335.513L847.396,338.334C848.373,338.116 849.313,337.793 850.141,337.605Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path730-0-6",
    d: "M814.215,346.477C802.642,346.463 792.171,345.447 784.196,343.388C792.171,341.342 802.642,340.078 814.215,340.044C825.793,340.059 836.317,341.328 844.268,343.388C836.317,345.447 825.793,346.463 814.215,346.477",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path738-3-6",
    d: "M814.215,346.477C802.642,346.463 792.171,345.447 784.196,343.388C792.171,341.342 802.642,340.078 814.215,340.044C825.793,340.059 836.317,341.328 844.268,343.388C836.317,345.447 825.793,346.463 814.215,346.477Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path739-0-2",
    d: "M850.716,321.377C851.018,320.482 850.751,319.6 850.083,319.38C849.441,319.198 848.68,319.773 848.378,320.63C848.057,321.545 848.338,322.441 848.982,322.642C849.624,322.829 850.409,322.273 850.716,321.377",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path740-9-7",
    d: "M850.716,321.377C851.018,320.482 850.751,319.6 850.083,319.38C849.441,319.198 848.68,319.773 848.378,320.63C848.057,321.545 848.338,322.441 848.982,322.642C849.624,322.829 850.409,322.273 850.716,321.377Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path741-2-4",
    d: "M827.666,316.918C827.79,315.988 827.326,315.16 826.65,315.074C825.989,314.992 825.328,315.701 825.223,316.63C825.098,317.56 825.544,318.383 826.224,318.47C826.899,318.537 827.541,317.828 827.666,316.918",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path742-1-2",
    d: "M827.666,316.918C827.79,315.988 827.326,315.16 826.65,315.074C825.989,314.992 825.328,315.701 825.223,316.63C825.098,317.56 825.544,318.383 826.224,318.47C826.899,318.537 827.541,317.828 827.666,316.918Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path743-4-0",
    d: "M800.913,316.918C800.788,315.988 801.229,315.16 801.909,315.074C802.59,314.992 803.227,315.701 803.356,316.63C803.456,317.56 803.016,318.383 802.355,318.47C801.679,318.537 801.033,317.828 800.913,316.918",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path744-3-5",
    d: "M800.913,316.918C800.788,315.988 801.229,315.16 801.909,315.074C802.59,314.992 803.227,315.701 803.356,316.63C803.456,317.56 803.016,318.383 802.355,318.47C801.679,318.537 801.033,317.828 800.913,316.918Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path745-5-0",
    d: "M777.863,321.377C777.542,320.482 777.828,319.6 778.471,319.38C779.108,319.198 779.894,319.773 780.201,320.63C780.503,321.545 780.236,322.441 779.597,322.642C778.936,322.829 778.165,322.273 777.863,321.377",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path746-7-6",
    d: "M777.863,321.377C777.542,320.482 777.828,319.6 778.471,319.38C779.108,319.198 779.894,319.773 780.201,320.63C780.503,321.545 780.236,322.441 779.597,322.642C778.936,322.829 778.165,322.273 777.863,321.377Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path748-6-5",
    d: "M814.215,303.606L810.134,306.068L813.161,312.64L814.215,313.335L815.255,312.64L818.301,306.068C816.939,305.248 815.591,304.404 814.215,303.606Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path750-8-5",
    d: "M805.258,313.536L807.121,316.242L813.487,314.278L814.162,313.387L813.487,312.473L807.121,310.614C806.467,311.569 805.835,312.534 805.258,313.536Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path752-8-0",
    d: "M823.206,313.536L821.333,316.242L814.967,314.278L814.292,313.387L814.967,312.473L821.333,310.614C821.988,311.569 822.596,312.552 823.206,313.536Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path754-86-6",
    d: "M787.649,306.528L784.449,309.551L788.55,314.959L789.637,315.394L790.442,314.566L791.884,308.032C790.478,307.514 789.066,307.015 787.649,306.528Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path756-2-6",
    d: "M780.933,317.373L783.338,319.634L789.153,316.491L789.599,315.481L788.765,314.719L782.112,314.144C781.667,315.201 781.307,316.289 780.933,317.373Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path758-6-7",
    d: "M798.484,313.842L797.253,316.831L790.595,316.223L789.728,315.462L790.188,314.432L796.022,311.356C796.869,312.16 797.674,313.004 798.484,313.842Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path760-53-6",
    d: "M774.529,318.216L773.978,321.377L767.315,322.067L766.305,321.492L766.559,320.414L771.564,316.257C772.529,316.946 773.529,317.58 774.529,318.216Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path761-5-0",
    d: "M787.357,315.495C787.357,314.264 788.406,313.268 789.69,313.268C790.993,313.268 792.027,314.264 792.027,315.495C792.027,316.712 790.993,317.708 789.69,317.708C788.406,317.708 787.357,316.712 787.357,315.495",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path762-7-4",
    d: "M787.357,315.495C787.357,314.264 788.406,313.268 789.69,313.268C790.993,313.268 792.027,314.264 792.027,315.495C792.027,316.712 790.993,317.708 789.69,317.708C788.406,317.708 787.357,316.712 787.357,315.495Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path764-5-2",
    d: "M840.867,306.528L844.077,309.551L839.971,314.959L838.884,315.394L838.084,314.566L836.638,308.032C838.064,307.577 839.468,307.06 840.867,306.528Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path766-9-1",
    d: "M847.593,317.373L845.183,319.634L839.368,316.491L838.903,315.481L839.761,314.719L846.414,314.144C846.877,315.216 847.209,316.273 847.593,317.373Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path768-0-8",
    d: "M830.037,313.842L831.268,316.831L837.926,316.223L838.779,315.462L838.333,314.432L832.504,311.356C831.694,312.198 830.867,313.021 830.037,313.842Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path769-3-7",
    d: "M853.101,318.216L853.638,321.377L860.286,322.067L861.287,321.492L861.038,320.414L856.047,316.257L853.101,318.216",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path770-0-7",
    d: "M853.101,318.216L853.638,321.377L860.286,322.067L861.287,321.492L861.038,320.414L856.047,316.257C855.059,316.901 854.071,317.544 853.101,318.216Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path771-1-5",
    d: "M811.916,313.402C811.916,312.152 812.946,311.174 814.253,311.174C815.518,311.174 816.591,312.152 816.591,313.402C816.591,314.618 815.532,315.615 814.253,315.615C812.946,315.615 811.916,314.618 811.916,313.402",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path772-00-2",
    d: "M811.916,313.402C811.916,312.152 812.946,311.174 814.253,311.174C815.518,311.174 816.591,312.152 816.591,313.402C816.591,314.618 815.532,315.615 814.253,315.615C812.946,315.615 811.916,314.618 811.916,313.402Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path773-7-5",
    d: "M836.532,315.495C836.532,314.264 837.581,313.268 838.87,313.268C840.168,313.268 841.226,314.264 841.226,315.495C841.226,316.712 840.168,317.708 838.87,317.708C837.581,317.708 836.532,316.712 836.532,315.495",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path774-5-8",
    d: "M836.532,315.495C836.532,314.264 837.581,313.268 838.87,313.268C840.168,313.268 841.226,314.264 841.226,315.495C841.226,316.712 840.168,317.708 838.87,317.708C837.581,317.708 836.532,316.712 836.532,315.495Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path776-8-9",
    d: "M817.357,286.932L817.357,289.686L810.575,289.686L810.575,286.932L812.792,286.932L812.792,280.714L809.847,280.714L809.847,277.946L812.792,277.946L812.792,275.225L815.7,275.225L815.7,277.946L818.588,277.946L818.588,280.714L815.7,280.714L815.7,286.932L817.338,286.932",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path777-8-8",
    d: "M817.357,286.932L817.357,289.686L810.575,289.686L810.575,286.932L812.792,286.932L812.792,280.714L809.847,280.714L809.847,277.946L812.792,277.946L812.792,275.225L815.7,275.225L815.7,277.946L818.588,277.946L818.588,280.714L815.7,280.714L815.7,286.932L817.358,286.932L817.357,286.932Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path780-2-9",
    d: "M816.027,283.082C818.444,283.737 820.199,285.867 820.199,288.379C820.199,291.425 817.592,293.892 814.349,293.892C811.131,293.892 808.524,291.425 808.524,288.379C808.524,285.822 810.349,283.692 812.835,283.037",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path782-41-9",
    d: "M765.303,321.613C764.672,320.764 763.57,319.486 762.401,318.436C761.471,317.607 759.191,316.899 759.191,316.899C759.191,316.477 760.528,315.529 761.974,315.529C762.813,315.529 763.612,315.883 764.087,316.477L764.254,315.562C764.254,315.562 765.433,315.782 765.95,317.085C766.486,318.436 766.146,320.482 766.146,320.482C765.96,320.914 765.572,321.227 765.303,321.613Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path784-5-2",
    d: "M765.61,320.75C766.166,320.175 767.306,320.295 768.144,321.023C769.001,321.746 769.25,322.809 768.69,323.403C768.144,323.993 767.018,323.859 766.166,323.13C765.303,322.407 765.059,321.325 765.61,320.75Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path785-1-1",
    d: "M862.087,321.914C862.159,321.966 863.888,319.619 865.215,318.436C866.125,317.607 868.425,316.899 868.425,316.899C868.425,316.477 867.088,315.529 865.642,315.529C864.803,315.529 863.999,315.883 863.52,316.477L863.343,315.562C863.343,315.562 862.159,315.782 861.647,317.085C861.115,318.436 861.446,320.482 861.446,320.482C861.446,320.482 861.661,321.425 862.088,321.914",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path786-5-2",
    d: "M862.087,321.914C862.159,321.966 863.888,319.619 865.215,318.436C866.125,317.607 868.425,316.899 868.425,316.899C868.425,316.477 867.088,315.529 865.642,315.529C864.803,315.529 863.999,315.883 863.52,316.477L863.343,315.562C863.343,315.562 862.159,315.782 861.647,317.085C861.115,318.436 861.446,320.482 861.446,320.482C861.426,321.073 861.694,321.253 862.087,321.914Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path787-5-2",
    d: "M862.15,320.75C861.589,320.175 860.454,320.295 859.597,321.023C858.739,321.746 858.509,322.809 859.041,323.403C859.597,323.993 860.737,323.859 861.589,323.13C862.447,322.407 862.701,321.325 862.15,320.75",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path788-9-9",
    d: "M862.15,320.75C861.589,320.175 860.454,320.295 859.597,321.023C858.739,321.746 858.509,322.809 859.041,323.403C859.597,323.993 860.737,323.859 861.589,323.13C862.447,322.407 862.701,321.325 862.15,320.75Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path779-2-2",
    d: "M820.39,286.932L820.39,289.686L808.333,289.686L808.333,286.932L812.792,286.932L812.792,280.714L809.847,280.714L809.847,277.946L812.792,277.946L812.792,275.225L815.7,275.225L815.7,277.946L818.603,277.946L818.603,280.714L815.7,280.714L815.7,286.932L820.39,286.932Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2639-2-8-7",
    transform: "matrix(0.924528,0,0,0.924528,635.338,134.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2640-9-2-5",
    d: "M193.384,229.571L193.384,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2641-4-2-8",
    d: "M191.612,229.571L191.612,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2642-9-9-6",
    d: "M189.94,229.571L189.94,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2643-5-0-6",
    d: "M188.282,229.571L188.282,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2644-3-3-6",
    d: "M186.805,229.571L186.805,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2645-9-6-3",
    d: "M183.987,229.22L183.948,223.283M185.323,229.298L185.323,223.088",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2646-4-3-0",
    d: "M181.386,228.953L181.386,223.483M182.704,229.109L182.665,223.288",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2647-6-9-0",
    d: "M177.897,228.64L177.897,223.835M179.042,228.718L179.042,223.679M180.221,228.875L180.221,223.639",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2648-7-8-6",
    d: "M176.673,228.601L176.673,223.952",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2649-1-8-6",
    d: "M175.533,228.697L175.533,223.61",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2650-4-0-8",
    d: "M174.31,228.549L174.31,223.805",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2651-8-1-7",
    d: "M171.806,228.138L171.767,224.124M173.089,228.384L173.089,223.95",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2652-4-5-0",
    d: "M170.522,228.045L170.522,224.421",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2653-0-5-9",
    d: "M169.347,228.086L169.347,224.604",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2654-7-7-0",
    d: "M168.064,227.414L168.064,224.799",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2655-2-0-8",
    d: "M166.745,227.438L166.745,225.051",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2656-9-8-5",
    d: "M165.349,227.126L165.349,225.352",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2657-0-4-8",
    d: "M200.432,229.22L200.432,223.244M197.431,229.415L197.47,223.088M195.244,229.493L195.244,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3401-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path789-9",
    x: 751.742,
    y: 338.331,
    width: 106.019,
    height: 27.792,
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path790-5",
    x: 751.742,
    y: 338.331,
    width: 106.019,
    height: 27.792,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path791-8",
    d: "M846.639,384.618C845.973,384.349 845.47,384.316 844.675,384.316L765.279,384.316C764.493,384.316 763.746,384.45 763.085,384.704C765.815,383.794 767.774,381.327 767.774,378.419C767.774,375.517 765.638,372.997 762.889,372.053C763.55,372.255 764.436,372.441 765.221,372.441L844.675,372.441C845.47,372.441 846.227,372.408 846.902,372.187L846.457,372.254C843.621,373.131 841.997,375.651 841.997,378.419C841.997,381.087 843.798,383.76 846.639,384.618",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path792-1",
    d: "M846.639,384.618C845.973,384.349 845.47,384.316 844.675,384.316L765.279,384.316C764.493,384.316 763.746,384.45 763.085,384.704C765.815,383.794 767.774,381.327 767.774,378.419C767.774,375.517 765.638,372.997 762.889,372.053C763.55,372.255 764.436,372.441 765.221,372.441L844.675,372.441C845.47,372.441 846.227,372.408 846.902,372.187L846.457,372.254C843.621,373.131 841.997,375.651 841.997,378.419C841.997,381.087 843.798,383.76 846.639,384.618L846.639,384.618Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path793-5",
    d: "M765.279,384.316L844.675,384.316C847.348,384.316 849.527,385.988 849.527,388.033C849.527,390.093 847.348,391.764 844.675,391.764L765.279,391.764C762.587,391.764 760.407,390.093 760.407,388.033C760.407,385.988 762.587,384.316 765.279,384.316",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path794-3",
    d: "M765.279,384.316L844.675,384.316C847.348,384.316 849.527,385.988 849.527,388.033C849.527,390.093 847.348,391.764 844.675,391.764L765.279,391.764C762.587,391.764 760.407,390.093 760.407,388.033C760.407,385.988 762.587,384.316 765.279,384.316Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path795-5",
    d: "M765.221,366.123L844.675,366.123C847.348,366.123 849.527,367.541 849.527,369.266C849.527,371.019 847.348,372.441 844.675,372.441L765.221,372.441C762.534,372.441 760.355,371.019 760.355,369.266C760.355,367.541 762.534,366.123 765.221,366.123",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path796-1",
    d: "M765.221,366.123L844.675,366.123C847.348,366.123 849.527,367.541 849.527,369.266C849.527,371.019 847.348,372.441 844.675,372.441L765.221,372.441C762.534,372.441 760.355,371.019 760.355,369.266C760.355,367.541 762.534,366.123 765.221,366.123Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path807-2",
    d: "M846.62,786.733C846.371,787.696 846.03,788.644 846.03,789.674C846.03,796.634 852.037,802.171 859.371,802.171L750.271,802.171C757.605,802.171 763.602,796.634 763.602,789.674C763.602,788.659 763.406,787.696 763.19,786.733C763.779,786.953 764.531,786.987 765.26,786.987L844.656,786.987C845.297,786.987 846.045,786.92 846.6,786.733",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path808-1",
    d: "M846.62,786.733C846.371,787.696 846.03,788.644 846.03,789.674C846.03,796.634 852.037,802.171 859.371,802.171L750.271,802.171C757.605,802.171 763.602,796.634 763.602,789.674C763.602,788.659 763.406,787.696 763.19,786.733C763.779,786.953 764.531,786.987 765.26,786.987L844.656,786.987C845.297,786.987 846.045,786.92 846.6,786.733L846.62,786.733L846.62,786.733Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path809-5",
    d: "M765.279,779.519L844.675,779.519C847.348,779.519 849.527,781.21 849.527,783.255C849.527,785.315 847.348,786.987 844.675,786.987L765.279,786.987C762.587,786.987 760.407,785.315 760.407,783.255C760.407,781.21 762.587,779.519 765.279,779.519",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path810-2",
    d: "M765.279,779.519L844.675,779.519C847.348,779.519 849.527,781.21 849.527,783.255C849.527,785.315 847.348,786.987 844.675,786.987L765.279,786.987C762.587,786.987 760.407,785.315 760.407,783.255C760.407,781.21 762.587,779.519 765.279,779.519Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path811-6",
    x: 750.401,
    y: 802.171,
    width: 108.831,
    height: 27.758,
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path812-1",
    x: 750.401,
    y: 802.171,
    width: 108.831,
    height: 27.758,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path813-6",
    d: "M867.734,681.29C878.512,687.507 885.826,693.873 884.648,697.049C884.054,699.971 880.634,702.15 875.748,705.393C868.06,710.748 863.366,720.309 867.025,724.721C860.674,719.586 856.66,711.917 856.66,703.386C856.66,694.467 860.889,686.425 867.734,681.29",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path814-7",
    d: "M867.734,681.29C878.512,687.507 885.826,693.873 884.648,697.049C884.054,699.971 880.634,702.15 875.748,705.393C868.06,710.748 863.366,720.309 867.025,724.721C860.674,719.586 856.66,711.917 856.66,703.386C856.66,694.467 860.889,686.425 867.734,681.29Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path815-1",
    x: 766.313,
    y: 396.176,
    width: 77.327,
    height: 378.85,
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path816-8",
    d: "M822.406,396.037L822.406,774.078M831.1,396.037L831.1,774.078",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path817-0",
    x: 766.313,
    y: 396.176,
    width: 77.327,
    height: 378.85,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path818-4",
    d: "M687.329,537.885C704.215,530.911 732.903,525.742 765.815,524.66C777.153,524.746 789.799,525.809 802.862,527.989C849.096,535.706 884.327,554.171 881.525,569.207C881.467,569.528 881.386,570.184 881.295,570.472C881.295,570.472 898.645,531.399 898.899,529.914C902.003,513.226 862.935,492.715 811.604,484.15C795.495,481.463 779.764,480.419 766.136,480.553C733.281,480.553 704.737,484.759 687.545,491.144L687.329,537.885",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path819-1",
    d: "M687.329,537.885C704.215,530.911 732.903,525.742 765.815,524.66C777.153,524.746 789.799,525.809 802.862,527.989C849.096,535.706 884.327,554.171 881.525,569.207C881.467,569.528 881.386,570.184 881.295,570.472C881.295,570.472 898.645,531.399 898.899,529.914C902.003,513.226 862.935,492.715 811.604,484.15C795.495,481.463 779.764,480.419 766.136,480.553C733.281,480.553 704.737,484.759 687.545,491.144L687.329,537.885",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path820-9",
    d: "M843.779,585.441C865.224,583.903 879.868,578.174 881.525,569.207C882.866,562.06 875.604,554.157 862.671,546.977C856.875,547.599 850.361,548.394 843.64,548.394L843.779,585.441",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path821-1",
    d: "M843.779,585.441C865.224,583.903 879.868,578.174 881.525,569.207C882.866,562.06 875.604,554.157 862.671,546.977C856.875,547.599 850.361,548.394 843.64,548.394L843.779,585.441",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path822-5",
    d: "M766.189,556.485C752.777,558.511 742.727,561.84 737.697,565.931L737.257,566.755C734.847,571.655 746.636,582.078 766.294,593.718L766.189,556.485",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path823-1",
    d: "M766.189,556.485C752.777,558.511 742.727,561.84 737.697,565.931L737.257,566.755C734.847,571.655 746.636,582.078 766.294,593.718L766.189,556.485",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path824-3",
    d: "M891.8,658.518C893.831,652.401 872.922,640.157 843.372,629.313C829.869,624.48 818.717,619.445 804.898,613.347C763.851,595.203 733.525,574.376 737.271,566.774L737.669,565.998C735.508,567.77 732.122,605.185 732.122,605.185C728.376,612.145 756.13,632.671 793.885,650.782C805.985,656.559 831.54,666 843.602,670.225C865.167,677.707 886.593,691.813 884.648,697.049L891.8,658.537",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path825-7",
    d: "M891.8,658.518C893.831,652.401 872.922,640.157 843.372,629.313C829.869,624.48 818.717,619.445 804.898,613.347C763.851,595.203 733.525,574.376 737.271,566.774L737.669,565.998C735.508,567.77 732.122,605.185 732.122,605.185C728.376,612.145 756.13,632.671 793.885,650.782C805.985,656.559 831.54,666 843.602,670.225C865.167,677.707 886.593,691.813 884.648,697.049L891.8,658.537L891.8,658.517L891.8,658.518Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path826-3",
    d: "M735.523,521.283C738.449,510.184 742.229,499.454 745.941,488.595C745.122,488.816 744.231,488.983 743.407,489.117C742.574,489.237 741.678,489.318 740.825,489.352C739.058,497.16 736.668,504.996 734.1,512.833C729.53,505.978 724.553,499.32 720.597,492.394C719.011,492.715 717.363,493.103 715.744,493.342C714.154,493.577 712.458,493.697 710.82,493.85C717.723,503.104 724.395,512.363 730.8,521.972C731.566,521.771 732.309,521.517 733.156,521.397C733.923,521.297 734.723,521.316 735.523,521.282",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827-9",
    d: "M764.924,488.816C763.511,488.883 762.103,488.983 760.69,488.964C759.286,488.949 757.878,488.782 756.484,488.677L755.914,519.185L777.249,519.544C777.139,518.916 776.981,518.241 777,517.599C777,516.971 777.197,516.315 777.297,515.688C773.48,515.942 769.312,516.181 764.421,516.095L764.924,488.815",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path828-3",
    d: "M798.417,493.831C801.827,494.118 805.108,494.707 808.394,495.301C808.332,494.66 808.231,494.018 808.284,493.357C808.334,492.734 808.572,492.106 808.749,491.498L779.869,489.103C779.941,489.745 780.046,490.368 779.979,490.995C779.922,491.671 779.692,492.279 779.524,492.902C782.47,492.835 786.025,492.801 790,493.136L787.486,520.588C788.894,520.623 790.302,520.608 791.696,520.722C793.1,520.827 794.498,521.076 795.887,521.282L798.402,493.831",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829-7",
    d: "M810.229,523.898C811.623,524.119 813.027,524.286 814.406,524.593C815.776,524.88 817.117,525.321 818.454,525.709L821.879,511.688L822.252,511.77C823.052,513.695 824.092,516.042 824.623,517.398L828.906,527.989C830.582,528.257 832.254,528.477 833.902,528.832C835.593,529.205 837.212,529.694 838.84,530.149L837.355,526.973C835.051,522.193 832.632,517.432 830.635,512.584C835.952,512.819 840.071,510.893 841.106,506.62C841.839,503.646 840.656,501.313 837.853,499.32C835.789,497.85 831.78,497.074 829.193,496.499L817.543,493.951L810.229,523.898M825.174,498.104C828.532,498.846 832.723,499.387 832.723,503.205C832.703,504.168 832.613,504.843 832.455,505.452C831.367,509.93 827.976,511.482 822.324,509.796L825.174,498.104",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path830-3",
    d: "M865.234,533.037C864.975,536.347 864.386,539.562 863.744,543.039C865.205,543.734 866.652,544.356 868.06,545.132C869.468,545.913 870.766,546.771 872.127,547.618L874.982,513.226C874.302,512.953 873.693,512.665 873.056,512.33C872.409,511.976 871.859,511.621 871.265,511.195L840.943,530.456C841.743,530.844 842.572,531.198 843.353,531.62C844.138,532.06 844.799,532.53 845.585,532.97C848.128,530.824 850.811,529.086 853.877,526.806L865.224,533.023L865.234,533.038L865.234,533.037ZM856.64,525.182L866.738,518.648L865.56,530.048L856.64,525.182",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path797-4",
    d: "M730.728,833.795C738.076,833.795 744.6,832.258 749.419,829.69C754.204,827.257 760.676,825.772 767.808,825.772C774.964,825.772 781.618,827.276 786.398,829.724C791.179,832.243 797.813,833.795 805.056,833.795C812.37,833.795 818.933,832.09 823.752,829.523C828.494,827.19 834.826,825.772 841.801,825.772C848.991,825.772 855.357,827.142 860.156,829.623C864.951,832.176 871.643,833.795 878.953,833.795L878.953,845.282C871.643,845.282 864.951,843.61 860.156,841.076C855.357,838.609 848.991,837.211 841.801,837.211C834.826,837.211 828.494,838.643 823.752,840.995C818.952,843.543 812.37,845.282 805.056,845.282C797.832,845.282 791.193,843.696 786.398,841.196C781.618,838.715 774.984,837.211 767.808,837.211C760.676,837.211 754.204,838.715 749.419,841.162C744.6,843.73 738.167,845.282 730.833,845.282L730.728,833.795",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path798-4",
    d: "M730.728,833.795C738.076,833.795 744.6,832.258 749.419,829.69C754.204,827.257 760.676,825.772 767.808,825.772C774.964,825.772 781.618,827.276 786.398,829.724C791.179,832.243 797.813,833.795 805.056,833.795C812.37,833.795 818.933,832.09 823.752,829.523C828.494,827.19 834.826,825.772 841.801,825.772C848.991,825.772 855.357,827.142 860.156,829.623C864.951,832.176 871.643,833.795 878.953,833.795L878.953,845.282C871.643,845.282 864.951,843.61 860.156,841.076C855.357,838.609 848.991,837.211 841.801,837.211C834.826,837.211 828.494,838.643 823.752,840.995C818.952,843.543 812.37,845.282 805.056,845.282C797.832,845.282 791.193,843.696 786.398,841.196C781.618,838.715 774.984,837.211 767.808,837.211C760.676,837.211 754.204,838.715 749.419,841.162C744.6,843.73 738.167,845.282 730.833,845.282L730.728,833.795L730.728,833.795Z",
    style: {
      fill: "rgb(0,69,175)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path799-0",
    d: "M730.728,845.282C738.076,845.282 744.6,843.73 749.419,841.162C754.204,838.715 760.676,837.211 767.808,837.211C774.964,837.211 781.618,838.715 786.398,841.196C791.179,843.696 797.813,845.282 805.056,845.282C812.37,845.282 818.933,843.543 823.752,840.995C828.494,838.643 834.826,837.211 841.801,837.211C848.991,837.211 855.357,838.609 860.156,841.076C864.951,843.61 871.643,845.282 878.953,845.282L878.953,856.735C871.643,856.735 864.951,855.097 860.156,852.563C855.357,850.062 848.991,848.678 841.801,848.678C834.826,848.678 828.494,850.115 823.752,852.462C818.952,855.015 812.37,856.735 805.056,856.735C797.832,856.735 791.193,855.149 786.398,852.649C781.618,850.182 774.984,848.678 767.808,848.678C760.676,848.678 754.204,850.182 749.419,852.63C744.6,855.183 738.167,856.735 730.833,856.735L730.728,845.282",
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path800-3",
    d: "M730.728,845.282C738.076,845.282 744.6,843.73 749.419,841.162C754.204,838.715 760.676,837.211 767.808,837.211C774.964,837.211 781.618,838.715 786.398,841.196C791.179,843.696 797.813,845.282 805.056,845.282C812.37,845.282 818.933,843.543 823.752,840.995C828.494,838.643 834.826,837.211 841.801,837.211C848.991,837.211 855.357,838.609 860.156,841.076C864.951,843.61 871.643,845.282 878.953,845.282L878.953,856.735C871.643,856.735 864.951,855.097 860.156,852.563C855.357,850.062 848.991,848.678 841.801,848.678C834.826,848.678 828.494,850.115 823.752,852.462C818.952,855.015 812.37,856.735 805.056,856.735C797.832,856.735 791.193,855.149 786.398,852.649C781.618,850.182 774.984,848.678 767.808,848.678C760.676,848.678 754.204,850.182 749.419,852.63C744.6,855.183 738.167,856.735 730.833,856.735L730.728,845.282",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path801-0",
    d: "M730.728,856.735C738.076,856.735 744.6,855.183 749.419,852.63C754.204,850.182 760.676,848.678 767.808,848.678C774.964,848.678 781.618,850.182 786.398,852.649C791.179,855.149 797.813,856.735 805.056,856.735C812.37,856.735 818.933,855.015 823.752,852.462C828.494,850.115 834.826,848.678 841.801,848.678C848.991,848.678 855.357,850.062 860.156,852.563C864.951,855.097 871.643,856.735 878.953,856.735L878.953,868.188C871.643,868.188 864.951,866.55 860.156,864.001C855.357,861.534 848.991,860.15 841.801,860.15C834.826,860.15 828.494,861.587 823.752,863.915C818.952,866.483 812.37,868.188 805.056,868.188C797.832,868.188 791.193,866.621 786.398,864.121C781.618,861.654 774.984,860.15 767.808,860.15C760.676,860.15 754.204,861.635 749.419,864.088C744.6,866.669 738.167,868.188 730.833,868.188L730.728,856.735",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path802-3",
    d: "M730.728,856.735C738.076,856.735 744.6,855.183 749.419,852.63C754.204,850.182 760.676,848.678 767.808,848.678C774.964,848.678 781.618,850.182 786.398,852.649C791.179,855.149 797.813,856.735 805.056,856.735C812.37,856.735 818.933,855.015 823.752,852.462C828.494,850.115 834.826,848.678 841.801,848.678C848.991,848.678 855.357,850.062 860.156,852.563C864.951,855.097 871.643,856.735 878.953,856.735L878.953,868.188C871.643,868.188 864.951,866.55 860.156,864.001C855.357,861.534 848.991,860.15 841.801,860.15C834.826,860.15 828.494,861.587 823.752,863.915C818.952,866.483 812.37,868.188 805.056,868.188C797.832,868.188 791.193,866.621 786.398,864.121C781.618,861.654 774.984,860.15 767.808,860.15C760.676,860.15 754.204,861.635 749.419,864.088C744.6,866.669 738.167,868.188 730.833,868.188L730.728,856.735",
    style: {
      fill: "rgb(0,69,175)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path803-6",
    d: "M730.833,879.66C738.167,879.66 744.6,878.108 749.419,875.541C754.204,873.107 760.676,871.618 767.808,871.618C774.964,871.618 781.618,873.107 786.398,875.574C791.179,878.074 797.813,879.66 805.056,879.66C812.37,879.66 818.933,877.936 823.752,875.368C828.494,873.04 834.826,871.618 841.801,871.618C848.991,871.618 855.357,873.007 860.156,875.469C864.951,878.022 871.643,879.66 878.953,879.66L878.953,868.26C871.643,868.26 864.951,866.55 860.156,864.001C855.357,861.534 848.991,860.15 841.801,860.15C834.826,860.15 828.494,861.587 823.752,863.915C818.952,866.483 812.37,868.188 805.056,868.188C797.832,868.188 791.193,866.621 786.398,864.121C781.618,861.654 774.984,860.15 767.808,860.15C760.676,860.15 754.204,861.635 749.419,864.088C744.6,866.669 738.076,868.188 730.728,868.188L730.833,879.66",
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path804-0",
    d: "M730.833,879.66C738.167,879.66 744.6,878.108 749.419,875.541C754.204,873.107 760.676,871.618 767.808,871.618C774.964,871.618 781.618,873.107 786.398,875.574C791.179,878.074 797.813,879.66 805.056,879.66C812.37,879.66 818.933,877.936 823.752,875.368C828.494,873.04 834.826,871.618 841.801,871.618C848.991,871.618 855.357,873.007 860.156,875.469C864.951,878.022 871.643,879.66 878.953,879.66L878.953,868.26C871.643,868.26 864.951,866.55 860.156,864.001C855.357,861.534 848.991,860.15 841.801,860.15C834.826,860.15 828.494,861.587 823.752,863.915C818.952,866.483 812.37,868.188 805.056,868.188C797.832,868.188 791.193,866.621 786.398,864.121C781.618,861.654 774.984,860.15 767.808,860.15C760.676,860.15 754.204,861.635 749.419,864.088C744.6,866.669 738.076,868.188 730.728,868.188L730.833,879.66",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path805-5",
    d: "M730.833,891.132C738.167,891.132 744.6,889.575 749.419,887.027C754.204,884.56 760.676,883.056 767.808,883.056C774.964,883.056 781.618,884.575 786.398,887.041C791.179,889.542 797.813,891.132 805.056,891.132C812.37,891.132 818.933,889.389 823.752,886.84C828.494,884.493 834.826,883.056 841.801,883.056C848.991,883.056 855.357,884.46 860.156,886.941C864.951,889.475 871.643,891.132 878.953,891.132L878.953,879.761C871.643,879.761 864.951,878.022 860.156,875.469C855.357,873.007 848.991,871.637 841.801,871.637C834.826,871.637 828.494,873.055 823.752,875.387C818.952,877.936 812.37,879.66 805.056,879.66C797.832,879.66 791.193,878.074 786.398,875.574C781.618,873.107 774.984,871.637 767.808,871.637C760.676,871.637 754.204,873.107 749.419,875.555C744.6,878.108 738.095,879.66 730.761,879.66L730.833,891.132",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path806-8",
    d: "M730.833,891.132C738.167,891.132 744.6,889.575 749.419,887.027C754.204,884.56 760.676,883.056 767.808,883.056C774.964,883.056 781.618,884.575 786.398,887.041C791.179,889.542 797.813,891.132 805.056,891.132C812.37,891.132 818.933,889.389 823.752,886.84C828.494,884.493 834.826,883.056 841.801,883.056C848.991,883.056 855.357,884.46 860.156,886.941C864.951,889.475 871.643,891.132 878.953,891.132L878.953,879.761C871.643,879.761 864.951,878.022 860.156,875.469C855.357,873.007 848.991,871.637 841.801,871.637C834.826,871.637 828.494,873.055 823.752,875.387C818.952,877.936 812.37,879.66 805.056,879.66C797.832,879.66 791.193,878.074 786.398,875.574C781.618,873.107 774.984,871.637 767.808,871.637C760.676,871.637 754.204,873.107 749.419,875.555C744.6,878.108 738.095,879.66 730.761,879.66L730.833,891.132L730.833,891.132Z",
    style: {
      fill: "rgb(0,69,175)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3314-4",
    transform: "matrix(1,0,0,1,4.99985,4.99999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3339-6",
    transform: "matrix(1,0,0,1,-8.73079,-10.0823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path555-6-9",
    d: "M68.056,327.829C68.056,327.829 65.628,327.829 64.291,327.068C62.955,326.292 58.921,322.474 58.921,322.474L55.693,320.175L52.752,316.103C52.752,316.103 49.255,310.533 50.86,306.188C52.464,301.863 55.156,300.325 57.585,299.06C60.009,297.791 65.096,296.258 65.096,296.258C65.096,296.258 69.143,294.481 70.48,294.213C71.816,293.959 76.669,292.69 76.669,292.69C76.669,292.69 78.01,291.933 79.346,291.425C80.702,290.917 82.575,290.917 83.662,290.649C84.73,290.395 87.427,289.533 89.032,289.447C91.528,289.346 95.489,289.887 96.845,289.887C98.181,289.887 102.751,290.156 104.624,290.156C106.497,290.156 113.217,289.634 115.109,289.634C116.982,289.634 118.338,289.399 120.498,289.634C122.639,289.887 126.4,291.152 127.487,291.679C128.56,292.187 135.017,294.481 137.426,295.243C139.85,295.985 145.771,297.015 148.468,298.284C151.14,299.568 152.783,301.714 154.12,303.501C155.475,305.278 155.725,307.218 156.261,308.502C156.778,309.771 156.798,312.506 156.28,313.775C155.739,315.04 153.837,317.66 153.837,317.66L150.872,322.489L147.112,325.53C147.112,325.53 144.415,328.098 142.279,327.829C140.118,327.609 118.338,323.758 104.355,323.758C90.368,323.758 68.037,327.829 68.037,327.829",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556-3-1",
    d: "M68.056,327.829C68.056,327.829 65.628,327.829 64.291,327.068C62.955,326.292 58.921,322.474 58.921,322.474L55.693,320.175L52.752,316.103C52.752,316.103 49.255,310.533 50.86,306.188C52.464,301.863 55.156,300.325 57.585,299.06C60.009,297.791 65.096,296.258 65.096,296.258C65.096,296.258 69.143,294.481 70.48,294.213C71.816,293.959 76.669,292.69 76.669,292.69C76.669,292.69 78.01,291.933 79.346,291.425C80.702,290.917 82.575,290.917 83.662,290.649C84.73,290.395 87.427,289.533 89.032,289.447C91.528,289.346 95.489,289.887 96.845,289.887C98.181,289.887 102.751,290.156 104.624,290.156C106.497,290.156 113.217,289.634 115.109,289.634C116.982,289.634 118.338,289.399 120.498,289.634C122.639,289.887 126.4,291.152 127.487,291.679C128.56,292.187 135.017,294.481 137.426,295.243C139.85,295.985 145.771,297.015 148.468,298.284C151.14,299.568 152.783,301.714 154.12,303.501C155.475,305.278 155.725,307.218 156.261,308.502C156.778,309.771 156.798,312.506 156.28,313.775C155.739,315.04 153.837,317.66 153.837,317.66L150.872,322.489L147.112,325.53C147.112,325.53 144.415,328.098 142.279,327.829C140.118,327.609 118.338,323.758 104.355,323.758C90.368,323.758 68.037,327.829 68.037,327.829L68.056,327.829Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558-6-8",
    d: "M97.97,296.627C97.97,290.055 100.911,284.753 104.533,284.753C108.154,284.753 111.095,290.055 111.095,296.627C111.095,303.165 108.154,308.487 104.533,308.487C100.911,308.487 97.97,303.165 97.97,296.627Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560-1-8",
    d: "M101.644,296.627C101.644,290.582 103,285.682 104.657,285.682C106.334,285.682 107.67,290.582 107.67,296.627C107.67,302.624 106.334,307.524 104.657,307.524C103,307.524 101.644,302.624 101.644,296.627Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568-0-5",
    d: "M127.645,327.068L81.77,327.068L81.238,321.459L80.165,315.615L79.025,308.32C72.726,300.004 66.93,294.548 64.986,295.717C65.45,294.179 66.001,293.03 67.218,292.321C72.817,288.992 84.376,296.982 93.065,310.106C93.846,311.309 94.598,312.506 95.259,313.708L114.146,313.708C114.827,312.525 115.574,311.323 116.359,310.106C125.03,296.982 136.602,288.992 142.188,292.321C143.4,293.03 143.955,294.179 144.434,295.717C142.475,294.567 136.693,300.004 130.361,308.32L129.235,315.615L128.167,321.459L127.645,327.068Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path569-7-0",
    d: "M65.987,295.497C70.284,292.963 80.328,300.919 88.476,313.282M143.419,295.497C139.103,292.963 129.077,300.919 120.924,313.282",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2944-3-6",
    transform: "matrix(1,0,0,1,-709.795,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path694-7-6",
    d: "M780.502,337.39C779.54,334.67 777.734,332.236 777.734,332.236C786.998,329.516 799.893,327.81 814.234,327.777C828.576,327.81 841.562,329.516 850.821,332.236C850.821,332.236 849.786,334.061 848.34,336.595C847.54,337.999 846.486,340.446 846.558,340.446C838.19,337.879 827.417,336.562 814.182,336.547C800.927,336.562 788.19,338.186 781.551,340.614C781.647,340.614 781.091,339.081 780.431,337.39L780.503,337.39",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path695-6-5",
    d: "M780.502,337.39C779.54,334.67 777.734,332.236 777.734,332.236C786.998,329.516 799.893,327.81 814.234,327.777C828.576,327.81 841.562,329.516 850.821,332.236C850.821,332.236 849.786,334.061 848.34,336.595C847.744,337.555 847.608,338.011 846.558,340.446C838.19,337.879 827.417,336.562 814.182,336.547C800.927,336.562 788.19,338.186 781.551,340.614C781.647,340.614 781.091,339.081 780.431,337.39L780.503,337.39",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696-5-4",
    d: "M814.234,349.164C825.807,349.145 838.549,347.392 843.257,346.175C846.395,345.26 848.234,343.843 847.894,342.204C847.736,341.428 847.056,340.753 846.141,340.365C839.239,338.152 826.794,336.581 814.234,336.562C801.699,336.581 789.192,338.152 782.265,340.365C781.379,340.753 780.68,341.428 780.536,342.204C780.181,343.843 782.021,345.26 785.177,346.175C789.872,347.392 802.671,349.145 814.234,349.164",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path697-6-2",
    d: "M814.234,349.164C825.807,349.145 838.549,347.392 843.257,346.175C846.395,345.26 848.234,343.843 847.894,342.204C847.736,341.428 847.056,340.753 846.141,340.365C839.239,338.152 826.794,336.581 814.234,336.562C801.699,336.581 789.192,338.152 782.265,340.365C781.379,340.753 780.68,341.428 780.536,342.204C780.181,343.843 782.021,345.26 785.177,346.175C789.872,347.392 802.671,349.145 814.234,349.164Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path704-0-0",
    d: "M851.386,327.068L848.574,324.52C848.574,324.52 845.878,326.172 842.51,325.664C839.157,325.161 838.084,321.09 838.084,321.09C838.084,321.09 834.305,324.246 831.234,324.012C828.149,323.739 826.133,321.09 826.133,321.09C826.133,321.09 822.761,323.485 819.8,323.25C816.84,322.982 814.019,319.298 814.019,319.298C814.019,319.298 811.063,323.116 808.098,323.384C805.138,323.624 802.728,320.817 802.728,320.817C802.728,320.817 801.373,323.624 797.608,324.246C793.848,324.888 790.619,321.325 790.619,321.325C790.619,321.325 788.497,324.769 785.925,325.664C783.376,326.56 780.023,324.381 780.023,324.381C780.023,324.381 779.487,325.664 779.08,326.426C778.668,327.188 777.595,327.322 777.595,327.322L778.438,329.602C787.649,326.934 800.147,325.276 814.273,325.262C828.418,325.276 841.255,326.934 850.462,329.621L851.41,327.068",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path705-4-8",
    d: "M851.386,327.068L848.574,324.52C848.574,324.52 845.878,326.172 842.51,325.664C839.157,325.161 838.084,321.09 838.084,321.09C838.084,321.09 834.305,324.246 831.234,324.012C828.149,323.739 826.133,321.09 826.133,321.09C826.133,321.09 822.761,323.485 819.8,323.25C816.84,322.982 814.019,319.298 814.019,319.298C814.019,319.298 811.063,323.116 808.098,323.384C805.138,323.624 802.728,320.817 802.728,320.817C802.728,320.817 801.373,323.624 797.608,324.246C793.848,324.888 790.619,321.325 790.619,321.325C790.619,321.325 788.497,324.769 785.925,325.664C783.376,326.56 780.023,324.381 780.023,324.381C780.023,324.381 779.487,325.664 779.08,326.426C778.668,327.188 777.595,327.322 777.595,327.322L778.438,329.602C787.649,326.934 800.147,325.276 814.273,325.262C828.418,325.276 841.255,326.934 850.462,329.621L851.41,327.068L851.385,327.068L851.386,327.068Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path713-6-7",
    d: "M814.306,314.753L815.643,314.992C815.432,315.548 815.389,316.137 815.389,316.764C815.389,319.533 817.769,321.78 820.691,321.78C823.048,321.78 825.045,320.328 825.726,318.316C825.807,318.369 826.238,316.491 826.449,316.525C826.65,316.525 826.616,318.47 826.664,318.436C827.019,320.951 829.318,322.675 831.929,322.675C834.851,322.675 837.222,320.429 837.222,317.66C837.222,317.454 837.207,317.253 837.172,317.052L838.848,315.394L839.734,317.507C839.38,318.149 839.236,318.891 839.236,319.686C839.236,322.34 841.507,324.486 844.29,324.486C846.057,324.486 847.609,323.624 848.5,322.34L849.569,320.989L849.549,322.661C849.549,324.314 850.267,325.803 851.881,326.071C851.881,326.071 853.754,326.206 856.221,324.246C858.703,322.307 860.058,320.683 860.058,320.683L860.202,322.675C860.202,322.675 857.768,326.661 855.579,327.93C854.367,328.639 852.523,329.381 851.067,329.128C849.51,328.893 848.428,327.643 847.853,326.225C846.751,326.881 845.448,327.255 844.054,327.255C841.06,327.255 838.368,325.597 837.314,323.15C835.935,324.634 834.014,325.53 831.763,325.53C829.377,325.53 827.183,324.467 825.804,322.795C824.453,324.045 822.618,324.807 820.597,324.807C817.962,324.807 815.587,323.485 814.25,321.545C812.909,323.485 810.571,324.807 807.913,324.807C805.896,324.807 804.066,324.045 802.711,322.795C801.336,324.467 799.161,325.53 796.752,325.53C794.505,325.53 792.594,324.634 791.224,323.15C790.166,325.583 787.459,327.255 784.48,327.255C783.091,327.255 781.802,326.881 780.696,326.225C780.125,327.643 779.024,328.893 777.486,329.128C776.025,329.381 774.186,328.639 772.974,327.93C770.761,326.661 768.141,322.675 768.141,322.675L768.481,320.683C768.481,320.683 769.832,322.307 772.298,324.246C774.775,326.206 776.648,326.071 776.648,326.071C778.272,325.803 778.961,324.314 778.961,322.661L778.961,320.989L780.02,322.34C780.93,323.624 782.477,324.486 784.226,324.486C787.033,324.486 789.294,322.34 789.294,319.686C789.294,318.891 789.15,318.149 788.796,317.507L789.687,315.394L791.344,317.052C791.309,317.253 791.309,317.454 791.309,317.66C791.309,320.429 793.666,322.675 796.564,322.675C799.193,322.675 801.493,320.951 801.833,318.436C801.905,318.47 801.883,316.525 802.063,316.525C802.298,316.491 802.724,318.369 802.796,318.316C803.49,320.328 805.488,321.78 807.84,321.78C810.771,321.78 813.142,319.533 813.142,316.764C813.142,316.137 813.107,315.548 812.893,314.992L814.268,314.753L814.306,314.753Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path714-7-0",
    d: "M814.234,327.796C799.893,327.81 787.012,329.516 777.758,332.255C777.135,332.457 776.378,331.982 776.172,331.427C775.971,330.838 776.421,330.11 777.02,329.908C786.337,327.068 799.538,325.276 814.234,325.262C828.916,325.276 842.184,327.068 851.482,329.908C852.1,330.11 852.55,330.838 852.354,331.427C852.157,331.982 851.372,332.457 850.768,332.255C841.509,329.516 828.576,327.81 814.234,327.796",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path715-5-4",
    d: "M814.234,327.796C799.893,327.81 787.012,329.516 777.758,332.255C777.135,332.457 776.378,331.982 776.172,331.427C775.971,330.838 776.421,330.11 777.02,329.908C786.337,327.068 799.538,325.276 814.234,325.262C828.916,325.276 842.184,327.068 851.482,329.908C852.1,330.11 852.55,330.838 852.354,331.427C852.157,331.982 851.372,332.457 850.768,332.255C841.509,329.516 828.576,327.81 814.234,327.796Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path716-7-0",
    d: "M800.357,332.878C800.357,331.8 801.287,330.919 802.446,330.919C803.586,330.919 804.515,331.8 804.515,332.878C804.515,333.975 803.586,334.837 802.446,334.837C801.287,334.837 800.357,333.975 800.357,332.878",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path717-1-1",
    d: "M800.357,332.878C800.357,331.8 801.287,330.919 802.446,330.919C803.586,330.919 804.515,331.8 804.515,332.878C804.515,333.975 803.586,334.837 802.446,334.837C801.287,334.837 800.357,333.975 800.357,332.878Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path718-1-2",
    d: "M814.411,333.726L809.794,333.726C808.936,333.726 808.223,333.051 808.223,332.236C808.223,331.441 808.917,330.785 809.775,330.785L819.106,330.785C819.963,330.785 820.634,331.441 820.634,332.236C820.634,333.051 819.944,333.726 819.087,333.726L814.411,333.726",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path719-4-5",
    d: "M814.411,333.726L809.794,333.726C808.936,333.726 808.223,333.051 808.223,332.236C808.223,331.441 808.917,330.785 809.775,330.785L819.106,330.785C819.963,330.785 820.634,331.441 820.634,332.236C820.634,333.051 819.944,333.726 819.087,333.726L814.411,333.726",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path720-4-9",
    d: "M791.299,335.312L787.999,335.8C787.151,335.92 786.356,335.379 786.212,334.569C786.088,333.774 786.653,333.031 787.496,332.912L790.811,332.423L794.197,331.901C795.045,331.8 795.826,332.323 795.97,333.118C796.094,333.908 795.505,334.67 794.667,334.789L791.299,335.312",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path721-6-5",
    d: "M791.299,335.312L787.999,335.8C787.151,335.92 786.356,335.379 786.212,334.569C786.088,333.774 786.653,333.031 787.496,332.912L790.811,332.423L794.197,331.901C795.045,331.8 795.826,332.323 795.97,333.118C796.094,333.908 795.505,334.67 794.667,334.789L791.299,335.312",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path722-7-3",
    d: "M777.968,337.625L779.434,335.264L782.576,335.853L780.751,338.506L777.968,337.625",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path723-7-5",
    d: "M777.968,337.625L779.434,335.264L782.576,335.853L780.751,338.506C779.824,338.213 778.896,337.919 777.968,337.625Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path724-2-2",
    d: "M823.977,332.878C823.977,331.8 824.921,330.919 826.061,330.919C827.206,330.919 828.149,331.8 828.149,332.878C828.149,333.975 827.206,334.837 826.061,334.837C824.921,334.837 823.977,333.975 823.977,332.878",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path725-7-1",
    d: "M823.977,332.878C823.977,331.8 824.921,330.919 826.061,330.919C827.206,330.919 828.149,331.8 828.149,332.878C828.149,333.975 827.206,334.837 826.061,334.837C824.921,334.837 823.977,333.975 823.977,332.878Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path726-4-6",
    d: "M837.193,335.312L840.513,335.8C841.351,335.92 842.132,335.379 842.275,334.569C842.395,333.774 841.849,333.031 841.011,332.912L837.691,332.423L834.305,331.901C833.447,331.8 832.662,332.323 832.537,333.118C832.394,333.908 833.002,334.67 833.84,334.789L837.193,335.312",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path727-5-6",
    d: "M837.193,335.312L840.513,335.8C841.351,335.92 842.132,335.379 842.275,334.569C842.395,333.774 841.849,333.031 841.011,332.912L837.691,332.423L834.305,331.901C833.447,331.8 832.662,332.323 832.537,333.118C832.394,333.908 833.002,334.67 833.84,334.789L837.193,335.312",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path728-2-0",
    d: "M850.251,337.759L849.073,335.244L845.854,335.513L847.396,338.334L850.251,337.759",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729-4-3",
    d: "M850.141,337.605L849.073,335.244L845.854,335.513L847.396,338.334C848.373,338.116 849.313,337.793 850.141,337.605Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path730-5-9",
    d: "M814.215,346.477C802.642,346.463 792.171,345.447 784.196,343.388C792.171,341.342 802.642,340.078 814.215,340.044C825.793,340.059 836.317,341.328 844.268,343.388C836.317,345.447 825.793,346.463 814.215,346.477",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path738-1-5",
    d: "M814.215,346.477C802.642,346.463 792.171,345.447 784.196,343.388C792.171,341.342 802.642,340.078 814.215,340.044C825.793,340.059 836.317,341.328 844.268,343.388C836.317,345.447 825.793,346.463 814.215,346.477Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path739-2-8",
    d: "M850.716,321.377C851.018,320.482 850.751,319.6 850.083,319.38C849.441,319.198 848.68,319.773 848.378,320.63C848.057,321.545 848.338,322.441 848.982,322.642C849.624,322.829 850.409,322.273 850.716,321.377",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path740-2-5",
    d: "M850.716,321.377C851.018,320.482 850.751,319.6 850.083,319.38C849.441,319.198 848.68,319.773 848.378,320.63C848.057,321.545 848.338,322.441 848.982,322.642C849.624,322.829 850.409,322.273 850.716,321.377Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path741-1-9",
    d: "M827.666,316.918C827.79,315.988 827.326,315.16 826.65,315.074C825.989,314.992 825.328,315.701 825.223,316.63C825.098,317.56 825.544,318.383 826.224,318.47C826.899,318.537 827.541,317.828 827.666,316.918",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path742-8-3",
    d: "M827.666,316.918C827.79,315.988 827.326,315.16 826.65,315.074C825.989,314.992 825.328,315.701 825.223,316.63C825.098,317.56 825.544,318.383 826.224,318.47C826.899,318.537 827.541,317.828 827.666,316.918Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path743-1-6",
    d: "M800.913,316.918C800.788,315.988 801.229,315.16 801.909,315.074C802.59,314.992 803.227,315.701 803.356,316.63C803.456,317.56 803.016,318.383 802.355,318.47C801.679,318.537 801.033,317.828 800.913,316.918",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path744-2-4",
    d: "M800.913,316.918C800.788,315.988 801.229,315.16 801.909,315.074C802.59,314.992 803.227,315.701 803.356,316.63C803.456,317.56 803.016,318.383 802.355,318.47C801.679,318.537 801.033,317.828 800.913,316.918Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path745-8-8",
    d: "M777.863,321.377C777.542,320.482 777.828,319.6 778.471,319.38C779.108,319.198 779.894,319.773 780.201,320.63C780.503,321.545 780.236,322.441 779.597,322.642C778.936,322.829 778.165,322.273 777.863,321.377",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path746-1-7",
    d: "M777.863,321.377C777.542,320.482 777.828,319.6 778.471,319.38C779.108,319.198 779.894,319.773 780.201,320.63C780.503,321.545 780.236,322.441 779.597,322.642C778.936,322.829 778.165,322.273 777.863,321.377Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path748-3-4",
    d: "M814.215,303.606L810.134,306.068L813.161,312.64L814.215,313.335L815.255,312.64L818.301,306.068C816.939,305.248 815.591,304.404 814.215,303.606Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path750-6-2",
    d: "M805.258,313.536L807.121,316.242L813.487,314.278L814.162,313.387L813.487,312.473L807.121,310.614C806.467,311.569 805.835,312.534 805.258,313.536Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path752-5-7",
    d: "M823.206,313.536L821.333,316.242L814.967,314.278L814.292,313.387L814.967,312.473L821.333,310.614C821.988,311.569 822.596,312.552 823.206,313.536Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path754-8-6",
    d: "M787.649,306.528L784.449,309.551L788.55,314.959L789.637,315.394L790.442,314.566L791.884,308.032C790.478,307.514 789.066,307.015 787.649,306.528Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path756-5-8",
    d: "M780.933,317.373L783.338,319.634L789.153,316.491L789.599,315.481L788.765,314.719L782.112,314.144C781.667,315.201 781.307,316.289 780.933,317.373Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path758-0-4",
    d: "M798.484,313.842L797.253,316.831L790.595,316.223L789.728,315.462L790.188,314.432L796.022,311.356C796.869,312.16 797.674,313.004 798.484,313.842Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path760-5-7",
    d: "M774.529,318.216L773.978,321.377L767.315,322.067L766.305,321.492L766.559,320.414L771.564,316.257C772.529,316.946 773.529,317.58 774.529,318.216Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path761-7-8",
    d: "M787.357,315.495C787.357,314.264 788.406,313.268 789.69,313.268C790.993,313.268 792.027,314.264 792.027,315.495C792.027,316.712 790.993,317.708 789.69,317.708C788.406,317.708 787.357,316.712 787.357,315.495",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path762-5-3",
    d: "M787.357,315.495C787.357,314.264 788.406,313.268 789.69,313.268C790.993,313.268 792.027,314.264 792.027,315.495C792.027,316.712 790.993,317.708 789.69,317.708C788.406,317.708 787.357,316.712 787.357,315.495Z",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path764-1-8",
    d: "M840.867,306.528L844.077,309.551L839.971,314.959L838.884,315.394L838.084,314.566L836.638,308.032C838.064,307.577 839.468,307.06 840.867,306.528Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path766-2-7",
    d: "M847.593,317.373L845.183,319.634L839.368,316.491L838.903,315.481L839.761,314.719L846.414,314.144C846.877,315.216 847.209,316.273 847.593,317.373Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path768-7-9",
    d: "M830.037,313.842L831.268,316.831L837.926,316.223L838.779,315.462L838.333,314.432L832.504,311.356C831.694,312.198 830.867,313.021 830.037,313.842Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path769-4-2",
    d: "M853.101,318.216L853.638,321.377L860.286,322.067L861.287,321.492L861.038,320.414L856.047,316.257L853.101,318.216",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path770-1-5",
    d: "M853.101,318.216L853.638,321.377L860.286,322.067L861.287,321.492L861.038,320.414L856.047,316.257C855.059,316.901 854.071,317.544 853.101,318.216Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path771-5-9",
    d: "M811.916,313.402C811.916,312.152 812.946,311.174 814.253,311.174C815.518,311.174 816.591,312.152 816.591,313.402C816.591,314.618 815.532,315.615 814.253,315.615C812.946,315.615 811.916,314.618 811.916,313.402",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path772-0-6",
    d: "M811.916,313.402C811.916,312.152 812.946,311.174 814.253,311.174C815.518,311.174 816.591,312.152 816.591,313.402C816.591,314.618 815.532,315.615 814.253,315.615C812.946,315.615 811.916,314.618 811.916,313.402Z",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path773-6-8",
    d: "M836.532,315.495C836.532,314.264 837.581,313.268 838.87,313.268C840.168,313.268 841.226,314.264 841.226,315.495C841.226,316.712 840.168,317.708 838.87,317.708C837.581,317.708 836.532,316.712 836.532,315.495",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path774-8-4",
    d: "M836.532,315.495C836.532,314.264 837.581,313.268 838.87,313.268C840.168,313.268 841.226,314.264 841.226,315.495C841.226,316.712 840.168,317.708 838.87,317.708C837.581,317.708 836.532,316.712 836.532,315.495Z",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path782-4-6",
    d: "M765.303,321.613C764.672,320.764 763.57,319.486 762.401,318.436C761.471,317.607 759.191,316.899 759.191,316.899C759.191,316.477 760.528,315.529 761.974,315.529C762.813,315.529 763.612,315.883 764.087,316.477L764.254,315.562C764.254,315.562 765.433,315.782 765.95,317.085C766.486,318.436 766.146,320.482 766.146,320.482C765.96,320.914 765.572,321.227 765.303,321.613Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path784-2-3",
    d: "M765.61,320.75C766.166,320.175 767.306,320.295 768.144,321.023C769.001,321.746 769.25,322.809 768.69,323.403C768.144,323.993 767.018,323.859 766.166,323.13C765.303,322.407 765.059,321.325 765.61,320.75Z",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path785-2-1",
    d: "M862.087,321.914C862.159,321.966 863.888,319.619 865.215,318.436C866.125,317.607 868.425,316.899 868.425,316.899C868.425,316.477 867.088,315.529 865.642,315.529C864.803,315.529 863.999,315.883 863.52,316.477L863.343,315.562C863.343,315.562 862.159,315.782 861.647,317.085C861.115,318.436 861.446,320.482 861.446,320.482C861.446,320.482 861.661,321.425 862.088,321.914",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path786-0-7",
    d: "M862.087,321.914C862.159,321.966 863.888,319.619 865.215,318.436C866.125,317.607 868.425,316.899 868.425,316.899C868.425,316.477 867.088,315.529 865.642,315.529C864.803,315.529 863.999,315.883 863.52,316.477L863.343,315.562C863.343,315.562 862.159,315.782 861.647,317.085C861.115,318.436 861.446,320.482 861.446,320.482C861.426,321.073 861.694,321.253 862.087,321.914Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path787-6-6",
    d: "M862.15,320.75C861.589,320.175 860.454,320.295 859.597,321.023C858.739,321.746 858.509,322.809 859.041,323.403C859.597,323.993 860.737,323.859 861.589,323.13C862.447,322.407 862.701,321.325 862.15,320.75",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path788-4-0",
    d: "M862.15,320.75C861.589,320.175 860.454,320.295 859.597,321.023C858.739,321.746 858.509,322.809 859.041,323.403C859.597,323.993 860.737,323.859 861.589,323.13C862.447,322.407 862.701,321.325 862.15,320.75Z",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3251-9",
    transform: "matrix(1,0,0,1,0,-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path780-3-4",
    d: "M816.027,283.082C818.444,283.737 820.199,285.867 820.199,288.379C820.199,291.425 817.592,293.892 814.349,293.892C811.131,293.892 808.524,291.425 808.524,288.379C808.524,285.822 810.349,283.692 812.835,283.037",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path779-5-7",
    d: "M820.39,286.932L820.39,289.686L808.333,289.686L808.333,286.932L812.792,286.932L812.792,280.714L809.847,280.714L809.847,277.946L812.792,277.946L812.792,275.225L815.7,275.225L815.7,277.946L818.603,277.946L818.603,280.714L815.7,280.714L815.7,286.932L820.39,286.932Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2639-2-2",
    transform: "matrix(0.924528,0,0,0.924528,635.113,134.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2640-9-4",
    d: "M193.384,229.571L193.384,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2641-4-0",
    d: "M191.612,229.571L191.612,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2642-9-5",
    d: "M189.94,229.571L189.94,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2643-5-8",
    d: "M188.282,229.571L188.282,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2644-3-1",
    d: "M186.805,229.571L186.805,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2645-9-3",
    d: "M183.987,229.22L183.948,223.283M185.323,229.298L185.323,223.088",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2646-4-64",
    d: "M181.386,228.953L181.386,223.483M182.704,229.109L182.665,223.288",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2647-6-7",
    d: "M177.897,228.64L177.897,223.835M179.042,228.718L179.042,223.679M180.221,228.875L180.221,223.639",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2648-7-5",
    d: "M176.673,228.601L176.673,223.952",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2649-1-1",
    d: "M175.533,228.697L175.533,223.61",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2650-4-5",
    d: "M174.31,228.549L174.31,223.805",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2651-8-8",
    d: "M171.806,228.138L171.767,224.124M173.089,228.384L173.089,223.95",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2652-4-4",
    d: "M170.522,228.045L170.522,224.421",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2653-0-7",
    d: "M169.347,228.086L169.347,224.604",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2654-7-2",
    d: "M168.064,227.414L168.064,224.799",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2655-2-3",
    d: "M166.745,227.438L166.745,225.051",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2656-9-6",
    d: "M165.349,227.126L165.349,225.352",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2657-0-94",
    d: "M200.432,229.22L200.432,223.244M197.431,229.415L197.47,223.088M195.244,229.493L195.244,223.049",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.11px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3183-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path647-5",
    x: 42.27,
    y: 338.331,
    width: 106.024,
    height: 27.792,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path648",
    x: 42.27,
    y: 338.331,
    width: 106.024,
    height: 27.792,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path649-5",
    d: "M53.398,384.618C54.059,384.349 54.543,384.316 55.362,384.316L134.758,384.316C135.543,384.316 136.29,384.45 136.913,384.704C134.202,383.794 132.243,381.327 132.243,378.419C132.243,375.517 134.365,372.997 137.11,372.053C136.487,372.255 135.558,372.441 134.81,372.441L55.362,372.441C54.557,372.441 53.791,372.408 53.134,372.187L53.561,372.254C56.396,373.131 58.02,375.651 58.02,378.419C58.02,381.087 56.219,383.76 53.398,384.618",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "M53.398,384.618C54.059,384.349 54.543,384.316 55.362,384.316L134.758,384.316C135.543,384.316 136.29,384.45 136.913,384.704C134.202,383.794 132.243,381.327 132.243,378.419C132.243,375.517 134.365,372.997 137.11,372.053C136.487,372.255 135.558,372.441 134.81,372.441L55.362,372.441C54.557,372.441 53.791,372.408 53.134,372.187L53.561,372.254C56.396,373.131 58.02,375.651 58.02,378.419C58.02,381.087 56.219,383.76 53.398,384.618L53.398,384.618Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path651-5",
    d: "M55.362,384.316L134.758,384.316C137.45,384.316 139.624,385.988 139.624,388.033C139.624,390.093 137.45,391.764 134.758,391.764L55.362,391.764C52.67,391.764 50.49,390.093 50.49,388.033C50.49,385.988 52.67,384.316 55.362,384.316",
    style: {
      fill: "rgb(159,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    d: "M55.362,384.316L134.758,384.316C137.45,384.316 139.624,385.988 139.624,388.033C139.624,390.093 137.45,391.764 134.758,391.764L55.362,391.764C52.67,391.764 50.49,390.093 50.49,388.033C50.49,385.988 52.67,384.316 55.362,384.316Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path653-4",
    d: "M55.362,366.123L134.81,366.123C137.488,366.123 139.682,367.541 139.682,369.266C139.682,371.019 137.488,372.441 134.81,372.441L55.362,372.441C52.67,372.441 50.49,371.019 50.49,369.266C50.49,367.541 52.67,366.123 55.362,366.123",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    d: "M55.362,366.123L134.81,366.123C137.488,366.123 139.682,367.541 139.682,369.266C139.682,371.019 137.488,372.441 134.81,372.441L55.362,372.441C52.67,372.441 50.49,371.019 50.49,369.266C50.49,367.541 52.67,366.123 55.362,366.123Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path665-1",
    d: "M53.398,786.733C53.652,787.696 54.006,788.644 54.006,789.674C54.006,796.634 47.995,802.171 40.647,802.171L149.76,802.171C142.407,802.171 136.396,796.634 136.396,789.674C136.396,788.659 136.592,787.696 136.846,786.733C136.219,786.953 135.471,786.987 134.758,786.987L55.362,786.987C54.72,786.987 53.973,786.92 53.398,786.733",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    d: "M53.398,786.733C53.652,787.696 54.006,788.644 54.006,789.674C54.006,796.634 47.995,802.171 40.647,802.171L149.76,802.171C142.407,802.171 136.396,796.634 136.396,789.674C136.396,788.659 136.592,787.696 136.846,786.733C136.219,786.953 135.471,786.987 134.758,786.987L55.362,786.987C54.72,786.987 53.973,786.92 53.398,786.733L53.398,786.733Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path667-2",
    d: "M55.362,779.519L134.758,779.519C137.45,779.519 139.624,781.21 139.624,783.255C139.624,785.315 137.45,786.987 134.758,786.987L55.362,786.987C52.67,786.987 50.49,785.315 50.49,783.255C50.49,781.21 52.67,779.519 55.362,779.519",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    d: "M55.362,779.519L134.758,779.519C137.45,779.519 139.624,781.21 139.624,783.255C139.624,785.315 137.45,786.987 134.758,786.987L55.362,786.987C52.67,786.987 50.49,785.315 50.49,783.255C50.49,781.21 52.67,779.519 55.362,779.519Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path669-6",
    x: 40.79,
    y: 802.171,
    width: 108.826,
    height: 27.758,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path670",
    x: 40.79,
    y: 802.171,
    width: 108.826,
    height: 27.758,
    style: {
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path671-2",
    d: "M32.278,681.29C21.505,687.507 14.21,693.873 15.388,697.049C15.977,699.971 19.402,702.15 24.288,705.393C31.976,710.748 36.652,720.309 32.992,724.721C39.363,719.586 43.391,711.917 43.391,703.386C43.391,694.467 39.147,686.425 32.278,681.29",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    d: "M32.278,681.29C21.505,687.507 14.21,693.873 15.388,697.049C15.977,699.971 19.402,702.15 24.288,705.393C31.976,710.748 36.652,720.309 32.992,724.721C39.363,719.586 43.391,711.917 43.391,703.386C43.391,694.467 39.147,686.425 32.278,681.29Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path673-6",
    x: 56.377,
    y: 396.176,
    width: 77.327,
    height: 378.85,
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "M111.497,396.698L111.497,774.724M120.181,396.698L120.181,774.724",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path675-5",
    x: 56.377,
    y: 396.176,
    width: 77.327,
    height: 378.85,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    d: "M212.688,537.885C195.817,530.911 167.134,525.742 134.221,524.66C122.878,524.746 110.232,525.809 97.175,527.989C50.921,535.706 15.69,554.171 18.492,569.207C18.545,569.528 18.65,570.184 18.722,570.472C18.722,570.472 1.387,531.399 1.099,529.914C-1.985,513.226 37.097,492.715 88.433,484.15C104.542,481.463 120.253,480.419 133.9,480.553C166.741,480.553 195.281,484.759 212.472,491.144L212.688,537.885",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path677-4",
    d: "M212.688,537.885C195.817,530.911 167.134,525.742 134.221,524.66C122.878,524.746 110.232,525.809 97.175,527.989C50.921,535.706 15.69,554.171 18.492,569.207C18.545,569.528 18.65,570.184 18.722,570.472C18.722,570.472 1.387,531.399 1.099,529.914C-1.985,513.226 37.097,492.715 88.433,484.15C104.542,481.463 120.253,480.419 133.9,480.553C166.741,480.553 195.281,484.759 212.472,491.144L212.688,537.885",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "M56.253,585.441C34.812,583.903 20.169,578.174 18.492,569.207C17.17,562.06 24.413,554.157 37.365,546.977C43.142,547.599 49.652,548.394 56.377,548.394L56.253,585.441",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path679-9",
    d: "M56.253,585.441C34.812,583.903 20.169,578.174 18.492,569.207C17.17,562.06 24.413,554.157 37.365,546.977C43.142,547.599 49.652,548.394 56.377,548.394L56.253,585.441",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    d: "M133.848,556.485C147.241,558.511 157.305,561.84 162.315,565.931L162.761,566.755C165.151,571.655 153.382,582.078 133.723,593.718L133.848,556.485",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path681-0",
    d: "M133.848,556.485C147.241,558.511 157.305,561.84 162.315,565.931L162.761,566.755C165.151,571.655 153.382,582.078 133.723,593.718L133.848,556.485",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    d: "M8.218,658.518C6.182,652.401 27.091,640.157 56.645,629.313C70.149,624.48 81.295,619.445 95.12,613.347C136.166,595.203 166.492,574.376 162.761,566.774L162.353,565.998C164.547,567.77 167.934,605.185 167.934,605.185C171.68,612.145 143.926,632.671 106.127,650.782C94.032,656.559 68.491,666 56.43,670.225C34.865,677.707 13.424,691.813 15.388,697.049L8.218,658.537",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path683-2",
    d: "M8.218,658.518C6.182,652.401 27.091,640.157 56.645,629.313C70.149,624.48 81.295,619.445 95.12,613.347C136.166,595.203 166.492,574.376 162.761,566.774L162.353,565.998C164.547,567.77 167.934,605.185 167.934,605.185C171.68,612.145 143.926,632.671 106.127,650.782C94.032,656.559 68.491,666 56.43,670.225C34.865,677.707 13.424,691.813 15.388,697.049L8.218,658.537L8.218,658.517L8.218,658.518Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    d: "M51.046,519.712C60.501,516.263 66.69,512.191 63.658,504.743C61.747,500.015 56.861,499.1 49.566,501.773L36.632,506.467L48.282,535.169C49.547,534.594 50.811,534 52.133,533.512C53.436,533.038 54.811,532.683 56.147,532.295L51.046,519.726L51.046,519.711L51.046,519.712ZM45.427,505.859L48.689,504.676C51.4,503.679 54.471,505.116 55.826,508.46C56.842,511.013 56.574,513.849 53.455,515.841C52.435,516.469 51.261,516.938 50.117,517.398L45.427,505.859",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path685-4",
    d: "M81.262,493.85C79.906,494.219 78.551,494.626 77.176,494.894C75.806,495.167 74.393,495.316 73.004,495.503L79.71,525.354L100.561,521.163C100.312,520.574 99.991,519.946 99.867,519.338C99.723,518.715 99.742,518.021 99.704,517.398C96.049,518.442 92.054,519.577 87.254,520.54L81.281,493.85",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    d: "M123.022,519.592C126.964,508.766 131.726,498.391 136.415,487.886C135.577,488.02 134.686,488.14 133.848,488.188C133.009,488.241 132.099,488.255 131.261,488.223C128.765,495.844 125.661,503.461 122.394,511.048C118.471,503.849 114.136,496.822 110.836,489.574C109.212,489.78 107.555,490.015 105.912,490.135C104.293,490.235 102.597,490.216 100.973,490.235C106.985,500.031 112.781,509.798 118.275,519.9C119.041,519.761 119.827,519.579 120.66,519.526C121.432,519.474 122.236,519.546 123.022,519.579",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path687-1",
    d: "M166.617,496.619C167.345,495.167 168.078,493.745 168.897,492.394C167.776,491.33 164.332,489.779 160.298,489.371C151.791,488.528 146.905,492.312 146.335,497.447C145.138,508.191 162.1,507.262 161.319,514.39C160.979,517.465 157.712,518.715 154.253,518.375C150.383,517.987 147.566,515.86 147.063,512.699L146.014,512.598C145.459,514.476 144.64,516.282 143.763,518.088C146.24,519.692 149.473,520.607 152.558,520.909C161.228,521.771 167.848,518.294 168.47,512.584C169.596,502.376 152.471,501.787 153.128,495.776C153.415,493.242 155.36,491.584 159.781,492.025C162.957,492.346 164.921,494.066 165.778,496.533L166.617,496.619",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path655-1",
    d: "M169.29,833.795C161.961,833.795 155.432,832.258 150.613,829.69C145.832,827.257 139.361,825.772 132.224,825.772C125.053,825.772 118.419,827.276 113.638,829.724C108.838,832.243 102.204,833.795 94.961,833.795C87.628,833.795 81.104,832.09 76.285,829.523C71.543,827.19 65.191,825.772 58.236,825.772C51.046,825.772 44.661,827.142 39.88,829.623C35.061,832.176 28.393,833.795 21.079,833.795L21.079,845.282C28.393,845.282 35.061,843.61 39.88,841.076C44.661,838.609 51.046,837.211 58.236,837.211C65.172,837.211 71.524,838.643 76.285,840.995C81.085,843.543 87.628,845.282 94.961,845.282C102.204,845.282 108.838,843.696 113.638,841.196C118.419,838.715 125.053,837.211 132.224,837.211C139.361,837.211 145.832,838.715 150.613,841.162C155.432,843.73 161.85,845.282 169.203,845.282L169.289,833.795",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    d: "M169.29,833.795C161.961,833.795 155.432,832.258 150.613,829.69C145.832,827.257 139.361,825.772 132.224,825.772C125.053,825.772 118.419,827.276 113.638,829.724C108.838,832.243 102.204,833.795 94.961,833.795C87.628,833.795 81.104,832.09 76.285,829.523C71.543,827.19 65.191,825.772 58.236,825.772C51.046,825.772 44.661,827.142 39.88,829.623C35.061,832.176 28.393,833.795 21.079,833.795L21.079,845.282C28.393,845.282 35.061,843.61 39.88,841.076C44.661,838.609 51.046,837.211 58.236,837.211C65.172,837.211 71.524,838.643 76.285,840.995C81.085,843.543 87.628,845.282 94.961,845.282C102.204,845.282 108.838,843.696 113.638,841.196C118.419,838.715 125.053,837.211 132.224,837.211C139.361,837.211 145.832,838.715 150.613,841.162C155.432,843.73 161.85,845.282 169.203,845.282L169.289,833.795L169.29,833.795Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path657-1",
    d: "M169.29,845.282C161.961,845.282 155.432,843.73 150.613,841.162C145.832,838.715 139.361,837.211 132.224,837.211C125.053,837.211 118.419,838.715 113.638,841.196C108.838,843.696 102.204,845.282 94.961,845.282C87.628,845.282 81.104,843.543 76.285,840.995C71.543,838.643 65.191,837.211 58.236,837.211C51.046,837.211 44.661,838.609 39.88,841.076C35.061,843.61 28.393,845.282 21.079,845.282L21.079,856.735C28.393,856.735 35.061,855.097 39.88,852.563C44.661,850.062 51.046,848.678 58.236,848.678C65.172,848.678 71.524,850.115 76.285,852.462C81.085,855.015 87.628,856.735 94.961,856.735C102.204,856.735 108.838,855.149 113.638,852.649C118.419,850.182 125.053,848.678 132.224,848.678C139.361,848.678 145.832,850.182 150.613,852.63C155.432,855.183 161.85,856.735 169.203,856.735L169.289,845.282",
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    d: "M169.29,845.282C161.961,845.282 155.432,843.73 150.613,841.162C145.832,838.715 139.361,837.211 132.224,837.211C125.053,837.211 118.419,838.715 113.638,841.196C108.838,843.696 102.204,845.282 94.961,845.282C87.628,845.282 81.104,843.543 76.285,840.995C71.543,838.643 65.191,837.211 58.236,837.211C51.046,837.211 44.661,838.609 39.88,841.076C35.061,843.61 28.393,845.282 21.079,845.282L21.079,856.735C28.393,856.735 35.061,855.097 39.88,852.563C44.661,850.062 51.046,848.678 58.236,848.678C65.172,848.678 71.524,850.115 76.285,852.462C81.085,855.015 87.628,856.735 94.961,856.735C102.204,856.735 108.838,855.149 113.638,852.649C118.419,850.182 125.053,848.678 132.224,848.678C139.361,848.678 145.832,850.182 150.613,852.63C155.432,855.183 161.85,856.735 169.203,856.735L169.289,845.282",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path659-6",
    d: "M169.29,856.735C161.961,856.735 155.432,855.183 150.613,852.63C145.832,850.182 139.361,848.678 132.224,848.678C125.053,848.678 118.419,850.182 113.638,852.649C108.838,855.149 102.204,856.735 94.961,856.735C87.628,856.735 81.104,855.015 76.285,852.462C71.543,850.115 65.191,848.678 58.236,848.678C51.046,848.678 44.661,850.062 39.88,852.563C35.061,855.097 28.393,856.735 21.079,856.735L21.079,868.188C28.393,868.188 35.061,866.55 39.88,864.001C44.661,861.534 51.046,860.15 58.236,860.15C65.172,860.15 71.524,861.587 76.285,863.915C81.085,866.483 87.628,868.188 94.961,868.188C102.204,868.188 108.838,866.621 113.638,864.121C118.419,861.654 125.053,860.15 132.224,860.15C139.361,860.15 145.832,861.635 150.613,864.088C155.432,866.669 161.85,868.188 169.203,868.188L169.289,856.735",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660-7",
    d: "M169.29,856.735C161.961,856.735 155.432,855.183 150.613,852.63C145.832,850.182 139.361,848.678 132.224,848.678C125.053,848.678 118.419,850.182 113.638,852.649C108.838,855.149 102.204,856.735 94.961,856.735C87.628,856.735 81.104,855.015 76.285,852.462C71.543,850.115 65.191,848.678 58.236,848.678C51.046,848.678 44.661,850.062 39.88,852.563C35.061,855.097 28.393,856.735 21.079,856.735L21.079,868.188C28.393,868.188 35.061,866.55 39.88,864.001C44.661,861.534 51.046,860.15 58.236,860.15C65.172,860.15 71.524,861.587 76.285,863.915C81.085,866.483 87.628,868.188 94.961,868.188C102.204,868.188 108.838,866.621 113.638,864.121C118.419,861.654 125.053,860.15 132.224,860.15C139.361,860.15 145.832,861.635 150.613,864.088C155.432,866.669 161.85,868.188 169.203,868.188L169.289,856.735",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path661-9",
    d: "M169.203,879.66C161.85,879.66 155.432,878.108 150.613,875.541C145.832,873.107 139.361,871.618 132.224,871.618C125.053,871.618 118.419,873.107 113.638,875.574C108.838,878.074 102.204,879.66 94.961,879.66C87.628,879.66 81.104,877.936 76.285,875.368C71.543,873.04 65.191,871.618 58.236,871.618C51.046,871.618 44.661,873.007 39.88,875.469C35.061,878.022 28.393,879.66 21.079,879.66L21.079,868.26C28.393,868.26 35.061,866.55 39.88,864.001C44.661,861.534 51.046,860.15 58.236,860.15C65.172,860.15 71.524,861.587 76.285,863.915C81.085,866.483 87.628,868.188 94.961,868.188C102.204,868.188 108.838,866.621 113.638,864.121C118.419,861.654 125.053,860.15 132.224,860.15C139.361,860.15 145.832,861.635 150.613,864.088C155.432,866.669 161.961,868.188 169.29,868.188L169.203,879.66",
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    d: "M169.203,879.66C161.85,879.66 155.432,878.108 150.613,875.541C145.832,873.107 139.361,871.618 132.224,871.618C125.053,871.618 118.419,873.107 113.638,875.574C108.838,878.074 102.204,879.66 94.961,879.66C87.628,879.66 81.104,877.936 76.285,875.368C71.543,873.04 65.191,871.618 58.236,871.618C51.046,871.618 44.661,873.007 39.88,875.469C35.061,878.022 28.393,879.66 21.079,879.66L21.079,868.26C28.393,868.26 35.061,866.55 39.88,864.001C44.661,861.534 51.046,860.15 58.236,860.15C65.172,860.15 71.524,861.587 76.285,863.915C81.085,866.483 87.628,868.188 94.961,868.188C102.204,868.188 108.838,866.621 113.638,864.121C118.419,861.654 125.053,860.15 132.224,860.15C139.361,860.15 145.832,861.635 150.613,864.088C155.432,866.669 161.961,868.188 169.29,868.188L169.203,879.66",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path663-9",
    d: "M169.203,891.132C161.85,891.132 155.432,889.575 150.613,887.027C145.832,884.56 139.361,883.056 132.224,883.056C125.053,883.056 118.419,884.575 113.638,887.041C108.838,889.542 102.204,891.132 94.961,891.132C87.628,891.132 81.104,889.389 76.285,886.84C71.543,884.493 65.191,883.056 58.236,883.056C51.046,883.056 44.661,884.46 39.88,886.941C35.061,889.475 28.393,891.132 21.079,891.132L21.079,879.761C28.393,879.761 35.061,878.022 39.88,875.469C44.661,873.007 51.046,871.637 58.236,871.637C65.172,871.637 71.524,873.055 76.285,875.387C81.085,877.936 87.628,879.66 94.961,879.66C102.204,879.66 108.838,878.074 113.638,875.574C118.419,873.107 125.053,871.637 132.224,871.637C139.361,871.637 145.832,873.107 150.613,875.555C155.432,878.108 161.922,879.66 169.27,879.66L169.203,891.132",
    style: {
      fill: "rgb(0,91,191)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    d: "M169.203,891.132C161.85,891.132 155.432,889.575 150.613,887.027C145.832,884.56 139.361,883.056 132.224,883.056C125.053,883.056 118.419,884.575 113.638,887.041C108.838,889.542 102.204,891.132 94.961,891.132C87.628,891.132 81.104,889.389 76.285,886.84C71.543,884.493 65.191,883.056 58.236,883.056C51.046,883.056 44.661,884.46 39.88,886.941C35.061,889.475 28.393,891.132 21.079,891.132L21.079,879.761C28.393,879.761 35.061,878.022 39.88,875.469C44.661,873.007 51.046,871.637 58.236,871.637C65.172,871.637 71.524,873.055 76.285,875.387C81.085,877.936 87.628,879.66 94.961,879.66C102.204,879.66 108.838,878.074 113.638,875.574C118.419,873.107 125.053,871.637 132.224,871.637C139.361,871.637 145.832,873.107 150.613,875.555C155.432,878.108 161.922,879.66 169.27,879.66L169.203,891.132L169.203,891.132Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.86px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path960-9",
    d: "M455.981,903.768C393.748,903.768 332.066,888.511 280.208,863.138C241.983,844.203 216.639,806.026 216.639,762.341L216.639,603.92L694.38,603.92L694.38,762.341C694.38,806.026 669.035,844.203 630.805,863.138C578.952,888.511 518.233,903.768 455.981,903.768",
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4288-7",
    transform: "matrix(1,0,0,1,4.99985,4.99999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path961-7",
    d: "M450.981,898.768C388.748,898.768 327.066,883.511 275.208,858.138C236.983,839.203 211.639,801.027 211.639,757.341L211.639,598.92L689.38,598.92L689.38,757.341C689.38,801.026 664.035,839.203 625.805,858.138C573.953,883.511 513.233,898.768 450.981,898.768Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3987-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path966-9",
    d: "M450.143,757.154C450.143,819.76 397.092,870.506 331.008,870.506C264.9,870.506 211.318,819.76 211.318,757.154L211.318,598.498L450.143,598.498L450.143,757.154",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path968-5",
    d: "M263.492,850.699C270.955,854.661 281.205,861.257 292.156,863.896L291.461,592.908L263.492,592.908L263.492,850.699Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path970-3",
    d: "M210.925,755.018C211.653,788.453 224.927,813.308 238.2,829.585L238.2,594.226L211.26,594.226L210.925,755.018L210.925,755.018Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.39px",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path972-3",
    d: "M316.738,869.836C327.684,870.937 335.846,870.717 344.708,869.836L344.708,592.908L316.738,592.908L316.738,869.836Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path974-9",
    d: "M369.3,863.896C380.25,861.697 392.594,854.881 397.969,851.36L397.969,592.908L370,592.908L369.3,863.896Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path976-1",
    d: "M423.96,826.945C435.605,816.609 446.555,793.07 450.536,766.236L451.23,592.908L423.261,592.908L423.96,826.945Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path977-8",
    d: "M450.143,757.154C450.143,819.76 397.092,870.506 331.008,870.506C264.9,870.506 211.318,819.76 211.318,757.154L211.318,598.498L450.143,598.498L450.143,757.154",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3890-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path964-4",
    x: 211.332,
    y: 333.604,
    width: 238.72,
    height: 265.048,
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3140-3",
    transform: "matrix(1,0,0,1,395.539,-428.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3007-9",
    d: "M-136.906,977.086L-136.906,957.782L-116.118,957.782L-116.35,889.66L-121.433,889.535L-126.515,889.409L-126.514,879.328C-126.513,873.783 -126.38,866.101 -126.218,862.256L-125.922,855.267L-123.621,855.265C-122.356,855.264 -119.033,855.133 -116.237,854.975L-111.155,854.688L-111.155,837.959L-120.642,837.959L-120.64,832.301C-120.639,829.189 -120.507,824.696 -120.346,822.316L-120.055,817.989L-111.607,817.989L-111.607,819.938C-111.607,822.044 -111.19,822.427 -108.896,822.427C-106.602,822.427 -106.185,822.044 -106.185,819.938L-106.185,817.989L-94.09,817.989L-93.791,819.947C-93.47,822.047 -92.989,822.427 -90.652,822.427C-88.751,822.427 -88.114,821.736 -88.114,819.675L-88.114,817.989L-79.53,817.989L-79.53,837.929L-89.243,838.181L-89.366,846.502L-89.489,854.823L-75.915,854.823L-75.915,813.551L-84.951,813.551L-84.951,793.581L-75.884,793.581L-76.184,795.8L-76.484,798.018L-74.901,798.018C-74.03,798.018 -72.682,797.894 -71.906,797.741C-70.583,797.481 -70.494,797.342 -70.494,795.522L-70.494,793.581L-58.747,793.581L-58.747,795.489C-58.747,797.875 -58.161,798.462 -55.776,798.462C-53.56,798.462 -53.086,798.007 -52.659,795.467L-52.343,793.581L-43.838,793.581L-43.838,813.551L-53.326,813.551L-53.326,854.823L-42.011,854.823L-42.257,838.181L-46.662,838.054L-51.067,837.927L-51.027,829.844C-51.005,825.398 -50.853,820.763 -50.688,819.542L-50.389,817.323L-42.031,817.068L-42.031,819.215C-42.031,821.731 -41.481,822.427 -39.493,822.427C-37.079,822.427 -36.651,822.06 -36.335,819.72L-36.041,817.545L-32.548,817.545C-30.627,817.545 -28.112,817.418 -26.959,817.263L-24.863,816.981L-24.863,822.427L-22.207,822.427C-19.228,822.427 -18.683,822.044 -18.462,819.791C-18.29,818.049 -17.882,817.869 -13.003,817.381L-9.954,817.077L-9.954,837.395L-12.05,837.677C-13.203,837.832 -15.337,837.959 -16.794,837.959L-19.441,837.959L-19.441,854.687L-13.949,854.977C-10.928,855.136 -7.167,855.267 -5.591,855.267L-2.725,855.267L-2.724,864.032C-2.723,868.852 -2.59,876.534 -2.427,881.102L-2.132,889.407L-7.059,889.534L-11.987,889.66L-11.987,957.56L-2.387,957.679L7.214,957.799L7.214,996.391L-136.908,996.391L-136.906,977.086Z",
    style: {
      fill: "rgb(43,17,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.04px",
      strokeMiterlimit: 3.864
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2511-8",
    transform: "matrix(1,0,0,1,-405.129,418.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6420-5-5",
    d: "M290.147,469.04L290.147,540.071L270.225,540.131L270.225,576.682L410.34,576.477L410.34,539.926L391.071,539.854L391.071,469.04L290.147,469.04Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6418-8-7",
    d: "M270.225,576.681L408.816,576.477",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6416-8-3",
    d: "M270.17,567.667L410.202,567.544",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6414-8-2",
    d: "M270.225,558.704L410.202,558.828",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6412-6-2",
    d: "M270.17,549.946L410.202,549.822",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6410-5-3",
    d: "M270.247,540.143L410.356,539.854",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6408-1-8",
    d: "M290.474,530.428L391.126,530.377",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6406-1-0",
    d: "M290.147,521.194L391.071,521.194",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6404-0-9",
    d: "M290.147,513.344L391.071,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6402-1-8",
    d: "M290.147,504.483L391.071,504.483",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6400-7-5",
    d: "M290.147,495.622L391.071,495.622",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6398-5-5",
    d: "M290.147,486.761L391.071,486.761",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8371-9-8",
    d: "M370.24,478.117L370.24,486.502",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6396-6-0",
    d: "M290.147,477.9L391.071,477.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6370-8-8",
    d: "M290.147,576.477L290.147,567.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6368-0-3",
    d: "M290.147,558.755L290.147,549.895",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6366-7-9",
    d: "M281.275,558.755L281.275,567.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6364-5-0",
    d: "M300.093,567.616L300.093,558.755",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6358-7-2",
    d: "M310.537,539.926L310.537,530.449",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6356-8-6",
    d: "M310.691,521.142L310.537,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6354-1-8",
    d: "M300.093,549.895L300.093,539.926",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6352-5-1",
    d: "M281.275,549.895L281.275,539.926",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6346-2-0",
    d: "M300.093,521.194L300.093,530.055",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6344-6-0",
    d: "M320.187,521.194L320.187,530.055",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6342-1-2",
    d: "M340.022,521.369L340.099,530.478",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6340-8-1",
    d: "M329.91,521.432L329.91,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6338-8-1",
    d: "M340.131,504.483L340.131,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6334-9-4",
    d: "M330.183,477.9L330.183,486.761",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6332-5-8",
    d: "M340.182,469.04L340.182,477.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6330-2-6",
    d: "M320.187,469.04L320.187,477.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6328-6-9",
    d: "M301.22,469.04L301.22,477.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6304-5-3",
    d: "M391.071,576.477L391.071,567.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6302-2-3",
    d: "M391.071,558.755L391.071,549.895",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6300-4-0",
    d: "M399.944,558.755L399.944,567.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6298-0-4",
    d: "M379.945,567.616L379.945,558.755",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6292-4-3",
    d: "M370.325,539.926L370.271,530.332",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6290-8-3",
    d: "M370.271,521.266L370.271,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6288-1-5",
    d: "M379.945,549.895L379.945,539.926",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6286-7-4",
    d: "M399.944,549.895L399.944,539.926",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6280-3-2",
    d: "M379.952,521.164L380.061,530.434",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6278-1-0",
    d: "M359.956,521.164L359.956,530.434",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6274-7-3",
    d: "M350.399,521.287L350.399,513.344",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6272-3-9",
    d: "M350.399,495.686L350.399,504.547",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6270-7-7",
    d: "M339.909,486.761L339.909,495.622",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6268-8-5",
    d: "M350.399,477.9L350.399,486.761",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6264-9-0",
    d: "M359.956,469.449L359.956,477.731",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6262-2-8",
    d: "M379.945,469.436L379.945,477.744",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6238-9-8",
    d: "M329.91,504.483L329.91,495.622",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20553-0-8",
    d: "M360.089,576.487L360.089,552.519C360.089,547.954 358.135,534.259 339.577,534.259C321.995,534.259 320.041,547.954 320.041,552.519L320.041,576.487L360.089,576.487Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20555-4-7",
    d: "M350.622,558.815L370.139,558.908L370.117,549.777L363.483,539.864L349.962,549.417C351.374,552.777 350.622,556.598 350.622,558.814L350.622,558.815Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20557-7-5",
    d: "M345.635,544.664L352.158,530.316L329.882,530.389L334.528,544.405C337.354,543.847 341.135,543.555 345.635,544.664Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20559-0-4",
    d: "M360.464,513.35L360.464,492.447C360.464,486.746 363.995,481.995 370.174,481.995C376.353,481.995 379.883,486.746 379.883,492.447L379.883,513.35L360.464,513.35Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6422-4-8",
    d: "M329.942,568.426C329.942,567.974 329.575,567.607 329.123,567.607L311.356,567.607C310.904,567.607 310.537,567.974 310.537,568.426L310.537,575.554C310.537,576.006 310.904,576.373 311.356,576.373L329.123,576.373C329.575,576.373 329.942,576.006 329.942,575.554L329.942,568.426Z",
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8362-5-5",
    x: 350.785,
    y: 567.641,
    width: 19.519,
    height: 8.765,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8364-6-5",
    d: "M329.891,558.625L310.537,558.811L310.707,549.79L316.45,540.227L330.231,549.283C329.396,552.968 329.972,552.772 329.891,558.625L329.891,558.625Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8373-4-7",
    d: "M310.377,478.121L310.377,486.506",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8375-7-6",
    d: "M300.114,513.381L300.114,492.326C300.114,486.584 303.788,481.799 310.217,481.799C316.646,481.799 320.32,486.584 320.32,492.326L320.32,513.381L300.114,513.381Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g11541-1-5",
    transform: "matrix(0.563628,0,0,0.52949,642.045,394.843)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect11535-2-0",
    x: -614.733,
    y: 43.702,
    width: 35.54,
    height: 98.378,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect11537-5-9",
    x: -553.184,
    y: -1.027,
    width: 35.386,
    height: 143.031,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect11539-0-5",
    x: -494.247,
    y: 43.702,
    width: 35.54,
    height: 98.378,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path11556-1-2",
    d: "M330.569,440.655L350.324,440.691",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6228-6-1",
    d: "M330.361,448.147L350.115,448.183",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13527-3-0",
    d: "M363.511,422.856L383.304,422.856",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13529-1-9",
    d: "M363.438,432.679L383.231,432.679",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13531-9-3",
    d: "M363.438,440.346L383.231,440.346",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13533-0-1",
    d: "M363.746,448.592L383.539,448.592",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13535-7-5",
    d: "M373.489,422.68L373.489,417.905",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13537-9-7",
    d: "M373.566,440.045L373.566,432.836",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13539-2-5",
    d: "M373.335,455.958L373.335,448.749",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11579-9-2",
    d: "M295.529,440.701L315.322,440.701",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11581-1-4",
    d: "M295.837,448.946L315.63,448.946",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5975-0-6",
    d: "M280.459,470.152L280.459,437.214L295.508,437.129L299.977,440.043L300.17,456L312.857,456.035L312.754,439.561L316.61,437.009L329.599,436.997L334.031,440.282L333.993,456.084L347.124,456.132L347.316,440.487L350.672,437.069L363.572,437.056L367.491,440.247L368.004,455.566L379.982,455.626L379.764,440.487L383.901,437.009L400.452,437.056L400.452,469.912L280.459,470.151L280.459,470.152Z",
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6394-3-4",
    d: "M280.331,460.611L400.251,460.611",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6326-7-2",
    d: "M290.132,460.646L290.132,470.15",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9348-7-0",
    d: "M310.394,460.551L310.394,470.055",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9350-4-4",
    d: "M330.429,460.653L330.429,470.158",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9352-9-0",
    d: "M350.41,460.602L350.41,470.106",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9354-2-3",
    d: "M370.281,460.653L370.281,470.158",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9356-4-3",
    d: "M391.068,460.623L391.068,470.128",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9358-3-2",
    d: "M300.104,451.319L300.104,460.823",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10329-3-0",
    d: "M299.848,442.304L280.522,442.304",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10331-5-2",
    d: "M299.967,451.954L280.641,451.954",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10333-9-0",
    d: "M333.884,442.237L312.865,442.237",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10335-1-8",
    d: "M367.541,442.207L347.138,442.134",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10337-1-4",
    d: "M400.462,442.134L379.751,442.134",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10339-6-7",
    d: "M333.827,451.954L312.731,451.882",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10341-2-9",
    d: "M367.797,451.954L347.163,451.954",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10343-3-2",
    d: "M400.315,451.924L379.835,451.852",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10345-6-7",
    d: "M290.093,442.47L290.093,451.974",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10347-6-4",
    d: "M320.197,451.91L320.236,460.727",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10349-6-8",
    d: "M330.428,442.241L330.45,451.836",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10351-4-0",
    d: "M350.406,442.293L350.429,451.888",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10353-6-1",
    d: "M391.084,441.977L391.107,451.898",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10355-2-9",
    d: "M320.101,437.114L320.123,442.388",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6266-8-7",
    d: "M340.182,456.094L340.182,460.633",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11523-4-2",
    d: "M359.967,451.935L360.005,460.463",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11525-0-6",
    d: "M359.87,436.851L359.892,442.124",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11527-9-6",
    d: "M379.956,451.861L379.995,460.606",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19398-6-8",
    transform: "matrix(0.563628,0,0,0.52949,485.592,390.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20609-9-2",
    d: "M-239.334,350.749L-239.334,313.02C-239.334,306.732 -238.014,287.771 -258.877,289.413C-280.097,288.189 -276.278,306.732 -276.278,313.02L-276.278,350.749L-239.334,350.749Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6222-0-4",
    d: "M-195.138,224.826L-195.138,195.203C-195.138,187.407 -198.316,179.612 -204.672,179.612C-211.029,179.612 -214.207,187.407 -214.207,195.203L-214.207,224.826L-195.138,224.826Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11529-0-3",
    d: "M-301.651,224.509L-301.651,194.886C-301.651,187.09 -304.829,179.295 -311.186,179.295C-317.542,179.295 -320.72,187.09 -320.72,194.886L-320.72,224.509L-301.651,224.509Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path11546-0-7",
    d: "M330.243,432.983L349.997,433.019",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11548-9-5",
    d: "M330.243,423.332L349.997,423.368",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11550-1-9",
    d: "M330.243,415.173L349.997,415.209",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11552-8-1",
    d: "M330.243,406.58L349.997,406.616",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11554-3-3",
    d: "M330.243,399.023L350.432,399.058",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6230-9-1",
    d: "M340.17,406.59L340.17,398.943",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11558-6-8",
    d: "M340.17,423.015L340.17,415.369",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11560-4-8",
    d: "M340.17,440.712L340.17,433.065",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11562-0-3",
    d: "M340.17,455.851L340.17,448.204",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6372-4-4",
    d: "M295.602,423.21L315.395,423.21",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11577-4-8",
    d: "M295.529,433.034L315.322,433.034",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11583-2-1",
    d: "M305.58,423.035L305.58,418.006",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11585-5-9",
    d: "M305.657,440.399L305.657,433.19",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13525-6-8",
    d: "M305.426,456.312L305.426,449.103",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16468-2-6",
    transform: "matrix(0.563628,0,0,0.52949,485.592,390.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect11564-9-8",
    d: "M-291.456,-29.178L-291.754,6.702L-223.061,6.428L-223.291,-28.982L-235.196,-28.709L-235.743,-19.936L-248.518,-20.209L-248.518,-28.817L-266.268,-28.817L-266.268,-20.209L-279.424,-20.209L-279.151,-29.178L-291.456,-29.178Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16464-4-7",
    d: "M-291.44,-8.428L-222.834,-8.361",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16466-7-5",
    d: "M-258.011,6.478L-258.011,-7.964",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16473-3-3",
    transform: "matrix(0.563628,0,0,0.52949,450.729,415.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16475-2-7",
    d: "M-291.456,-29.178L-291.754,6.702L-223.061,6.428L-223.291,-28.982L-235.196,-28.709L-235.743,-19.936L-248.518,-20.209L-248.518,-28.817L-266.268,-28.817L-266.268,-20.209L-279.424,-20.209L-279.151,-29.178L-291.456,-29.178Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16477-2-6",
    d: "M-291.44,-8.428L-222.834,-8.361",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16479-4-4",
    d: "M-258.011,6.478L-258.011,-7.964",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16481-1-9",
    transform: "matrix(0.563628,0,0,0.52949,519.11,414.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16483-9-1",
    d: "M-291.456,-29.178L-291.754,6.702L-223.061,6.428L-223.291,-28.982L-235.196,-28.709L-235.743,-19.936L-248.518,-20.209L-248.518,-28.817L-266.268,-28.817L-266.268,-20.209L-279.424,-20.209L-279.151,-29.178L-291.456,-29.178Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16485-5-9",
    d: "M-291.44,-8.428L-222.834,-8.361",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16487-5-6",
    d: "M-258.011,6.478L-258.011,-7.964",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.83px"
    }
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "path965-2",
    x: 211.332,
    y: 333.604,
    width: 238.72,
    height: 265.048,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3738-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6398-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33928-6",
    d: "M615.122,664.574L606.612,661.042L591.232,678.4L596.389,685.698L615.122,664.574",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33926-9",
    d: "M621.746,669.854L626.898,677.173L611.524,694.53L603.034,690.978L621.746,669.854",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path979-2",
    d: "M689.595,598.498L689.595,757.154C689.595,819.76 635.941,870.506 569.833,870.506C503.744,870.506 450.143,819.76 450.143,757.154L450.143,598.498L689.595,598.498",
    style: {
      fill: "rgb(182,0,40)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33894-8",
    d: "M485.072,614.628C477.421,614.628 471.234,620.537 471.234,627.799C471.234,633.56 475.127,638.535 480.571,640.304L480.571,660.811L471.734,663.311L471.734,685.986L480.404,688.487L480.404,681.151L480.571,681.151L480.571,667.98L489.074,667.98L489.074,640.47C489.437,640.363 490.06,640.265 490.408,640.137L517.584,670.647L512.582,678.15L528.087,695.322L536.59,691.654L558.097,715.829C557.729,716.478 557.509,717.125 557.264,717.83L543.259,717.83L540.758,709.327L516.917,709.327L514.249,717.83L497.91,717.83C496.597,713.782 493.321,710.499 489.074,709.16L489.074,681.151L480.571,681.151L480.571,688.487L480.404,688.487L480.571,709.16C475.874,710.576 472.141,714.188 471.068,718.83C471.058,718.881 471.078,718.946 471.068,718.997C470.914,719.797 470.734,720.634 470.734,721.498C470.734,727.37 474.797,732.325 480.404,734.002L480.404,747.34L471.568,750.341L472.902,773.015L481.738,775.016C482.928,781.309 484.866,787.282 487.407,793.022L486.74,793.855C481.751,799.355 482.414,807.639 488.24,812.362C492.007,815.428 496.995,816.161 501.411,814.863C505.245,819.169 509.588,823.162 514.249,826.7L512.248,835.536C518.683,839.865 525.632,843.618 533.089,846.373L539.758,840.038C545.242,841.865 550.991,843.229 556.93,844.039C558.305,849.932 563.79,854.376 570.435,854.376C577.095,854.376 582.605,849.968 583.939,844.039C589.472,843.206 594.963,841.942 600.112,840.205L599.945,840.038C602.273,839.244 604.54,838.502 606.78,837.537L602.612,830.201C606.862,828.392 610.949,826.309 614.783,823.865L618.951,831.035C615.081,833.437 611.028,835.707 606.78,837.537C604.57,838.485 602.421,839.425 600.111,840.204L606.613,846.373C614.076,843.618 621.019,839.865 627.454,835.536L625.62,826.7C630.241,823.181 634.485,819.137 638.291,814.862C642.686,816.161 647.7,815.428 651.462,812.361C657.289,807.639 658.087,799.355 653.129,793.855L652.296,793.022C654.844,787.282 656.786,781.309 657.964,775.015L666.801,773.015L668.134,750.34L659.298,747.339L659.298,734.002C664.915,732.325 668.968,727.37 668.968,721.497C668.968,720.634 668.818,719.797 668.634,718.997C668.624,718.944 668.644,718.882 668.634,718.83C667.556,714.19 663.837,710.575 659.131,709.16L659.298,688.486L668.134,685.986L668.134,663.311L659.298,660.81L659.298,640.303C664.93,638.622 668.968,633.702 668.968,627.799C668.968,620.536 662.781,614.628 655.13,614.628C648.966,614.628 643.763,618.508 641.958,623.798L618.451,623.798L618.451,631.967L604.446,631.967L604.446,623.798L583.105,623.798C581.296,618.508 576.103,614.628 569.934,614.628C563.765,614.628 558.572,618.508 556.763,623.798L535.756,623.798L535.756,631.967L521.751,631.967L521.751,623.798L498.243,623.798C496.449,618.508 491.257,614.628 485.072,614.628L485.072,614.628Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33892-3",
    d: "M516.583,615.295L514.082,623.631L543.092,623.631L540.591,615.295L516.583,615.295Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33890-4",
    d: "M599.778,615.295L597.11,623.631L626.12,623.631L623.619,615.295L599.778,615.295Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33888-7",
    d: "M485.072,622.131C488.344,622.131 491.074,624.697 491.074,627.799C491.074,630.907 488.344,633.468 485.072,633.468C481.796,633.468 479.07,630.907 479.07,627.799C479.07,624.697 481.796,622.131 485.072,622.131Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33886-6",
    d: "M498.41,631.968L514.082,631.968L516.583,640.47L540.591,640.47L543.092,631.968L556.763,631.968C558.169,636.036 561.483,639.203 565.766,640.47L565.766,650.14L556.93,652.641L556.93,675.316L565.766,677.816L565.766,709.327C565.296,709.491 564.721,709.774 564.266,709.994L543.092,686.319L548.26,678.983L532.588,661.644L524.252,665.312L496.91,634.969C497.554,634.008 498.027,633.092 498.41,631.968Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33884-1",
    d: "M582.939,631.968L597.11,631.968L599.778,640.47L623.619,640.47L626.12,631.968L641.959,631.968C642.148,632.55 642.527,632.947 642.792,633.468L615.116,664.645L606.614,661.144L591.275,678.483L596.443,685.819L601.445,680.317L610.281,670.147L616.95,675.482L603.112,691.154L611.448,694.655L626.954,677.316L621.785,669.98L648.795,639.47C649.408,639.777 649.969,640.099 650.628,640.304L650.628,660.811L641.625,663.311L641.625,685.986L650.628,688.487L650.628,709.327C646.407,710.666 643.106,713.782 641.792,717.83L625.953,717.83L623.286,709.327L599.444,709.327L596.944,717.83L583.606,717.83C583.243,716.675 582.936,715.638 582.272,714.662L603.112,691.154L607.947,685.486L601.445,680.317L575.77,709.494C575.386,709.381 574.653,709.268 574.269,709.16L574.269,670.481L565.766,670.481L565.766,657.309L574.436,657.309L574.436,677.816L583.272,675.316L583.272,652.641L574.436,650.14L574.436,640.304C578.53,638.985 581.584,635.888 582.939,631.967L582.939,631.968Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33882-9",
    d: "M489.24,660.811L489.24,688.487L498.077,685.986L498.077,663.311L489.24,660.811Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path33880-2",
    x: 650.628,
    y: 667.98,
    width: 8.67,
    height: 13.171,
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33878-5",
    d: "M529.087,670.814L538.09,680.817L531.588,686.153L522.418,675.982L529.087,670.814Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33876-1",
    d: "M484.739,715.996C487.004,715.996 488.916,717.174 489.907,718.83C489.927,718.875 489.887,718.95 489.907,718.997C490.271,719.814 490.574,720.628 490.574,721.498C490.574,724.615 488.036,727.166 484.739,727.166C481.463,727.166 478.737,724.615 478.737,721.498C478.737,720.633 479.036,719.887 479.404,719.164C479.429,719.119 479.379,719.043 479.404,718.997C480.4,717.241 482.493,715.996 484.739,715.996Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33874-1",
    d: "M655.13,715.996C657.456,715.996 659.312,717.339 660.298,719.164L660.465,719.164C660.768,719.917 660.965,720.698 660.965,721.498C660.965,724.616 658.426,727.166 655.13,727.166C651.859,727.167 649.128,724.616 649.128,721.498C649.128,720.578 649.376,719.753 649.795,718.997C650.761,717.28 652.809,715.996 655.13,715.996L655.13,715.996Z",
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33872-5",
    d: "M521.085,717.83L535.589,717.83L535.589,725.666L557.43,725.666C557.716,726.499 557.991,727.295 558.431,728L538.09,750.507L529.587,746.84L514.082,764.179L519.251,771.515L502.412,790.188C500.071,789.319 497.352,789.012 494.909,789.354C492.844,784.609 491.389,779.668 490.407,774.516C489.979,772.27 489.615,769.995 489.407,767.68L480.738,767.68C480.517,765.265 480.404,762.859 480.404,760.344L480.404,754.342L489.24,754.509L489.24,760.344C489.24,762.834 489.21,765.26 489.407,767.68C489.595,769.989 489.97,772.262 490.407,774.515L499.244,771.681C499.244,771.681 498.18,756.541 498.41,760.344C498.599,763.605 498.076,749.007 498.076,749.007L489.24,746.839L489.24,734.002C493.278,732.688 496.353,729.524 497.743,725.666L521.084,725.666L521.084,717.83L521.085,717.83Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33870-8",
    d: "M604.613,717.83L618.618,717.83L618.618,725.666L641.959,725.666C643.349,729.525 646.56,732.688 650.628,734.002L650.628,746.84L641.625,749.007C641.625,749.007 641.264,763.605 641.458,760.344C641.704,756.541 640.458,771.681 640.458,771.681L649.461,774.516C648.475,779.678 646.854,784.6 644.793,789.354C642.339,789.011 639.818,789.319 637.457,790.188L620.618,771.515L625.62,764.179L610.114,746.84L601.612,750.507L582.272,728.333C582.778,727.526 583.283,726.752 583.605,725.832L604.613,725.666L604.613,717.83L604.613,717.83Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6352-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33961-1",
    d: "M659.298,754.412L659.278,734.044C664.895,732.383 668.963,727.39 668.963,721.517C668.963,715.655 664.839,710.61 659.221,708.913L659.278,681.047L650.671,681.047L650.636,709.077C646.414,710.411 643.138,713.528 641.824,717.566L618.589,717.601L618.589,725.748L641.977,725.748C643.368,729.607 646.511,732.638 650.58,733.952L650.595,754.463L659.278,754.412L659.298,754.412L659.298,754.412Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33953-2",
    d: "M659.354,640.312L659.277,667.82L650.67,667.82L650.67,640.204C650.011,640.005 649.362,639.734 648.748,639.427L616.911,675.282L610.328,670.053L642.773,633.498C642.507,632.977 642.221,632.435 642.032,631.858L618.49,631.858L618.49,623.711L641.961,623.711C643.765,618.431 648.963,614.644 655.127,614.644C662.779,614.644 669.004,620.521 669.004,627.769C669.004,633.662 664.987,638.635 659.354,640.312L659.354,640.312Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33951-1",
    d: "M574.447,640.204L574.371,657.148L565.769,657.148L565.789,640.347C561.505,639.085 558.132,635.916 556.726,631.858L535.73,631.858L535.73,623.711L556.726,623.711C558.536,618.431 563.708,614.644 569.878,614.644C576.047,614.644 581.26,618.431 583.069,623.711L604.48,623.711L604.48,631.858L583.013,631.858C581.659,635.768 578.541,638.891 574.447,640.204L574.447,640.204Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33936-1",
    d: "M613.956,776.835L605.472,780.438L589.939,763.208L595.04,755.869L613.956,776.835",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33918-1",
    d: "M543.136,631.878L540.514,640.347L516.604,640.347L514.018,631.878L543.136,631.878",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33916-3",
    d: "M543.136,623.675L540.514,615.221L516.604,615.221L514.018,623.675L543.136,623.675",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6309-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6305-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33969-1",
    d: "M525.799,776.835L534.289,780.438L549.816,763.208L544.715,755.869L525.799,776.835",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33967-6",
    d: "M519.216,771.514L514.125,764.144L529.663,746.914L538.127,750.533L519.216,771.514",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6284-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6279-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33846-3",
    d: "M524.935,823.898L520.698,831.197C513.44,826.689 506.975,821.123 501.419,814.882C497.003,816.18 492.014,815.408 488.247,812.342C482.42,807.619 481.715,799.329 486.704,793.829L487.429,793.057C483.918,785.125 481.541,776.6 480.729,767.66L489.407,767.695C490.092,775.321 491.994,782.584 494.958,789.397C497.401,789.055 500.008,789.341 502.349,790.21L524.066,766.182L530.609,771.462L509.029,795.454C511.943,799.885 511.825,805.599 508.498,809.964C513.287,815.264 518.792,819.987 524.935,823.897L524.935,823.898Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33836-1",
    d: "M518.5,819.226C525.988,825.068 534.687,829.811 544.092,832.817L546.07,824.22C538.342,821.787 531.181,818.219 524.884,813.589L518.5,819.226",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path982-5",
    d: "M514.202,826.653C521.797,832.367 530.481,836.947 539.788,840.121L533.139,846.336C525.681,843.581 518.664,839.942 512.229,835.613L514.202,826.653",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6270-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33844-0",
    d: "M480.463,754.412L480.473,734.044C474.866,732.383 470.792,727.39 470.792,721.517C470.792,715.655 474.922,710.61 480.539,708.913L480.473,681.047L489.085,681.047L489.1,709.077C493.348,710.411 496.619,713.528 497.932,717.566L521.152,717.601L521.152,725.748L497.784,725.748C496.394,729.607 493.215,732.638 489.177,733.952L489.162,754.463L480.463,754.412",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33840-4",
    d: "M481.792,774.938L472.868,772.94L471.61,750.339L480.463,747.415L480.473,760.377C480.473,765.406 480.917,770.165 481.792,774.938L481.792,774.938Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33838-5",
    d: "M489.198,746.914L498.086,749.005C498.086,749.005 498.541,763.53 498.352,760.27C498.122,756.467 499.323,771.626 499.323,771.626L490.358,774.581C489.464,769.965 489.162,765.243 489.162,760.377L489.177,746.914L489.198,746.914Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33945-4",
    d: "M480.575,660.771L471.651,663.276L471.651,685.918L480.575,688.366L480.575,660.771",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33943-4",
    d: "M489.239,660.771L498.142,663.276L498.142,685.918L489.239,688.366L489.239,660.771",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33924-1",
    d: "M514.227,717.587L516.834,709.133L540.759,709.133L543.341,717.587L514.227,717.587",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33922-5",
    d: "M514.227,725.77L516.834,734.239L540.759,734.239L543.341,725.77L514.227,725.77",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g6298-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33852-7",
    d: "M583.274,835.827C590.092,834.749 596.374,832.873 602.579,830.261L606.842,837.524C599.707,840.586 592.014,842.789 584,843.995C582.666,849.924 577.131,854.375 570.471,854.375C563.826,854.375 558.286,849.98 556.911,844.087C548.447,842.932 540.417,840.749 532.898,837.524L537.182,830.261C543.709,833.016 550.675,834.856 557.902,835.863C559.431,832.551 562.226,829.99 565.901,828.799L565.978,793.236L574.559,793.236L574.636,828.672C578.444,829.811 581.659,832.403 583.258,835.827L583.274,835.827Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33949-0",
    d: "M621.25,819.226C613.752,825.068 605.048,829.811 595.669,832.817L593.691,824.22C601.398,821.787 608.574,818.219 614.856,813.589L621.25,819.226",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33947-2",
    d: "M625.554,826.653C617.933,832.367 609.28,836.947 599.967,840.121L606.612,846.336C614.074,843.581 621.097,839.942 627.532,835.613L625.554,826.653",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33906-1",
    d: "M574.6,800.249L583.525,797.744L583.525,775.122L574.6,772.669L574.6,800.249",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33904-5",
    d: "M565.942,800.249L557.033,797.744L557.033,775.122L565.942,772.669L565.942,800.249",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path33898-6",
    d: "M597.074,631.878L599.707,640.347L623.606,640.347L626.198,631.878L597.074,631.878",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path984-5",
    d: "M597.074,623.675L599.707,615.221L623.606,615.221L626.198,623.675L597.074,623.675",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path33868-1",
    d: "M514.249,725.833L516.916,734.169L540.758,734.169L543.259,725.833L514.249,725.833Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33866-2",
    d: "M596.944,725.833L599.444,734.169L623.286,734.169L625.953,725.833L596.944,725.833Z",
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33864-6",
    d: "M564.933,733.502C565.27,733.66 565.57,733.748 565.933,733.835L565.933,772.682L557.097,775.183L557.097,797.69L565.933,800.191L565.933,828.868C562.258,830.059 559.459,832.558 557.93,835.87C553.217,835.213 548.534,834.257 544.092,832.869L546.093,824.199C538.365,821.767 531.216,818.16 524.919,813.529L518.417,819.198C520.289,820.658 522.237,822.053 524.252,823.366C522.22,822.041 520.304,820.692 518.417,819.198C514.864,816.383 511.588,813.357 508.58,810.028C511.908,805.663 511.994,799.954 509.08,795.523L525.753,776.85L534.256,780.518L549.761,763.179L544.759,755.843L564.933,733.502L564.933,733.502Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33862-4",
    d: "M575.77,733.669L600.111,761.345L606.614,756.176L615.617,766.18L609.114,771.515L600.111,761.345L595.11,755.843L589.941,763.179L605.446,780.518L613.949,776.85L630.788,795.523C627.895,799.954 627.976,805.663 631.289,810.028C628.273,813.373 624.857,816.372 621.285,819.198C619.415,820.678 617.465,822.053 615.45,823.366C617.467,822.053 619.411,820.658 621.285,819.198L614.783,813.529C608.501,818.16 601.317,821.766 593.609,824.199L595.61,832.869C591.632,834.163 587.56,835.192 583.272,835.87C581.672,832.446 578.411,829.841 574.603,828.701L574.603,800.191L583.606,797.69L583.606,775.183L574.603,772.682L574.603,734.169C575.078,734.041 575.325,733.812 575.77,733.669Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33860-8",
    d: "M659.298,754.342L659.298,760.344C659.298,762.859 659.186,765.265 658.965,767.68L650.295,767.68C650.492,765.26 650.628,762.834 650.628,760.344L650.628,754.509L659.298,754.343L659.298,754.342Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33858-5",
    d: "M533.089,756.176L539.758,761.345L530.588,771.515L524.086,766.18L533.089,756.176Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path33856-5",
    x: 565.933,
    y: 780.018,
    width: 8.67,
    height: 13.171,
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32837-2",
    d: "M524.919,823.866C528.751,826.31 533.002,828.393 537.257,830.201L532.922,837.537C528.692,835.716 524.603,833.59 520.751,831.202L524.919,823.866Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33850-8",
    d: "M558.383,728.075C557.948,727.354 557.621,726.582 557.335,725.749L535.618,725.749L535.618,717.602L557.187,717.602C557.432,716.917 557.775,716.232 558.132,715.583L531.508,685.969L538.051,680.669L564.342,709.782C564.797,709.562 565.257,709.368 565.748,709.204L565.768,670.416L574.35,670.416L574.35,708.969C574.733,709.077 575.321,709.184 575.704,709.312L601.362,680.127L607.961,685.376L582.195,714.397C582.86,715.368 583.315,716.452 583.678,717.602L604.577,717.602L604.577,725.749L583.56,725.806C583.258,726.726 582.727,727.574 582.231,728.382L606.632,756.125L600.084,761.425L575.801,733.646C575.357,733.81 575.132,733.989 574.636,734.116L574.58,779.988L565.978,779.988L565.953,733.917C565.595,733.809 565.293,733.625 564.951,733.467L539.671,761.425L533.129,756.125L558.383,728.075",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33842-2",
    d: "M492.24,798.599C494.376,796.217 498.123,795.946 500.617,797.965C503.111,799.984 503.418,803.552 501.286,805.898C499.145,808.259 495.403,808.545 492.909,806.526C490.415,804.492 490.113,800.96 492.24,798.599Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33965-5",
    d: "M478.73,721.517C478.73,718.394 481.388,715.874 484.664,715.874C487.941,715.874 490.588,718.394 490.588,721.517C490.588,724.635 487.941,727.119 484.664,727.119C481.388,727.119 478.73,724.635 478.73,721.517Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33963-9",
    d: "M614.815,823.898L619.063,831.197C626.31,826.689 632.786,821.123 638.342,814.882C642.737,816.18 647.746,815.408 651.508,812.342C657.335,807.619 658.005,799.329 653.047,793.829L652.311,793.057C655.832,785.125 658.214,776.6 658.991,767.66L650.353,767.695C649.668,775.321 647.746,782.584 644.792,789.397C642.339,789.055 639.753,789.341 637.391,790.21L615.694,766.182L609.147,771.462L630.711,795.454C627.818,799.885 627.93,805.599 631.242,809.964C626.464,815.264 620.964,819.987 614.815,823.897L614.815,823.898Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33959-3",
    d: "M647,798.7C644.869,796.318 641.138,796.047 638.649,798.066C636.149,800.085 635.848,803.653 637.979,805.999C640.11,808.36 643.862,808.646 646.356,806.627C648.851,804.593 649.132,801.061 647,798.7Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33957-9",
    d: "M657.948,774.938L666.872,772.94L668.13,750.339L659.298,747.415L659.278,760.377C659.278,765.406 658.838,770.165 657.949,774.938L657.948,774.938Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33955-5",
    d: "M650.563,746.914L641.674,749.005C641.674,749.005 641.194,763.53 641.388,760.27C641.634,756.467 640.417,771.626 640.417,771.626L649.382,774.581C650.277,769.965 650.578,765.243 650.578,760.377L650.563,746.914",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path983-1",
    d: "M650.593,660.771L641.69,663.276L641.69,685.918L650.593,688.366L650.593,660.771",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33938-5",
    d: "M659.257,660.771L668.186,663.276L668.186,685.918L659.257,688.366L659.257,660.771",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33934-5",
    d: "M620.54,771.514L625.63,764.144L610.098,746.914L601.628,750.533L620.54,771.514",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33920-0",
    d: "M479.149,627.784C479.149,624.687 481.812,622.162 485.088,622.162C488.36,622.162 491.007,624.687 491.007,627.784C491.007,630.887 488.36,633.391 485.088,633.391C481.812,633.391 479.149,630.887 479.149,627.784Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33914-4",
    d: "M649.132,721.517C649.132,718.394 651.8,715.874 655.071,715.874C658.368,715.874 660.99,718.394 660.99,721.517C660.99,724.635 658.368,727.119 655.071,727.119C651.8,727.119 649.132,724.635 649.132,721.517Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33912-9",
    d: "M625.983,717.587L623.361,709.133L599.451,709.133L596.87,717.587L625.983,717.587",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33910-4",
    d: "M625.983,725.77L623.361,734.239L599.451,734.239L596.87,725.77L625.983,725.77",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33908-3",
    d: "M564.531,841.235C564.531,838.117 567.194,835.597 570.471,835.597C573.742,835.597 576.384,838.117 576.384,841.235C576.384,844.337 573.742,846.842 570.471,846.842C567.194,846.842 564.531,844.337 564.531,841.235Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33902-3",
    d: "M649.193,627.784C649.193,624.687 651.835,622.162 655.127,622.162C658.403,622.162 661.051,624.687 661.051,627.784C661.051,630.887 658.403,633.391 655.127,633.391C651.835,633.391 649.193,630.887 649.193,627.784Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33900-4",
    d: "M563.944,627.784C563.944,624.687 566.607,622.162 569.878,622.162C573.154,622.162 575.802,624.687 575.802,627.784C575.802,630.887 573.154,633.391 569.878,633.391C566.607,633.391 563.944,630.887 563.944,627.784Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6386-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path33848-5",
    d: "M490.476,640.133L522.482,675.946L529.034,670.646L496.849,634.976C497.493,634.02 497.948,632.977 498.332,631.858L521.746,631.858L521.746,623.711L498.316,623.711C496.522,618.431 491.273,614.644 485.088,614.644C477.437,614.644 471.212,620.521 471.212,627.769C471.212,633.519 475.106,638.42 480.55,640.184L480.499,667.82L489.101,667.82L489.101,640.368C489.464,640.26 490.128,640.26 490.476,640.133L490.476,640.133Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33932-9",
    d: "M524.174,665.239L532.668,661.635L548.201,678.87L543.1,686.22L524.174,665.239",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33930-6",
    d: "M517.596,670.575L512.515,677.95L528.043,695.164L536.512,691.54L517.596,670.575",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path985-3",
    d: "M565.845,650.12L556.936,652.624L556.936,675.261L565.845,677.715L565.845,650.12M574.411,650.12L583.315,652.624L583.315,675.261L574.411,677.715L574.411,650.12",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path986-7",
    d: "M556.415,721.839C556.415,714.556 562.641,708.662 570.312,708.662C577.964,708.662 584.184,714.556 584.184,721.839C584.184,729.086 577.964,734.959 570.312,734.959C562.641,734.959 556.415,729.086 556.415,721.839",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.07px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path1162-2",
    x: 465.303,
    y: 593.076,
    width: 20.693,
    height: 4.934,
    style: {
      fill: "rgb(200,177,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path1163-8",
    x: 465.303,
    y: 593.076,
    width: 20.693,
    height: 4.934,
    style: {
      fill: "rgb(222,173,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3978-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1030-4",
    d: "M462.468,828.44C472.422,831.434 477.466,838.849 477.466,847.528C477.466,858.833 466.501,867.412 452.265,867.412C438.033,867.412 426.489,858.833 426.489,847.528C426.489,838.983 431.236,829.436 441.133,828.747C441.133,828.747 440.831,827.851 439.978,826.38C438.953,825.283 436.927,823.238 436.927,823.238C436.927,823.238 440.706,822.529 442.886,823.357C445.08,824.186 446.521,825.571 446.521,825.571C446.521,825.571 447.556,823.544 449.003,821.973C450.464,820.416 452.356,819.439 452.356,819.439C452.356,819.439 454.545,821.279 455.263,822.51C455.977,823.779 456.442,825.283 456.442,825.283C456.442,825.283 458.454,823.626 460.202,822.95C461.946,822.261 464.197,821.719 464.197,821.719C464.197,821.719 463.555,823.899 463.129,825.01C462.698,826.112 462.32,827.454 462.32,827.454L461.894,828.223L462.468,828.44Z",
    style: {
      fill: "rgb(246,203,126)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1032-5",
    d: "M450.162,879.679C450.162,879.679 431.236,866.923 423.031,865.199C412.54,862.986 400.752,864.777 395.651,864.509C395.794,864.658 401.768,868.916 404.388,871.55C407.013,874.171 415.755,879.406 420.693,880.642C436.05,884.493 450.162,879.679 450.162,879.679",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1034-8",
    d: "M455.565,880.79C455.565,880.79 467.689,868.188 480.378,866.449C495.376,864.37 505.191,867.685 511.015,869.203C511.149,869.203 506.201,871.55 503.586,873.342C500.956,875.133 494.202,880.79 483.875,880.91C473.528,881.064 462.113,879.828 460.221,880.115C458.329,880.369 455.565,880.79 455.565,880.79",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1036-6",
    d: "M449.595,862.621C444.829,858.195 444.198,854.488 444.198,847.514C444.198,840.554 447.182,834.269 451.944,829.863C456.691,834.269 459.632,840.554 459.632,847.514C459.632,854.488 459.406,857.969 454.664,862.395L452.035,864.225L449.595,862.621Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.47px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1038-0",
    d: "M446.914,889.987C446.914,889.987 450.037,883.818 450.32,877.6C450.569,872.398 449.587,867.263 449.587,867.263L453.371,867.263C453.371,867.263 455.263,872.786 455.263,877.6C455.263,882.429 454.387,888.852 454.387,888.852C454.387,888.852 451.767,889.255 450.895,889.662C450.037,890.083 447.776,891.169 447.776,891.169L446.4,891.53L446.914,889.987Z",
    style: {
      fill: "rgb(4,109,68)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.47px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3956-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path962-1",
    x: 449.966,
    y: 333.604,
    width: 239.395,
    height: 265.048,
    style: {
      fill: "rgb(195,195,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path963-5",
    x: 449.966,
    y: 333.604,
    width: 239.395,
    height: 265.048,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3786-0",
    transform: "matrix(1,0,0,1,-9.33604,-5.7934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1027-9",
    d: "M608.729,569.785C608.729,569.785 605.769,572.841 606.837,575.389C607.925,577.942 609.797,580.61 609.797,580.61C609.797,580.61 609.692,576.812 610.89,575.782C612.619,574.258 615.847,573.99 615.847,573.99C615.847,573.99 613.294,571.71 612.475,571.456C611.69,571.183 608.729,569.785 608.729,569.785Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1029-8",
    d: "M623.516,574.258C623.516,574.258 622.036,577.942 624.872,580.356C627.689,582.79 630.117,583.043 630.117,583.043C630.117,583.043 627.957,579.207 628.637,577.18C629.332,575.068 631.185,573.751 631.185,573.751C631.185,573.751 627.689,572.587 627.152,572.721C626.62,572.84 623.516,574.258 623.516,574.258Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path988-1",
    d: "M581.912,408.796L582.18,405.855L582.587,404.216C582.587,404.216 574.923,404.844 570.89,403.709C566.856,402.564 563.221,400.906 559.451,397.731C555.695,394.536 554.211,392.543 551.518,392.141C545.061,391.111 540.084,394.033 540.084,394.033C540.084,394.033 544.937,395.819 548.577,400.265C552.194,404.743 556.141,407.004 557.851,407.545C560.672,408.408 570.482,407.799 573.175,407.9C575.867,408.034 581.912,408.81 581.912,408.81L581.912,408.796L581.912,408.796Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1722-3",
    transform: "matrix(1,0,0,1,9.92347,9.88447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1003-4",
    d: "M558.418,403.117L560.018,400.583L561.604,402.882L558.418,403.117",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1005-8",
    d: "M562.303,402.997L564.19,400.463L566.212,402.743L562.303,402.997",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1007-9",
    d: "M560.559,387.338L564.463,388.742L560.967,390.514L560.56,387.338",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1009-5",
    d: "M565.263,388.622L568.76,389.504L565.943,391.664L565.263,388.622",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path989-8",
    d: "M617.752,398.018C617.752,398.018 617.772,401.448 618.106,404.724C618.427,407.866 617.091,410.621 617.608,412.359C618.106,414.117 618.355,415.502 619.036,416.766C619.677,418.036 620.032,421.245 620.032,421.245C620.032,421.245 618.197,419.942 616.497,418.678C614.825,417.394 613.623,416.599 613.623,416.599C613.623,416.599 613.968,420.028 614.126,421.499C614.308,422.969 615.165,425.738 616.554,427.376C617.929,428.981 620.679,431.616 621.526,433.728C622.408,435.859 622.231,440.554 622.231,440.554C622.231,440.554 619.998,436.99 618.082,436.348C616.2,435.687 612.061,433.393 612.061,433.393C612.061,433.393 615.855,437.158 615.855,440.741C615.855,444.319 614.308,448.39 614.308,448.39C614.308,448.39 612.593,445.147 610.365,443.021C608.119,440.908 605.015,438.781 605.015,438.781C605.015,438.781 607.439,444.319 607.439,448.055C607.439,451.82 606.763,459.81 606.763,459.81C606.763,459.81 604.871,456.72 602.979,455.216C601.073,453.765 598.845,452.462 598.146,451.499C597.471,450.522 600.397,454.574 600.713,457.022C601.049,459.474 602.213,468.207 609.848,479.358C614.308,485.877 621.21,497.278 635.997,493.527C650.803,489.795 645.309,469.898 642.205,460.605C639.101,451.331 637.549,441.042 637.731,437.445C637.889,433.881 640.476,423.29 640.136,421.312C639.796,419.372 638.991,411.804 640.831,405.706C642.723,399.354 644.294,396.888 645.309,394.267C646.32,391.666 647.177,390.196 647.522,387.916C647.862,385.636 647.862,381.377 647.862,381.377C647.862,381.377 650.607,386.445 651.302,388.237C651.982,390.043 651.982,395.398 651.982,395.398C651.982,395.398 652.494,390.043 656.638,387.442C660.776,384.807 665.59,382.053 666.798,380.582C668,379.097 668.354,378.135 668.354,378.135C668.354,378.135 668,387.274 665.428,390.871C663.718,393.204 656.978,400.806 656.978,400.806C656.978,400.806 660.436,399.489 662.841,399.354C665.25,399.168 666.965,399.354 666.965,399.354C666.965,399.354 664.038,401.635 660.254,407.172C656.475,412.7 658.012,413.188 655.263,417.748C652.494,422.308 650.267,422.476 646.823,425.25C641.65,429.402 644.437,445.923 645.113,448.376C645.807,450.809 654.746,471.042 654.923,475.928C655.081,480.824 655.958,491.74 647.34,498.748C641.793,503.294 632.716,503.327 630.647,504.625C628.573,505.909 624.472,509.981 624.472,518.464C624.472,526.962 627.543,528.245 629.952,530.372C632.376,532.499 635.465,531.354 636.155,532.992C636.855,534.611 637.19,535.593 638.229,536.57C639.264,537.533 639.959,538.683 639.604,540.455C639.264,542.266 635.303,546.337 633.928,549.293C632.539,552.195 629.789,559.884 629.789,561.014C629.789,562.164 629.468,565.747 630.647,567.552C630.647,567.552 634.948,572.572 632.017,573.55C630.129,574.191 628.276,572.366 627.385,572.572C624.812,573.248 623.471,574.833 622.729,574.699C621.014,574.378 621.014,573.535 620.837,571.116C620.679,568.683 620.765,567.687 619.998,567.687C618.964,567.687 618.441,568.534 618.269,569.818C618.082,571.116 618.082,574.038 616.894,574.038C615.682,574.038 613.968,571.926 612.933,571.456C611.898,570.963 608.976,570.474 608.809,569.176C608.636,567.873 610.528,565.105 612.416,564.611C614.308,564.123 616.037,563.16 614.825,562.183C613.613,561.201 612.416,561.201 611.223,562.183C610.011,563.16 607.439,562.331 607.601,560.865C607.778,559.395 608.119,557.618 607.937,556.794C607.779,555.999 605.71,554.361 608.44,552.871C611.204,551.42 612.397,554.193 615.146,553.7C617.91,553.23 619.285,552.215 620.319,550.61C621.354,548.986 621.172,545.556 619.285,543.449C617.393,541.317 615.505,540.982 614.806,539.679C614.111,538.381 613.096,535.287 613.096,535.287C613.096,535.287 613.594,540.982 613.254,541.811C612.918,542.62 613.096,546.031 613.096,546.031C613.096,546.031 611.204,543.918 609.652,542.299C608.119,540.661 606.567,535.78 606.567,535.78C606.567,535.78 606.404,540.34 606.404,542.146C606.404,543.918 608.454,545.556 607.779,546.218C607.084,546.859 603.822,542.788 602.965,542.146C602.088,541.49 599.343,539.377 598.132,537.078C596.934,534.798 596.057,531.555 595.722,530.391C595.377,529.256 594.812,524.174 595.377,522.89C596.235,520.945 597.614,517.515 597.614,517.515L590.903,517.515C587.301,517.515 584.714,516.385 583.34,518.818C581.97,521.266 582.645,526.166 584.36,532.518C586.089,538.85 587.105,541.959 586.606,543.109C586.103,544.239 583.862,546.859 583.004,547.334C582.128,547.841 579.718,547.669 578.684,547.2C577.668,546.706 575.958,545.878 572.672,545.878C569.41,545.878 567.341,546.031 566.148,545.744C564.936,545.408 562.009,543.938 560.615,544.259C559.241,544.594 556.865,545.811 557.511,547.688C558.565,550.625 556.496,551.286 555.107,551.118C553.732,550.945 552.554,550.457 550.805,549.983C549.095,549.48 546.504,549.983 546.849,548.009C547.184,546.05 547.883,545.897 548.736,544.445C549.608,542.956 549.929,542.012 548.961,541.911C547.754,541.792 546.542,541.657 545.598,542.434C544.688,543.195 543.208,544.833 541.991,544.225C540.775,543.583 539.836,542.18 539.836,539.104C539.836,536.048 536.602,533.38 539.567,533.515C542.527,533.649 546.293,535.814 546.968,534.156C547.629,532.485 547.222,531.742 545.617,530.439C544.003,529.175 541.991,528.413 544.147,526.756C546.293,525.118 546.829,525.118 547.648,524.207C548.453,523.326 549.607,520.457 551.111,521.166C554.067,522.569 551.25,524.61 554.211,527.905C557.176,531.215 559.049,532.384 564.025,531.857C568.998,531.354 570.358,530.712 570.358,529.309C570.358,527.905 569.942,525.371 569.798,524.342C569.678,523.326 570.483,519.628 570.483,519.628C570.483,519.628 568.198,521.046 567.522,522.43C566.876,523.834 565.52,526.234 565.52,526.234C565.52,526.234 564.969,523.379 565.127,521.046C565.218,519.681 565.702,517.295 565.649,516.826C565.52,515.557 564.576,512.366 564.576,512.366C564.576,512.366 563.767,515.81 563.24,516.826C562.703,517.837 562.435,521.927 562.435,521.927C562.435,521.927 559.278,519.173 560.155,514.546C560.811,510.977 559.614,506.269 560.687,504.731C561.74,503.193 564.289,496.957 570.482,496.689C576.671,496.454 581.504,496.957 583.665,496.842C585.815,496.689 593.475,495.304 593.475,495.304C593.475,495.304 579.358,488.057 576.135,485.878C572.906,483.732 567.929,478.123 566.305,475.574C564.696,473.021 563.221,468.073 563.221,468.073C563.221,468.073 560.687,468.188 558.387,469.457C556.102,470.708 553.822,472.652 552.481,474.152C551.121,475.689 548.984,479.138 548.984,479.138C548.984,479.138 549.377,474.679 549.377,473.275C549.377,471.905 549.109,469.189 549.109,469.189C549.109,469.189 547.504,475.301 544.276,477.581C541.047,479.895 537.282,483.071 537.282,483.071C537.282,483.071 537.694,479.66 537.694,478.884C537.694,478.123 538.499,474.171 538.499,474.171C538.499,474.171 536.214,477.581 532.717,478.257C529.22,478.884 524.1,478.75 523.693,480.93C523.3,483.071 524.636,486.012 523.836,487.53C523.027,489.068 521.283,490.083 521.283,490.083C521.283,490.083 519.271,488.412 517.518,488.292C515.77,488.158 514.151,489.068 514.151,489.068C514.151,489.068 512.67,487.142 513.202,485.878C513.753,484.608 516.431,482.702 515.77,481.926C515.094,481.164 512.939,482.194 511.597,482.822C510.261,483.463 507.425,484.086 507.693,481.926C507.962,479.761 508.637,478.496 507.962,476.959C507.291,475.455 507.693,474.425 508.781,474.037C509.849,473.682 514.151,474.152 514.558,473.174C514.951,472.145 513.49,470.875 510.654,470.233C507.833,469.611 506.482,467.939 507.962,466.535C509.442,465.132 509.849,464.763 510.52,463.479C511.19,462.196 511.454,459.911 514.021,461.06C516.555,462.196 516.019,464.998 518.735,465.894C521.393,466.804 527.726,465.52 529.058,464.763C530.418,463.982 534.715,460.807 536.195,460.031C537.68,459.288 543.849,454.694 543.849,454.694C543.849,454.694 540.228,452.175 538.872,450.877C537.536,449.607 535.127,446.566 533.934,445.924C532.717,445.268 526.797,443.002 524.78,442.868C522.763,442.734 516.575,440.588 516.575,440.588C516.575,440.588 519.396,439.678 520.34,438.916C521.283,438.154 523.405,436.229 524.512,436.363C525.566,436.502 525.829,436.502 525.829,436.502C525.829,436.502 520.071,436.229 518.855,435.874C517.648,435.467 514.151,433.307 512.814,433.307C511.454,433.307 508.781,433.829 508.781,433.829C508.781,433.829 512.402,431.534 515.363,431.027C518.323,430.538 520.608,430.639 520.608,430.639C520.608,430.639 516.043,429.369 514.951,427.851C513.883,426.313 512.814,424.048 511.99,423.018C511.19,422.007 510.654,420.335 509.174,420.216C507.694,420.081 505.136,422.007 503.66,421.868C502.199,421.753 501.107,420.838 500.964,418.692C500.863,416.518 500.964,417.275 500.451,416.144C499.915,414.98 497.759,412.307 499.771,411.685C501.807,411.043 506.103,412.058 506.496,411.297C506.908,410.535 504.216,408.24 502.468,407.345C500.719,406.463 497.898,404.926 499.378,403.661C500.863,402.392 502.334,401.889 503.143,400.739C503.948,399.59 504.892,396.414 506.64,397.425C508.388,398.44 510.807,403.422 512.153,403.034C513.509,402.646 513.609,399.082 513.365,397.563C513.097,396.026 513.365,393.358 514.687,393.607C516.043,393.861 517.111,395.638 519.271,395.786C521.408,395.906 524.636,395.283 524.368,396.783C524.1,398.306 522.883,400.198 521.408,401.87C519.966,403.541 519.286,406.837 520.215,408.997C521.154,411.177 523.587,414.626 525.728,416.01C527.865,417.409 531.898,418.443 534.466,420.081C537.014,421.753 542.939,426.447 544.956,426.955C546.968,427.477 548.984,428.493 548.984,428.493C548.984,428.493 551.265,427.477 554.373,427.477C557.458,427.477 564.576,427.985 567.268,426.835C569.96,425.671 573.457,423.779 572.384,421.346C571.321,418.946 565.395,416.767 565.932,414.875C566.468,412.968 568.624,412.834 572.24,412.7C575.866,412.58 580.843,413.342 581.773,408.24C582.716,403.153 582.985,400.212 577.902,399.082C572.782,397.932 569.012,397.817 568.092,394.115C567.139,390.431 566.2,389.54 567.268,388.505C568.36,387.509 570.229,386.987 573.994,386.752C577.759,386.479 582.055,386.479 583.272,385.569C584.484,384.707 584.733,382.274 586.213,381.244C587.688,380.247 593.489,379.333 593.489,379.333C593.489,379.333 600.397,382.714 606.815,387.476C612.559,391.767 617.751,398.105 617.751,398.105",
    style: {
      fill: "rgb(218,90,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path991-8",
    d: "M568.198,394.435C568.198,394.435 567.393,392.141 567.254,391.499C567.13,390.871 567.026,390.127 567.026,390.127C567.026,390.127 570.89,390.095 570.751,391.36C570.622,392.644 569.41,392.644 569.142,393.137C568.878,393.659 568.198,394.435 568.198,394.435",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path994-1",
    d: "M587.301,387.796L587.018,385.756C587.018,385.756 590.654,385.789 592.402,387.02C595.099,388.931 596.829,391.868 596.704,391.987C596.235,392.442 594.151,390.718 592.671,390.215C592.671,390.215 591.598,390.469 590.515,390.469C589.442,390.469 588.906,389.961 588.762,389.453C588.643,388.931 588.906,388.05 588.906,388.05L587.301,387.815L587.301,387.796L587.301,387.796Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path995-0",
    d: "M613.522,416.584C613.522,416.584 611.898,414.285 611.505,413.509C611.093,412.767 610.418,411.229 610.418,411.229",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path996-2",
    d: "M515.076,393.659C515.076,393.659 517.361,395.297 519.109,395.551C520.857,395.819 522.75,395.819 523.018,395.819C523.281,395.819 523.837,393.252 523.549,391.499C522.606,385.756 517.361,384.486 517.361,384.486C517.361,384.486 518.927,387.969 518.165,389.573C517.092,391.868 515.076,393.659 515.076,393.659",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path997-6",
    d: "M515.076,393.659C515.076,393.659 517.361,395.297 519.109,395.551C520.857,395.819 522.75,395.819 523.018,395.819C523.281,395.819 523.837,393.252 523.549,391.499C522.606,385.756 517.361,384.486 517.361,384.486C517.361,384.486 518.927,387.969 518.165,389.573C517.092,391.868 515.076,393.659 515.076,393.659Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path998-4",
    d: "M504.178,398.626C504.178,398.626 502.162,394.928 497.865,395.431C493.563,395.939 490.728,399.268 490.728,399.268C490.728,399.268 495.475,399.115 496.648,399.891C498.401,401.041 498.933,403.982 498.933,403.982C498.933,403.982 501.505,402.444 502.305,401.429C503.105,400.399 504.178,398.626 504.178,398.626",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path999-0",
    d: "M504.178,398.626C504.178,398.626 502.162,394.928 497.865,395.431C493.563,395.939 490.728,399.268 490.728,399.268C490.728,399.268 495.475,399.115 496.648,399.891C498.401,401.041 498.933,403.982 498.933,403.982C498.933,403.982 501.505,402.444 502.305,401.429C503.105,400.399 504.178,398.626 504.178,398.626Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1000-0",
    d: "M498.933,413.509C498.933,413.509 495.312,414.031 493.3,416.33C491.264,418.625 491.552,422.95 491.552,422.95C491.552,422.95 493.956,420.416 496.117,420.416C498.277,420.416 501.63,421.178 501.63,421.178C501.63,421.178 500.557,418.476 500.557,417.341C500.557,416.196 498.933,413.509 498.933,413.509",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1001-6",
    d: "M498.933,413.509C498.933,413.509 495.312,414.031 493.3,416.33C491.264,418.625 491.552,422.95 491.552,422.95C491.552,422.95 493.956,420.416 496.117,420.416C498.277,420.416 501.63,421.178 501.63,421.178C501.63,421.178 500.557,418.476 500.557,417.341C500.557,416.196 498.933,413.509 498.933,413.509Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1010-5",
    d: "M548.961,428.425C548.961,428.425 545.134,429.541 543.721,431.601C541.977,434.149 542.102,436.703 542.102,436.703C542.102,436.703 545.33,434.034 549.502,435.165C553.679,436.315 554.067,436.703 555.835,436.583C557.583,436.449 561.885,434.911 561.885,434.911C561.885,434.911 558.388,438.983 558.781,441.804C559.188,444.592 559.705,445.856 559.595,447.279C559.307,450.723 556.764,454.929 556.764,454.929C556.764,454.929 558.244,454.019 561.741,453.257C565.219,452.495 568.198,450.824 570.071,449.439C571.944,448.021 574.368,444.592 574.368,444.592C574.368,444.592 573.587,449.305 574.368,451.346C575.172,453.391 575.441,459.254 575.441,459.254C575.441,459.254 577.687,457.261 579.469,456.313C580.413,455.791 582.841,454.522 583.79,453.003C584.446,451.921 585.27,447.935 585.27,447.935C585.27,447.935 585.802,452.227 587.138,454.306C588.498,456.313 590.491,462.583 590.491,462.583C590.491,462.583 591.852,458.512 593.332,456.84C594.793,455.183 596.56,453.022 596.685,451.739C596.809,450.469 596.292,447.681 596.292,447.681L598.165,451.739M543.85,454.66C543.85,454.66 546.135,450.723 548.291,449.439C550.451,448.156 553.411,445.875 554.211,445.622C554.997,445.368 558.513,443.442 558.513,443.442M563.221,468.039C563.221,468.039 568.395,465.385 569.942,464.456C573.175,462.564 575.455,459.12 575.455,459.12",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1011-4",
    d: "M511.167,461.654C511.167,461.654 509.155,459.508 505.658,460.131C502.162,460.773 499.877,464.729 499.877,464.729C499.877,464.729 502.837,463.948 504.59,464.336C506.334,464.729 507.551,466.501 507.551,466.501C507.551,466.501 509.155,465.098 509.692,464.336C510.228,463.579 511.153,461.654 511.153,461.654",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1012-2",
    d: "M511.167,461.654C511.167,461.654 509.155,459.508 505.658,460.131C502.162,460.773 499.877,464.729 499.877,464.729C499.877,464.729 502.837,463.948 504.59,464.336C506.334,464.729 507.551,466.501 507.551,466.501C507.551,466.501 509.155,465.098 509.692,464.336C510.228,463.579 511.153,461.654 511.153,461.654L511.168,461.654L511.167,461.654Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1013-6",
    d: "M507.139,475.789C507.139,475.789 504.178,475.286 501.63,477.327C499.077,479.372 498.933,483.31 498.933,483.31C498.933,483.31 501.362,481.264 503.254,481.537C505.127,481.772 507.407,482.802 507.407,482.802C507.407,482.802 507.819,480.369 507.939,479.746C508.355,477.969 507.139,475.789 507.139,475.789",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1014-7",
    d: "M507.139,475.789C507.139,475.789 504.178,475.286 501.63,477.327C499.077,479.372 498.933,483.31 498.933,483.31C498.933,483.31 501.362,481.264 503.254,481.537C505.127,481.772 507.407,482.802 507.407,482.802C507.407,482.802 507.819,480.369 507.939,479.746C508.355,477.969 507.139,475.789 507.139,475.789Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1015-2",
    d: "M514.008,488.799C514.008,488.799 513.811,492.583 515.612,494.897C517.504,497.33 521.001,497.704 521.001,497.704C521.001,497.704 519.823,495.17 519.646,493.881C519.377,491.975 521.25,490.318 521.25,490.318C521.25,490.318 519.521,488.545 517.773,488.545C516.019,488.545 514.008,488.799 514.008,488.799",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1016-3",
    d: "M514.008,488.799C514.008,488.799 513.811,492.583 515.612,494.897C517.504,497.33 521.001,497.704 521.001,497.704C521.001,497.704 519.823,495.17 519.646,493.881C519.377,491.975 521.25,490.318 521.25,490.318C521.25,490.318 519.521,488.545 517.773,488.545C516.019,488.545 514.008,488.799 514.008,488.799L514.008,488.799Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1017-0",
    d: "M593.351,495.151C593.351,495.151 603.036,501.148 602.768,506.115C602.481,511.082 597.379,517.583 597.379,517.583",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1018-2",
    d: "M548.961,522.296C548.961,522.296 546.542,519.24 543.189,519.36C539.817,519.494 536.315,522.65 536.315,522.65C536.315,522.65 540.497,522.296 541.56,523.68C542.652,525.103 543.721,526.856 543.721,526.856C543.721,526.856 545.598,525.86 546.417,525.218C547.222,524.595 548.961,522.296 548.961,522.296",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1019-2",
    d: "M548.961,522.296C548.961,522.296 546.542,519.24 543.189,519.36C539.817,519.494 536.315,522.65 536.315,522.65C536.315,522.65 540.497,522.296 541.56,523.68C542.652,525.103 543.721,526.856 543.721,526.856C543.721,526.856 545.598,525.86 546.417,525.218C547.222,524.595 548.961,522.296 548.961,522.296Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1020-5",
    d: "M538.605,535.66C538.605,535.66 534.183,535.018 532.023,537.313C529.863,539.598 530.007,543.803 530.007,543.803C530.007,543.803 532.703,540.881 535.108,541.13C537.537,541.384 540.229,542.668 540.229,542.668C540.229,542.668 539.817,540.12 539.548,538.97C539.28,537.821 538.605,535.66 538.605,535.66",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1021-7",
    d: "M538.605,535.66C538.605,535.66 534.183,535.018 532.023,537.313C529.863,539.598 530.007,543.803 530.007,543.803C530.007,543.803 532.703,540.881 535.108,541.13C537.537,541.384 540.229,542.668 540.229,542.668C540.229,542.668 539.817,540.12 539.548,538.97C539.28,537.821 538.605,535.66 538.605,535.66Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1022-9",
    d: "M548.166,549.8C548.166,549.8 546.005,552.857 547.629,555.271C549.234,557.704 552.592,558.854 552.592,558.854C552.592,558.854 551.394,557.081 551.931,555.017C552.357,553.398 555.159,551.199 555.159,551.199L548.166,549.815",
    style: {
      fill: "rgb(219,68,70)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1023-6",
    d: "M548.166,549.8C548.166,549.8 546.005,552.857 547.629,555.271C549.234,557.704 552.592,558.854 552.592,558.854C552.592,558.854 551.394,557.081 551.931,555.017C552.357,553.398 555.159,551.199 555.159,551.199L548.166,549.815L548.166,549.8L548.166,549.8Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1024-3",
    d: "M607.189,555.544C607.189,555.544 603.305,554.629 601.144,555.913C599.003,557.182 597.255,562.537 597.255,562.537C597.255,562.537 600.752,559.615 603.305,559.97C605.853,560.372 607.745,561.388 607.745,561.388C607.745,561.388 608.133,559.208 607.865,557.704C607.707,556.794 607.19,555.544 607.19,555.544",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1025-6",
    d: "M607.189,555.544C607.189,555.544 603.305,554.629 601.144,555.913C599.003,557.182 597.255,562.537 597.255,562.537C597.255,562.537 600.752,559.615 603.305,559.97C605.853,560.372 607.745,561.388 607.745,561.388C607.745,561.388 608.133,559.208 607.865,557.704C607.707,556.794 607.19,555.544 607.19,555.544L607.189,555.544Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1168-2",
    d: "M614.988,377.612L613.613,377.713C613.55,377.881 612.933,378.863 612.348,379.404C611.132,380.568 609.297,380.702 608.262,379.725C607.759,379.217 607.51,378.508 607.601,377.78C606.797,378.187 605.958,378.187 605.173,377.747C603.942,377.038 603.635,375.347 604.531,373.943C604.674,373.675 604.818,373.321 605.034,373.119L604.943,371.582L603.281,371.97L602.802,372.88C601.767,374.049 600.234,374.35 599.468,373.661C599.094,373.34 599.015,373.068 598.845,372.411C598.472,372.728 598.448,372.813 598.021,372.913C595.473,373.541 594.457,367.932 594.4,366.48L593.562,367.664C593.562,367.664 594.314,371.021 593.935,373.862C593.562,376.698 592.56,379.538 592.56,379.538C596.115,380.448 601.432,383.337 606.706,387.408C611.989,391.446 616.142,395.839 617.857,398.914C617.857,398.914 620.587,397.391 623.457,396.481C626.297,395.551 629.914,395.532 629.914,395.532L630.943,394.521C629.43,394.742 623.423,394.996 623.543,392.476C623.549,392.094 623.47,392.047 624.029,391.496C623.078,391.495 622.925,391.58 622.494,391.312C621.622,390.737 621.641,389.267 622.604,388.05L623.442,387.442L623.495,385.823L621.885,386.043C621.742,386.244 621.373,386.479 621.157,386.685C619.892,387.782 618.072,387.863 617.071,386.833C616.467,386.244 616.281,385.449 616.539,384.62C615.806,384.841 615.04,384.774 614.393,384.4C613.167,383.658 612.932,381.919 613.881,380.568C614.321,379.907 615.198,379.131 615.351,379.05L615.021,377.627",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1172-1",
    d: "M608.794,384.687L607.242,383.49C606.96,383.27 606.869,382.915 607.051,382.714C607.228,382.527 607.601,382.527 607.889,382.728L609.436,383.945L611.026,385.147C611.295,385.349 611.395,385.703 611.223,385.923C611.026,386.11 610.653,386.091 610.366,385.89L608.794,384.688",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1174-0",
    d: "M600.502,379.011L599.271,378.288C598.965,378.101 598.807,377.747 598.95,377.512C599.075,377.258 599.448,377.224 599.75,377.406L600.977,378.135L602.232,378.863C602.534,379.03 602.677,379.385 602.553,379.639C602.409,379.859 602.055,379.907 601.733,379.725L600.502,379.011",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2730-1-1",
    transform: "matrix(0.822912,0.56817,-0.612003,0.790855,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.167,
    cy: -29.36,
    rx: 0.958,
    ry: 0.713,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1180-5",
    d: "M616.521,391.293L617.536,392.275C617.785,392.51 618.178,392.596 618.393,392.409C618.609,392.241 618.58,391.901 618.341,391.666L617.34,390.67L616.305,389.655C616.056,389.42 615.663,389.353 615.448,389.54C615.218,389.688 615.251,390.062 615.52,390.297L616.521,391.293",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2730-1-2-8",
    transform: "matrix(0.592514,0.80556,-0.836537,0.547911,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.97,
    cy: -266.317,
    rx: 0.958,
    ry: 0.713,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1184-6",
    d: "M607.951,366.428L605.139,366.514L604.588,370.653L604.89,371.309L605.623,371.261L609.225,368.842C608.826,368.023 608.394,367.222 607.951,366.428Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1186-3",
    d: "M600.325,368.727L600.249,371.309L604.622,371.85L605.302,371.563L605.245,370.854L602.696,367.458C601.852,367.8 601.076,368.227 600.325,368.727Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1188-2",
    d: "M609.364,373.876L607.031,375.179L604.478,371.769L604.426,371.074L605.106,370.787L609.494,371.309C609.549,372.183 609.53,373.023 609.364,373.876Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path2792-8-5",
    cx: 604.752,
    cy: 371.144,
    r: 1.47,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1192-5",
    d: "M593.475,366.413C593.403,366.428 592.862,364.234 592.259,363.017C591.852,362.136 590.405,360.991 590.405,360.991C590.548,360.718 592.369,360.062 594.544,361.427C596.306,362.883 594.4,365.551 594.4,365.551C594.4,365.551 593.936,366.193 593.49,366.413",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1194-4",
    d: "M598.39,367.898L596.397,369.623L593.15,366.801L593.432,366.394L593.547,365.7L597.949,365.379C598.136,366.213 598.275,367.053 598.39,367.898Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1196-9",
    d: "M592.839,366.428C592.864,365.677 593.331,365.088 593.853,365.084C594.382,365.108 594.783,365.71 594.768,366.443C594.743,367.194 594.27,367.765 593.755,367.787C593.201,367.766 592.811,367.165 592.839,366.428",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1198-6",
    d: "M618.729,373.167L615.927,372.866L614.753,376.904L614.969,377.593L615.701,377.612L619.624,375.701C619.328,374.856 619.031,374.011 618.729,373.167Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1200-5",
    d: "M610.825,374.417L610.385,376.971L614.629,378.082L615.342,377.881L615.395,377.191L613.378,373.455C612.51,373.732 611.669,374.076 610.825,374.417Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1202-3",
    d: "M619.035,380.702L616.521,381.698L614.504,377.981L614.556,377.272L615.27,377.086L619.514,378.202C619.399,379.045 619.235,379.881 619.035,380.702Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path2792-1",
    cx: 614.868,
    cy: 377.574,
    r: 1.47,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1206-1",
    d: "M628.132,381.904L628.644,384.553L624.491,385.938L623.758,385.789L623.672,385.095L625.402,381.258C626.316,381.457 627.223,381.682 628.132,381.904Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1208-4",
    d: "M627.384,389.487L624.726,390.076L623.255,386.124L623.423,385.449L624.156,385.348L628.203,387.006C627.933,387.834 627.66,388.661 627.384,389.487Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1210-3",
    d: "M620.175,382.153L619.318,384.606L623.37,386.244L624.113,386.144L624.256,385.468L622.815,381.531C621.934,381.736 621.055,381.945 620.175,382.153Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path2792-6-2",
    cx: 623.733,
    cy: 385.607,
    r: 1.47,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1214-4",
    d: "M631.197,395.331C631.182,395.398 633.573,395.451 634.948,395.752C635.925,395.958 637.444,397.055 637.444,397.055C637.712,396.854 637.98,395.043 636.107,393.305C634.234,391.968 631.892,394.32 631.892,394.32C631.892,394.32 631.327,394.876 631.197,395.331",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1216-2",
    d: "M628.63,391.073L627.26,393.286L630.862,395.719L631.303,395.331L631.892,395.13L631.341,390.972C630.437,391.008 629.534,391.041 628.63,391.073Z",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1218-7",
    d: "M631.308,395.936C632.053,395.801 632.575,395.265 632.457,394.78C632.327,394.27 631.624,393.974 630.877,394.114C630.126,394.267 629.615,394.771 629.74,395.295C629.853,395.779 630.562,396.076 631.308,395.936",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2660-3",
    d: "M590.056,388.64C590.056,388.64 590.333,389.064 590.273,389.282C590.223,389.465 589.84,389.651 589.84,389.651C590.693,389.95 591.138,389.735 591.479,389.524C591.415,388.991 590.991,388.839 590.624,388.674C590.451,388.597 590.056,388.64 590.056,388.64L590.056,388.64Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "path2730-8",
    transform: "matrix(0.848174,0.529718,-0.57498,0.818167,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 705.1,
    cy: 3.237,
    rx: 0.958,
    ry: 0.713,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2730-3-0",
    transform: "matrix(0.848174,0.529718,-0.57498,0.818167,0,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 715.312,
    cy: 3.039,
    rx: 0.958,
    ry: 0.713,
    style: {
      fill: "rgb(160,126,0)",
      stroke: "black",
      strokeWidth: "0.75px"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g3754-4",
    transform: "matrix(1,0,0,1,4.99985,4.99999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1152-6",
    d: "M373.353,597.502C373.353,549.443 407.976,510.486 450.679,510.486C493.397,510.486 528.02,549.443 528.02,597.502C528.02,645.561 493.397,684.518 450.679,684.518C407.976,684.518 373.353,645.561 373.353,597.502",
    style: {
      fill: "rgb(206,17,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153-6",
    d: "M373.353,597.502C373.353,549.443 407.976,510.486 450.679,510.486C493.397,510.486 528.02,549.443 528.02,597.502C528.02,645.561 493.397,684.518 450.679,684.518C407.976,684.518 373.353,645.561 373.353,597.502Z",
    style: {
      fill: "rgb(181,0,39)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1154-4",
    d: "M396.292,597.334C396.292,562.094 420.641,533.531 450.713,533.531C480.766,533.531 505.119,562.094 505.119,597.334C505.119,632.589 480.766,661.171 450.713,661.171C420.641,661.171 396.292,632.589 396.292,597.334",
    style: {
      fill: "rgb(0,91,191)",
      fillOpacity: 0.94,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1155-1",
    d: "M396.292,597.334C396.292,562.094 420.641,533.531 450.713,533.531C480.766,533.531 505.119,562.094 505.119,597.334C505.119,632.589 480.766,661.171 450.713,661.171C420.641,661.171 396.292,632.589 396.292,597.334Z",
    style: {
      fill: "rgb(0,68,173)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "2.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1156-4",
    d: "M425.009,553.41C425.009,553.41 418.547,560.489 418.547,567.042C418.547,573.633 421.278,579.103 421.278,579.103C420.3,576.502 417.661,574.63 414.557,574.63C410.634,574.63 407.439,577.638 407.439,581.369C407.439,582.452 408.1,584.138 408.598,585.067L410.917,589.747C411.683,588.022 413.489,587.06 415.592,587.06C418.404,587.06 420.693,589.206 420.693,591.878C420.693,592.281 420.641,592.688 420.535,593.057L414.734,593.077L414.734,598.011L419.908,598.011L416.056,605.646L421.158,603.653L425.009,607.993L429.004,603.653L434.091,605.646L430.254,598.011L435.428,598.011L435.428,593.077L429.612,593.057C429.507,592.688 429.488,592.281 429.488,591.878C429.488,589.206 431.734,587.06 434.551,587.06C436.654,587.06 438.46,588.022 439.24,589.747L441.54,585.067C442.043,584.138 442.704,582.452 442.704,581.369C442.704,577.638 439.528,574.63 435.586,574.63C432.482,574.63 429.861,576.502 428.879,579.103C428.879,579.103 431.591,573.633 431.591,567.042C431.591,560.489 424.995,553.41 424.995,553.41",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path1158-3",
    x: 414.734,
    y: 593.076,
    width: 20.708,
    height: 4.934,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1160-9",
    d: "M475.578,553.41C475.578,553.41 469.121,560.489 469.121,567.042C469.121,573.633 471.832,579.103 471.832,579.103C470.87,576.502 468.23,574.63 465.126,574.63C461.184,574.63 458.008,577.638 458.008,581.369C458.008,582.452 458.669,584.138 459.167,585.067L461.467,589.747C462.257,588.022 464.058,587.06 466.161,587.06C468.977,587.06 471.243,589.206 471.243,591.878C471.243,592.281 471.208,592.688 471.104,593.057L465.303,593.077L465.303,598.011L470.477,598.011L466.625,605.646L471.708,603.653L475.578,607.993L479.559,603.653L484.66,605.646L480.804,598.011L485.977,598.011L485.977,593.077L480.181,593.057C480.071,592.688 480.038,592.281 480.038,591.878C480.038,589.206 482.304,587.06 485.125,587.06C487.228,587.06 489.029,588.022 489.795,589.747L492.114,585.067C492.617,584.138 493.268,582.452 493.268,581.369C493.268,577.638 490.083,574.63 486.155,574.63C483.056,574.63 480.407,576.502 479.434,579.103C479.434,579.103 482.16,573.633 482.16,567.042C482.16,560.489 475.564,553.41 475.564,553.41",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1164-1",
    d: "M450.286,596.908C450.286,596.908 443.829,603.988 443.829,610.56C443.829,617.132 446.56,622.602 446.56,622.602C445.578,620.001 442.953,618.128 439.834,618.128C435.911,618.128 432.716,621.136 432.716,624.868C432.716,625.964 433.377,627.636 433.876,628.565L436.194,633.245C436.98,631.521 438.761,630.544 440.864,630.544C443.686,630.544 445.971,632.704 445.971,635.377C445.971,635.798 445.918,636.201 445.808,636.574L440.012,636.589L440.012,641.523L445.204,641.523L441.348,649.159L446.435,647.151L450.286,651.491L454.281,647.151L459.383,649.159L455.512,641.523L460.7,641.523L460.7,636.589L454.904,636.574C454.799,636.201 454.761,635.798 454.761,635.377C454.761,632.704 457.031,630.544 459.848,630.544C461.946,630.544 463.732,631.521 464.523,633.245L466.841,628.565C467.335,627.636 468,625.964 468,624.868C468,621.136 464.805,618.128 460.882,618.128C457.778,618.128 455.158,620.001 454.157,622.602C454.157,622.602 456.887,617.132 456.887,610.56C456.887,603.988 450.267,596.908 450.267,596.908",
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path1166-0",
    x: 440.012,
    y: 636.589,
    width: 20.708,
    height: 4.934,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path1601",
    x: 465.284,
    y: 593.076,
    width: 20.708,
    height: 4.934,
    style: {
      fill: "rgb(160,126,0)",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path731-6",
    d: "M455.905,903.768C393.672,903.768 331.99,888.511 280.133,863.138C241.908,844.203 216.563,806.026 216.563,762.341L216.563,603.92L216.257,338.604L694.285,338.604L694.304,603.92L694.304,762.341C694.304,806.026 668.959,844.203 630.73,863.138C578.877,888.511 518.157,903.768 455.905,903.768L455.905,903.768Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 4
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaDeEspana2);
export default __webpack_public_path__ + "static/media/Bandera_de_España2.58afd5b2fb983483277ba39197c803ec.svg";
export { ForwardRef as ReactComponent };